export const m_0 = `
  .m-0 {
    margin: 0px !important;
  }
`;
    
export const m_1 = `
  .m-1 {
    margin: 8px !important;
  }
`;
    
export const m_2 = `
  .m-2 {
    margin: 16px !important;
  }
`;
    
export const m_3 = `
  .m-3 {
    margin: 24px !important;
  }
`;
    
export const m_4 = `
  .m-4 {
    margin: 32px !important;
  }
`;
    
export const m_5 = `
  .m-5 {
    margin: 40px !important;
  }
`;
    
export const m_6 = `
  .m-6 {
    margin: 48px !important;
  }
`;
    
export const m_7 = `
  .m-7 {
    margin: 56px !important;
  }
`;
    
export const m_8 = `
  .m-8 {
    margin: 64px !important;
  }
`;
    
export const m__1 = `
  .m--1 {
    margin: -8px !important;
  }
`;
    
export const m__2 = `
  .m--2 {
    margin: -16px !important;
  }
`;
    
export const m__3 = `
  .m--3 {
    margin: -24px !important;
  }
`;
    
export const m__4 = `
  .m--4 {
    margin: -32px !important;
  }
`;
    
export const m__5 = `
  .m--5 {
    margin: -40px !important;
  }
`;
    
export const m__6 = `
  .m--6 {
    margin: -48px !important;
  }
`;
    
export const m__7 = `
  .m--7 {
    margin: -56px !important;
  }
`;
    
export const m__8 = `
  .m--8 {
    margin: -64px !important;
  }
`;
    
export const m_auto = `
  .m-auto {
    margin: auto !important;
  }
`;
    
export const m_lg_0 = `
  @media (min-width: 992px) {
    .m-lg-0 {
      margin: 0px !important;
    }
  }
`;
    
export const m_lg_1 = `
  @media (min-width: 992px) {
    .m-lg-1 {
      margin: 8px !important;
    }
  }
`;
    
export const m_lg_2 = `
  @media (min-width: 992px) {
    .m-lg-2 {
      margin: 16px !important;
    }
  }
`;
    
export const m_lg_3 = `
  @media (min-width: 992px) {
    .m-lg-3 {
      margin: 24px !important;
    }
  }
`;
    
export const m_lg_4 = `
  @media (min-width: 992px) {
    .m-lg-4 {
      margin: 32px !important;
    }
  }
`;
    
export const m_lg_5 = `
  @media (min-width: 992px) {
    .m-lg-5 {
      margin: 40px !important;
    }
  }
`;
    
export const m_lg_6 = `
  @media (min-width: 992px) {
    .m-lg-6 {
      margin: 48px !important;
    }
  }
`;
    
export const m_lg_7 = `
  @media (min-width: 992px) {
    .m-lg-7 {
      margin: 56px !important;
    }
  }
`;
    
export const m_lg_8 = `
  @media (min-width: 992px) {
    .m-lg-8 {
      margin: 64px !important;
    }
  }
`;
    
export const m_lg__1 = `
  @media (min-width: 992px) {
    .m-lg--1 {
      margin: -8px !important;
    }
  }
`;
    
export const m_lg__2 = `
  @media (min-width: 992px) {
    .m-lg--2 {
      margin: -16px !important;
    }
  }
`;
    
export const m_lg__3 = `
  @media (min-width: 992px) {
    .m-lg--3 {
      margin: -24px !important;
    }
  }
`;
    
export const m_lg__4 = `
  @media (min-width: 992px) {
    .m-lg--4 {
      margin: -32px !important;
    }
  }
`;
    
export const m_lg__5 = `
  @media (min-width: 992px) {
    .m-lg--5 {
      margin: -40px !important;
    }
  }
`;
    
export const m_lg__6 = `
  @media (min-width: 992px) {
    .m-lg--6 {
      margin: -48px !important;
    }
  }
`;
    
export const m_lg__7 = `
  @media (min-width: 992px) {
    .m-lg--7 {
      margin: -56px !important;
    }
  }
`;
    
export const m_lg__8 = `
  @media (min-width: 992px) {
    .m-lg--8 {
      margin: -64px !important;
    }
  }
`;
    
export const m_lg_auto = `
  @media (min-width: 992px) {
    .m-lg-auto {
      margin: auto !important;
    }
  }
`;
    
export const m_md_0 = `
  @media (min-width: 768px) {
    .m-md-0 {
      margin: 0px !important;
    }
  }
`;
    
export const m_md_1 = `
  @media (min-width: 768px) {
    .m-md-1 {
      margin: 8px !important;
    }
  }
`;
    
export const m_md_2 = `
  @media (min-width: 768px) {
    .m-md-2 {
      margin: 16px !important;
    }
  }
`;
    
export const m_md_3 = `
  @media (min-width: 768px) {
    .m-md-3 {
      margin: 24px !important;
    }
  }
`;
    
export const m_md_4 = `
  @media (min-width: 768px) {
    .m-md-4 {
      margin: 32px !important;
    }
  }
`;
    
export const m_md_5 = `
  @media (min-width: 768px) {
    .m-md-5 {
      margin: 40px !important;
    }
  }
`;
    
export const m_md_6 = `
  @media (min-width: 768px) {
    .m-md-6 {
      margin: 48px !important;
    }
  }
`;
    
export const m_md_7 = `
  @media (min-width: 768px) {
    .m-md-7 {
      margin: 56px !important;
    }
  }
`;
    
export const m_md_8 = `
  @media (min-width: 768px) {
    .m-md-8 {
      margin: 64px !important;
    }
  }
`;
    
export const m_md__1 = `
  @media (min-width: 768px) {
    .m-md--1 {
      margin: -8px !important;
    }
  }
`;
    
export const m_md__2 = `
  @media (min-width: 768px) {
    .m-md--2 {
      margin: -16px !important;
    }
  }
`;
    
export const m_md__3 = `
  @media (min-width: 768px) {
    .m-md--3 {
      margin: -24px !important;
    }
  }
`;
    
export const m_md__4 = `
  @media (min-width: 768px) {
    .m-md--4 {
      margin: -32px !important;
    }
  }
`;
    
export const m_md__5 = `
  @media (min-width: 768px) {
    .m-md--5 {
      margin: -40px !important;
    }
  }
`;
    
export const m_md__6 = `
  @media (min-width: 768px) {
    .m-md--6 {
      margin: -48px !important;
    }
  }
`;
    
export const m_md__7 = `
  @media (min-width: 768px) {
    .m-md--7 {
      margin: -56px !important;
    }
  }
`;
    
export const m_md__8 = `
  @media (min-width: 768px) {
    .m-md--8 {
      margin: -64px !important;
    }
  }
`;
    
export const m_md_auto = `
  @media (min-width: 768px) {
    .m-md-auto {
      margin: auto !important;
    }
  }
`;
    
export const m_sm_0 = `
  @media (min-width: 576px) {
    .m-sm-0 {
      margin: 0px !important;
    }
  }
`;
    
export const m_sm_1 = `
  @media (min-width: 576px) {
    .m-sm-1 {
      margin: 8px !important;
    }
  }
`;
    
export const m_sm_2 = `
  @media (min-width: 576px) {
    .m-sm-2 {
      margin: 16px !important;
    }
  }
`;
    
export const m_sm_3 = `
  @media (min-width: 576px) {
    .m-sm-3 {
      margin: 24px !important;
    }
  }
`;
    
export const m_sm_4 = `
  @media (min-width: 576px) {
    .m-sm-4 {
      margin: 32px !important;
    }
  }
`;
    
export const m_sm_5 = `
  @media (min-width: 576px) {
    .m-sm-5 {
      margin: 40px !important;
    }
  }
`;
    
export const m_sm_6 = `
  @media (min-width: 576px) {
    .m-sm-6 {
      margin: 48px !important;
    }
  }
`;
    
export const m_sm_7 = `
  @media (min-width: 576px) {
    .m-sm-7 {
      margin: 56px !important;
    }
  }
`;
    
export const m_sm_8 = `
  @media (min-width: 576px) {
    .m-sm-8 {
      margin: 64px !important;
    }
  }
`;
    
export const m_sm__1 = `
  @media (min-width: 576px) {
    .m-sm--1 {
      margin: -8px !important;
    }
  }
`;
    
export const m_sm__2 = `
  @media (min-width: 576px) {
    .m-sm--2 {
      margin: -16px !important;
    }
  }
`;
    
export const m_sm__3 = `
  @media (min-width: 576px) {
    .m-sm--3 {
      margin: -24px !important;
    }
  }
`;
    
export const m_sm__4 = `
  @media (min-width: 576px) {
    .m-sm--4 {
      margin: -32px !important;
    }
  }
`;
    
export const m_sm__5 = `
  @media (min-width: 576px) {
    .m-sm--5 {
      margin: -40px !important;
    }
  }
`;
    
export const m_sm__6 = `
  @media (min-width: 576px) {
    .m-sm--6 {
      margin: -48px !important;
    }
  }
`;
    
export const m_sm__7 = `
  @media (min-width: 576px) {
    .m-sm--7 {
      margin: -56px !important;
    }
  }
`;
    
export const m_sm__8 = `
  @media (min-width: 576px) {
    .m-sm--8 {
      margin: -64px !important;
    }
  }
`;
    
export const m_sm_auto = `
  @media (min-width: 576px) {
    .m-sm-auto {
      margin: auto !important;
    }
  }
`;
    
export const m_xl_0 = `
  @media (min-width: 1320px) {
    .m-xl-0 {
      margin: 0px !important;
    }
  }
`;
    
export const m_xl_1 = `
  @media (min-width: 1320px) {
    .m-xl-1 {
      margin: 8px !important;
    }
  }
`;
    
export const m_xl_2 = `
  @media (min-width: 1320px) {
    .m-xl-2 {
      margin: 16px !important;
    }
  }
`;
    
export const m_xl_3 = `
  @media (min-width: 1320px) {
    .m-xl-3 {
      margin: 24px !important;
    }
  }
`;
    
export const m_xl_4 = `
  @media (min-width: 1320px) {
    .m-xl-4 {
      margin: 32px !important;
    }
  }
`;
    
export const m_xl_5 = `
  @media (min-width: 1320px) {
    .m-xl-5 {
      margin: 40px !important;
    }
  }
`;
    
export const m_xl_6 = `
  @media (min-width: 1320px) {
    .m-xl-6 {
      margin: 48px !important;
    }
  }
`;
    
export const m_xl_7 = `
  @media (min-width: 1320px) {
    .m-xl-7 {
      margin: 56px !important;
    }
  }
`;
    
export const m_xl_8 = `
  @media (min-width: 1320px) {
    .m-xl-8 {
      margin: 64px !important;
    }
  }
`;
    
export const m_xl__1 = `
  @media (min-width: 1320px) {
    .m-xl--1 {
      margin: -8px !important;
    }
  }
`;
    
export const m_xl__2 = `
  @media (min-width: 1320px) {
    .m-xl--2 {
      margin: -16px !important;
    }
  }
`;
    
export const m_xl__3 = `
  @media (min-width: 1320px) {
    .m-xl--3 {
      margin: -24px !important;
    }
  }
`;
    
export const m_xl__4 = `
  @media (min-width: 1320px) {
    .m-xl--4 {
      margin: -32px !important;
    }
  }
`;
    
export const m_xl__5 = `
  @media (min-width: 1320px) {
    .m-xl--5 {
      margin: -40px !important;
    }
  }
`;
    
export const m_xl__6 = `
  @media (min-width: 1320px) {
    .m-xl--6 {
      margin: -48px !important;
    }
  }
`;
    
export const m_xl__7 = `
  @media (min-width: 1320px) {
    .m-xl--7 {
      margin: -56px !important;
    }
  }
`;
    
export const m_xl__8 = `
  @media (min-width: 1320px) {
    .m-xl--8 {
      margin: -64px !important;
    }
  }
`;
    
export const m_xl_auto = `
  @media (min-width: 1320px) {
    .m-xl-auto {
      margin: auto !important;
    }
  }
`;
    
export const mb_0 = `
  .mb-0 {
    margin-bottom: 0px !important;
  }
`;
    
export const mb_1 = `
  .mb-1 {
    margin-bottom: 8px !important;
  }
`;
    
export const mb_2 = `
  .mb-2 {
    margin-bottom: 16px !important;
  }
`;
    
export const mb_3 = `
  .mb-3 {
    margin-bottom: 24px !important;
  }
`;
    
export const mb_4 = `
  .mb-4 {
    margin-bottom: 32px !important;
  }
`;
    
export const mb_5 = `
  .mb-5 {
    margin-bottom: 40px !important;
  }
`;
    
export const mb_6 = `
  .mb-6 {
    margin-bottom: 48px !important;
  }
`;
    
export const mb_7 = `
  .mb-7 {
    margin-bottom: 56px !important;
  }
`;
    
export const mb_8 = `
  .mb-8 {
    margin-bottom: 64px !important;
  }
`;
    
export const mb__1 = `
  .mb--1 {
    margin-bottom: -8px !important;
  }
`;
    
export const mb__2 = `
  .mb--2 {
    margin-bottom: -16px !important;
  }
`;
    
export const mb__3 = `
  .mb--3 {
    margin-bottom: -24px !important;
  }
`;
    
export const mb__4 = `
  .mb--4 {
    margin-bottom: -32px !important;
  }
`;
    
export const mb__5 = `
  .mb--5 {
    margin-bottom: -40px !important;
  }
`;
    
export const mb__6 = `
  .mb--6 {
    margin-bottom: -48px !important;
  }
`;
    
export const mb__7 = `
  .mb--7 {
    margin-bottom: -56px !important;
  }
`;
    
export const mb__8 = `
  .mb--8 {
    margin-bottom: -64px !important;
  }
`;
    
export const mb_auto = `
  .mb-auto {
    margin-bottom: auto !important;
  }
`;
    
export const mb_lg_0 = `
  @media (min-width: 992px) {
    .mb-lg-0 {
      margin-bottom: 0px !important;
    }
  }
`;
    
export const mb_lg_1 = `
  @media (min-width: 992px) {
    .mb-lg-1 {
      margin-bottom: 8px !important;
    }
  }
`;
    
export const mb_lg_2 = `
  @media (min-width: 992px) {
    .mb-lg-2 {
      margin-bottom: 16px !important;
    }
  }
`;
    
export const mb_lg_3 = `
  @media (min-width: 992px) {
    .mb-lg-3 {
      margin-bottom: 24px !important;
    }
  }
`;
    
export const mb_lg_4 = `
  @media (min-width: 992px) {
    .mb-lg-4 {
      margin-bottom: 32px !important;
    }
  }
`;
    
export const mb_lg_5 = `
  @media (min-width: 992px) {
    .mb-lg-5 {
      margin-bottom: 40px !important;
    }
  }
`;
    
export const mb_lg_6 = `
  @media (min-width: 992px) {
    .mb-lg-6 {
      margin-bottom: 48px !important;
    }
  }
`;
    
export const mb_lg_7 = `
  @media (min-width: 992px) {
    .mb-lg-7 {
      margin-bottom: 56px !important;
    }
  }
`;
    
export const mb_lg_8 = `
  @media (min-width: 992px) {
    .mb-lg-8 {
      margin-bottom: 64px !important;
    }
  }
`;
    
export const mb_lg__1 = `
  @media (min-width: 992px) {
    .mb-lg--1 {
      margin-bottom: -8px !important;
    }
  }
`;
    
export const mb_lg__2 = `
  @media (min-width: 992px) {
    .mb-lg--2 {
      margin-bottom: -16px !important;
    }
  }
`;
    
export const mb_lg__3 = `
  @media (min-width: 992px) {
    .mb-lg--3 {
      margin-bottom: -24px !important;
    }
  }
`;
    
export const mb_lg__4 = `
  @media (min-width: 992px) {
    .mb-lg--4 {
      margin-bottom: -32px !important;
    }
  }
`;
    
export const mb_lg__5 = `
  @media (min-width: 992px) {
    .mb-lg--5 {
      margin-bottom: -40px !important;
    }
  }
`;
    
export const mb_lg__6 = `
  @media (min-width: 992px) {
    .mb-lg--6 {
      margin-bottom: -48px !important;
    }
  }
`;
    
export const mb_lg__7 = `
  @media (min-width: 992px) {
    .mb-lg--7 {
      margin-bottom: -56px !important;
    }
  }
`;
    
export const mb_lg__8 = `
  @media (min-width: 992px) {
    .mb-lg--8 {
      margin-bottom: -64px !important;
    }
  }
`;
    
export const mb_lg_auto = `
  @media (min-width: 992px) {
    .mb-lg-auto {
      margin-bottom: auto !important;
    }
  }
`;
    
export const mb_md_0 = `
  @media (min-width: 768px) {
    .mb-md-0 {
      margin-bottom: 0px !important;
    }
  }
`;
    
export const mb_md_1 = `
  @media (min-width: 768px) {
    .mb-md-1 {
      margin-bottom: 8px !important;
    }
  }
`;
    
export const mb_md_2 = `
  @media (min-width: 768px) {
    .mb-md-2 {
      margin-bottom: 16px !important;
    }
  }
`;
    
export const mb_md_3 = `
  @media (min-width: 768px) {
    .mb-md-3 {
      margin-bottom: 24px !important;
    }
  }
`;
    
export const mb_md_4 = `
  @media (min-width: 768px) {
    .mb-md-4 {
      margin-bottom: 32px !important;
    }
  }
`;
    
export const mb_md_5 = `
  @media (min-width: 768px) {
    .mb-md-5 {
      margin-bottom: 40px !important;
    }
  }
`;
    
export const mb_md_6 = `
  @media (min-width: 768px) {
    .mb-md-6 {
      margin-bottom: 48px !important;
    }
  }
`;
    
export const mb_md_7 = `
  @media (min-width: 768px) {
    .mb-md-7 {
      margin-bottom: 56px !important;
    }
  }
`;
    
export const mb_md_8 = `
  @media (min-width: 768px) {
    .mb-md-8 {
      margin-bottom: 64px !important;
    }
  }
`;
    
export const mb_md__1 = `
  @media (min-width: 768px) {
    .mb-md--1 {
      margin-bottom: -8px !important;
    }
  }
`;
    
export const mb_md__2 = `
  @media (min-width: 768px) {
    .mb-md--2 {
      margin-bottom: -16px !important;
    }
  }
`;
    
export const mb_md__3 = `
  @media (min-width: 768px) {
    .mb-md--3 {
      margin-bottom: -24px !important;
    }
  }
`;
    
export const mb_md__4 = `
  @media (min-width: 768px) {
    .mb-md--4 {
      margin-bottom: -32px !important;
    }
  }
`;
    
export const mb_md__5 = `
  @media (min-width: 768px) {
    .mb-md--5 {
      margin-bottom: -40px !important;
    }
  }
`;
    
export const mb_md__6 = `
  @media (min-width: 768px) {
    .mb-md--6 {
      margin-bottom: -48px !important;
    }
  }
`;
    
export const mb_md__7 = `
  @media (min-width: 768px) {
    .mb-md--7 {
      margin-bottom: -56px !important;
    }
  }
`;
    
export const mb_md__8 = `
  @media (min-width: 768px) {
    .mb-md--8 {
      margin-bottom: -64px !important;
    }
  }
`;
    
export const mb_md_auto = `
  @media (min-width: 768px) {
    .mb-md-auto {
      margin-bottom: auto !important;
    }
  }
`;
    
export const mb_sm_0 = `
  @media (min-width: 576px) {
    .mb-sm-0 {
      margin-bottom: 0px !important;
    }
  }
`;
    
export const mb_sm_1 = `
  @media (min-width: 576px) {
    .mb-sm-1 {
      margin-bottom: 8px !important;
    }
  }
`;
    
export const mb_sm_2 = `
  @media (min-width: 576px) {
    .mb-sm-2 {
      margin-bottom: 16px !important;
    }
  }
`;
    
export const mb_sm_3 = `
  @media (min-width: 576px) {
    .mb-sm-3 {
      margin-bottom: 24px !important;
    }
  }
`;
    
export const mb_sm_4 = `
  @media (min-width: 576px) {
    .mb-sm-4 {
      margin-bottom: 32px !important;
    }
  }
`;
    
export const mb_sm_5 = `
  @media (min-width: 576px) {
    .mb-sm-5 {
      margin-bottom: 40px !important;
    }
  }
`;
    
export const mb_sm_6 = `
  @media (min-width: 576px) {
    .mb-sm-6 {
      margin-bottom: 48px !important;
    }
  }
`;
    
export const mb_sm_7 = `
  @media (min-width: 576px) {
    .mb-sm-7 {
      margin-bottom: 56px !important;
    }
  }
`;
    
export const mb_sm_8 = `
  @media (min-width: 576px) {
    .mb-sm-8 {
      margin-bottom: 64px !important;
    }
  }
`;
    
export const mb_sm__1 = `
  @media (min-width: 576px) {
    .mb-sm--1 {
      margin-bottom: -8px !important;
    }
  }
`;
    
export const mb_sm__2 = `
  @media (min-width: 576px) {
    .mb-sm--2 {
      margin-bottom: -16px !important;
    }
  }
`;
    
export const mb_sm__3 = `
  @media (min-width: 576px) {
    .mb-sm--3 {
      margin-bottom: -24px !important;
    }
  }
`;
    
export const mb_sm__4 = `
  @media (min-width: 576px) {
    .mb-sm--4 {
      margin-bottom: -32px !important;
    }
  }
`;
    
export const mb_sm__5 = `
  @media (min-width: 576px) {
    .mb-sm--5 {
      margin-bottom: -40px !important;
    }
  }
`;
    
export const mb_sm__6 = `
  @media (min-width: 576px) {
    .mb-sm--6 {
      margin-bottom: -48px !important;
    }
  }
`;
    
export const mb_sm__7 = `
  @media (min-width: 576px) {
    .mb-sm--7 {
      margin-bottom: -56px !important;
    }
  }
`;
    
export const mb_sm__8 = `
  @media (min-width: 576px) {
    .mb-sm--8 {
      margin-bottom: -64px !important;
    }
  }
`;
    
export const mb_sm_auto = `
  @media (min-width: 576px) {
    .mb-sm-auto {
      margin-bottom: auto !important;
    }
  }
`;
    
export const mb_xl_0 = `
  @media (min-width: 1320px) {
    .mb-xl-0 {
      margin-bottom: 0px !important;
    }
  }
`;
    
export const mb_xl_1 = `
  @media (min-width: 1320px) {
    .mb-xl-1 {
      margin-bottom: 8px !important;
    }
  }
`;
    
export const mb_xl_2 = `
  @media (min-width: 1320px) {
    .mb-xl-2 {
      margin-bottom: 16px !important;
    }
  }
`;
    
export const mb_xl_3 = `
  @media (min-width: 1320px) {
    .mb-xl-3 {
      margin-bottom: 24px !important;
    }
  }
`;
    
export const mb_xl_4 = `
  @media (min-width: 1320px) {
    .mb-xl-4 {
      margin-bottom: 32px !important;
    }
  }
`;
    
export const mb_xl_5 = `
  @media (min-width: 1320px) {
    .mb-xl-5 {
      margin-bottom: 40px !important;
    }
  }
`;
    
export const mb_xl_6 = `
  @media (min-width: 1320px) {
    .mb-xl-6 {
      margin-bottom: 48px !important;
    }
  }
`;
    
export const mb_xl_7 = `
  @media (min-width: 1320px) {
    .mb-xl-7 {
      margin-bottom: 56px !important;
    }
  }
`;
    
export const mb_xl_8 = `
  @media (min-width: 1320px) {
    .mb-xl-8 {
      margin-bottom: 64px !important;
    }
  }
`;
    
export const mb_xl__1 = `
  @media (min-width: 1320px) {
    .mb-xl--1 {
      margin-bottom: -8px !important;
    }
  }
`;
    
export const mb_xl__2 = `
  @media (min-width: 1320px) {
    .mb-xl--2 {
      margin-bottom: -16px !important;
    }
  }
`;
    
export const mb_xl__3 = `
  @media (min-width: 1320px) {
    .mb-xl--3 {
      margin-bottom: -24px !important;
    }
  }
`;
    
export const mb_xl__4 = `
  @media (min-width: 1320px) {
    .mb-xl--4 {
      margin-bottom: -32px !important;
    }
  }
`;
    
export const mb_xl__5 = `
  @media (min-width: 1320px) {
    .mb-xl--5 {
      margin-bottom: -40px !important;
    }
  }
`;
    
export const mb_xl__6 = `
  @media (min-width: 1320px) {
    .mb-xl--6 {
      margin-bottom: -48px !important;
    }
  }
`;
    
export const mb_xl__7 = `
  @media (min-width: 1320px) {
    .mb-xl--7 {
      margin-bottom: -56px !important;
    }
  }
`;
    
export const mb_xl__8 = `
  @media (min-width: 1320px) {
    .mb-xl--8 {
      margin-bottom: -64px !important;
    }
  }
`;
    
export const mb_xl_auto = `
  @media (min-width: 1320px) {
    .mb-xl-auto {
      margin-bottom: auto !important;
    }
  }
`;
    
export const ml_0 = `
  .ml-0 {
    margin-left: 0px !important;
  }
`;
    
export const ml_1 = `
  .ml-1 {
    margin-left: 8px !important;
  }
`;
    
export const ml_2 = `
  .ml-2 {
    margin-left: 16px !important;
  }
`;
    
export const ml_3 = `
  .ml-3 {
    margin-left: 24px !important;
  }
`;
    
export const ml_4 = `
  .ml-4 {
    margin-left: 32px !important;
  }
`;
    
export const ml_5 = `
  .ml-5 {
    margin-left: 40px !important;
  }
`;
    
export const ml_6 = `
  .ml-6 {
    margin-left: 48px !important;
  }
`;
    
export const ml_7 = `
  .ml-7 {
    margin-left: 56px !important;
  }
`;
    
export const ml_8 = `
  .ml-8 {
    margin-left: 64px !important;
  }
`;
    
export const ml__1 = `
  .ml--1 {
    margin-left: -8px !important;
  }
`;
    
export const ml__2 = `
  .ml--2 {
    margin-left: -16px !important;
  }
`;
    
export const ml__3 = `
  .ml--3 {
    margin-left: -24px !important;
  }
`;
    
export const ml__4 = `
  .ml--4 {
    margin-left: -32px !important;
  }
`;
    
export const ml__5 = `
  .ml--5 {
    margin-left: -40px !important;
  }
`;
    
export const ml__6 = `
  .ml--6 {
    margin-left: -48px !important;
  }
`;
    
export const ml__7 = `
  .ml--7 {
    margin-left: -56px !important;
  }
`;
    
export const ml__8 = `
  .ml--8 {
    margin-left: -64px !important;
  }
`;
    
export const ml_auto = `
  .ml-auto {
    margin-left: auto !important;
  }
`;
    
export const ml_lg_0 = `
  @media (min-width: 992px) {
    .ml-lg-0 {
      margin-left: 0px !important;
    }
  }
`;
    
export const ml_lg_1 = `
  @media (min-width: 992px) {
    .ml-lg-1 {
      margin-left: 8px !important;
    }
  }
`;
    
export const ml_lg_2 = `
  @media (min-width: 992px) {
    .ml-lg-2 {
      margin-left: 16px !important;
    }
  }
`;
    
export const ml_lg_3 = `
  @media (min-width: 992px) {
    .ml-lg-3 {
      margin-left: 24px !important;
    }
  }
`;
    
export const ml_lg_4 = `
  @media (min-width: 992px) {
    .ml-lg-4 {
      margin-left: 32px !important;
    }
  }
`;
    
export const ml_lg_5 = `
  @media (min-width: 992px) {
    .ml-lg-5 {
      margin-left: 40px !important;
    }
  }
`;
    
export const ml_lg_6 = `
  @media (min-width: 992px) {
    .ml-lg-6 {
      margin-left: 48px !important;
    }
  }
`;
    
export const ml_lg_7 = `
  @media (min-width: 992px) {
    .ml-lg-7 {
      margin-left: 56px !important;
    }
  }
`;
    
export const ml_lg_8 = `
  @media (min-width: 992px) {
    .ml-lg-8 {
      margin-left: 64px !important;
    }
  }
`;
    
export const ml_lg__1 = `
  @media (min-width: 992px) {
    .ml-lg--1 {
      margin-left: -8px !important;
    }
  }
`;
    
export const ml_lg__2 = `
  @media (min-width: 992px) {
    .ml-lg--2 {
      margin-left: -16px !important;
    }
  }
`;
    
export const ml_lg__3 = `
  @media (min-width: 992px) {
    .ml-lg--3 {
      margin-left: -24px !important;
    }
  }
`;
    
export const ml_lg__4 = `
  @media (min-width: 992px) {
    .ml-lg--4 {
      margin-left: -32px !important;
    }
  }
`;
    
export const ml_lg__5 = `
  @media (min-width: 992px) {
    .ml-lg--5 {
      margin-left: -40px !important;
    }
  }
`;
    
export const ml_lg__6 = `
  @media (min-width: 992px) {
    .ml-lg--6 {
      margin-left: -48px !important;
    }
  }
`;
    
export const ml_lg__7 = `
  @media (min-width: 992px) {
    .ml-lg--7 {
      margin-left: -56px !important;
    }
  }
`;
    
export const ml_lg__8 = `
  @media (min-width: 992px) {
    .ml-lg--8 {
      margin-left: -64px !important;
    }
  }
`;
    
export const ml_lg_auto = `
  @media (min-width: 992px) {
    .ml-lg-auto {
      margin-left: auto !important;
    }
  }
`;
    
export const ml_md_0 = `
  @media (min-width: 768px) {
    .ml-md-0 {
      margin-left: 0px !important;
    }
  }
`;
    
export const ml_md_1 = `
  @media (min-width: 768px) {
    .ml-md-1 {
      margin-left: 8px !important;
    }
  }
`;
    
export const ml_md_2 = `
  @media (min-width: 768px) {
    .ml-md-2 {
      margin-left: 16px !important;
    }
  }
`;
    
export const ml_md_3 = `
  @media (min-width: 768px) {
    .ml-md-3 {
      margin-left: 24px !important;
    }
  }
`;
    
export const ml_md_4 = `
  @media (min-width: 768px) {
    .ml-md-4 {
      margin-left: 32px !important;
    }
  }
`;
    
export const ml_md_5 = `
  @media (min-width: 768px) {
    .ml-md-5 {
      margin-left: 40px !important;
    }
  }
`;
    
export const ml_md_6 = `
  @media (min-width: 768px) {
    .ml-md-6 {
      margin-left: 48px !important;
    }
  }
`;
    
export const ml_md_7 = `
  @media (min-width: 768px) {
    .ml-md-7 {
      margin-left: 56px !important;
    }
  }
`;
    
export const ml_md_8 = `
  @media (min-width: 768px) {
    .ml-md-8 {
      margin-left: 64px !important;
    }
  }
`;
    
export const ml_md__1 = `
  @media (min-width: 768px) {
    .ml-md--1 {
      margin-left: -8px !important;
    }
  }
`;
    
export const ml_md__2 = `
  @media (min-width: 768px) {
    .ml-md--2 {
      margin-left: -16px !important;
    }
  }
`;
    
export const ml_md__3 = `
  @media (min-width: 768px) {
    .ml-md--3 {
      margin-left: -24px !important;
    }
  }
`;
    
export const ml_md__4 = `
  @media (min-width: 768px) {
    .ml-md--4 {
      margin-left: -32px !important;
    }
  }
`;
    
export const ml_md__5 = `
  @media (min-width: 768px) {
    .ml-md--5 {
      margin-left: -40px !important;
    }
  }
`;
    
export const ml_md__6 = `
  @media (min-width: 768px) {
    .ml-md--6 {
      margin-left: -48px !important;
    }
  }
`;
    
export const ml_md__7 = `
  @media (min-width: 768px) {
    .ml-md--7 {
      margin-left: -56px !important;
    }
  }
`;
    
export const ml_md__8 = `
  @media (min-width: 768px) {
    .ml-md--8 {
      margin-left: -64px !important;
    }
  }
`;
    
export const ml_md_auto = `
  @media (min-width: 768px) {
    .ml-md-auto {
      margin-left: auto !important;
    }
  }
`;
    
export const ml_sm_0 = `
  @media (min-width: 576px) {
    .ml-sm-0 {
      margin-left: 0px !important;
    }
  }
`;
    
export const ml_sm_1 = `
  @media (min-width: 576px) {
    .ml-sm-1 {
      margin-left: 8px !important;
    }
  }
`;
    
export const ml_sm_2 = `
  @media (min-width: 576px) {
    .ml-sm-2 {
      margin-left: 16px !important;
    }
  }
`;
    
export const ml_sm_3 = `
  @media (min-width: 576px) {
    .ml-sm-3 {
      margin-left: 24px !important;
    }
  }
`;
    
export const ml_sm_4 = `
  @media (min-width: 576px) {
    .ml-sm-4 {
      margin-left: 32px !important;
    }
  }
`;
    
export const ml_sm_5 = `
  @media (min-width: 576px) {
    .ml-sm-5 {
      margin-left: 40px !important;
    }
  }
`;
    
export const ml_sm_6 = `
  @media (min-width: 576px) {
    .ml-sm-6 {
      margin-left: 48px !important;
    }
  }
`;
    
export const ml_sm_7 = `
  @media (min-width: 576px) {
    .ml-sm-7 {
      margin-left: 56px !important;
    }
  }
`;
    
export const ml_sm_8 = `
  @media (min-width: 576px) {
    .ml-sm-8 {
      margin-left: 64px !important;
    }
  }
`;
    
export const ml_sm__1 = `
  @media (min-width: 576px) {
    .ml-sm--1 {
      margin-left: -8px !important;
    }
  }
`;
    
export const ml_sm__2 = `
  @media (min-width: 576px) {
    .ml-sm--2 {
      margin-left: -16px !important;
    }
  }
`;
    
export const ml_sm__3 = `
  @media (min-width: 576px) {
    .ml-sm--3 {
      margin-left: -24px !important;
    }
  }
`;
    
export const ml_sm__4 = `
  @media (min-width: 576px) {
    .ml-sm--4 {
      margin-left: -32px !important;
    }
  }
`;
    
export const ml_sm__5 = `
  @media (min-width: 576px) {
    .ml-sm--5 {
      margin-left: -40px !important;
    }
  }
`;
    
export const ml_sm__6 = `
  @media (min-width: 576px) {
    .ml-sm--6 {
      margin-left: -48px !important;
    }
  }
`;
    
export const ml_sm__7 = `
  @media (min-width: 576px) {
    .ml-sm--7 {
      margin-left: -56px !important;
    }
  }
`;
    
export const ml_sm__8 = `
  @media (min-width: 576px) {
    .ml-sm--8 {
      margin-left: -64px !important;
    }
  }
`;
    
export const ml_sm_auto = `
  @media (min-width: 576px) {
    .ml-sm-auto {
      margin-left: auto !important;
    }
  }
`;
    
export const ml_xl_0 = `
  @media (min-width: 1320px) {
    .ml-xl-0 {
      margin-left: 0px !important;
    }
  }
`;
    
export const ml_xl_1 = `
  @media (min-width: 1320px) {
    .ml-xl-1 {
      margin-left: 8px !important;
    }
  }
`;
    
export const ml_xl_2 = `
  @media (min-width: 1320px) {
    .ml-xl-2 {
      margin-left: 16px !important;
    }
  }
`;
    
export const ml_xl_3 = `
  @media (min-width: 1320px) {
    .ml-xl-3 {
      margin-left: 24px !important;
    }
  }
`;
    
export const ml_xl_4 = `
  @media (min-width: 1320px) {
    .ml-xl-4 {
      margin-left: 32px !important;
    }
  }
`;
    
export const ml_xl_5 = `
  @media (min-width: 1320px) {
    .ml-xl-5 {
      margin-left: 40px !important;
    }
  }
`;
    
export const ml_xl_6 = `
  @media (min-width: 1320px) {
    .ml-xl-6 {
      margin-left: 48px !important;
    }
  }
`;
    
export const ml_xl_7 = `
  @media (min-width: 1320px) {
    .ml-xl-7 {
      margin-left: 56px !important;
    }
  }
`;
    
export const ml_xl_8 = `
  @media (min-width: 1320px) {
    .ml-xl-8 {
      margin-left: 64px !important;
    }
  }
`;
    
export const ml_xl__1 = `
  @media (min-width: 1320px) {
    .ml-xl--1 {
      margin-left: -8px !important;
    }
  }
`;
    
export const ml_xl__2 = `
  @media (min-width: 1320px) {
    .ml-xl--2 {
      margin-left: -16px !important;
    }
  }
`;
    
export const ml_xl__3 = `
  @media (min-width: 1320px) {
    .ml-xl--3 {
      margin-left: -24px !important;
    }
  }
`;
    
export const ml_xl__4 = `
  @media (min-width: 1320px) {
    .ml-xl--4 {
      margin-left: -32px !important;
    }
  }
`;
    
export const ml_xl__5 = `
  @media (min-width: 1320px) {
    .ml-xl--5 {
      margin-left: -40px !important;
    }
  }
`;
    
export const ml_xl__6 = `
  @media (min-width: 1320px) {
    .ml-xl--6 {
      margin-left: -48px !important;
    }
  }
`;
    
export const ml_xl__7 = `
  @media (min-width: 1320px) {
    .ml-xl--7 {
      margin-left: -56px !important;
    }
  }
`;
    
export const ml_xl__8 = `
  @media (min-width: 1320px) {
    .ml-xl--8 {
      margin-left: -64px !important;
    }
  }
`;
    
export const ml_xl_auto = `
  @media (min-width: 1320px) {
    .ml-xl-auto {
      margin-left: auto !important;
    }
  }
`;
    
export const mr_0 = `
  .mr-0 {
    margin-right: 0px !important;
  }
`;
    
export const mr_1 = `
  .mr-1 {
    margin-right: 8px !important;
  }
`;
    
export const mr_2 = `
  .mr-2 {
    margin-right: 16px !important;
  }
`;
    
export const mr_3 = `
  .mr-3 {
    margin-right: 24px !important;
  }
`;
    
export const mr_4 = `
  .mr-4 {
    margin-right: 32px !important;
  }
`;
    
export const mr_5 = `
  .mr-5 {
    margin-right: 40px !important;
  }
`;
    
export const mr_6 = `
  .mr-6 {
    margin-right: 48px !important;
  }
`;
    
export const mr_7 = `
  .mr-7 {
    margin-right: 56px !important;
  }
`;
    
export const mr_8 = `
  .mr-8 {
    margin-right: 64px !important;
  }
`;
    
export const mr__1 = `
  .mr--1 {
    margin-right: -8px !important;
  }
`;
    
export const mr__2 = `
  .mr--2 {
    margin-right: -16px !important;
  }
`;
    
export const mr__3 = `
  .mr--3 {
    margin-right: -24px !important;
  }
`;
    
export const mr__4 = `
  .mr--4 {
    margin-right: -32px !important;
  }
`;
    
export const mr__5 = `
  .mr--5 {
    margin-right: -40px !important;
  }
`;
    
export const mr__6 = `
  .mr--6 {
    margin-right: -48px !important;
  }
`;
    
export const mr__7 = `
  .mr--7 {
    margin-right: -56px !important;
  }
`;
    
export const mr__8 = `
  .mr--8 {
    margin-right: -64px !important;
  }
`;
    
export const mr_auto = `
  .mr-auto {
    margin-right: auto !important;
  }
`;
    
export const mr_lg_0 = `
  @media (min-width: 992px) {
    .mr-lg-0 {
      margin-right: 0px !important;
    }
  }
`;
    
export const mr_lg_1 = `
  @media (min-width: 992px) {
    .mr-lg-1 {
      margin-right: 8px !important;
    }
  }
`;
    
export const mr_lg_2 = `
  @media (min-width: 992px) {
    .mr-lg-2 {
      margin-right: 16px !important;
    }
  }
`;
    
export const mr_lg_3 = `
  @media (min-width: 992px) {
    .mr-lg-3 {
      margin-right: 24px !important;
    }
  }
`;
    
export const mr_lg_4 = `
  @media (min-width: 992px) {
    .mr-lg-4 {
      margin-right: 32px !important;
    }
  }
`;
    
export const mr_lg_5 = `
  @media (min-width: 992px) {
    .mr-lg-5 {
      margin-right: 40px !important;
    }
  }
`;
    
export const mr_lg_6 = `
  @media (min-width: 992px) {
    .mr-lg-6 {
      margin-right: 48px !important;
    }
  }
`;
    
export const mr_lg_7 = `
  @media (min-width: 992px) {
    .mr-lg-7 {
      margin-right: 56px !important;
    }
  }
`;
    
export const mr_lg_8 = `
  @media (min-width: 992px) {
    .mr-lg-8 {
      margin-right: 64px !important;
    }
  }
`;
    
export const mr_lg__1 = `
  @media (min-width: 992px) {
    .mr-lg--1 {
      margin-right: -8px !important;
    }
  }
`;
    
export const mr_lg__2 = `
  @media (min-width: 992px) {
    .mr-lg--2 {
      margin-right: -16px !important;
    }
  }
`;
    
export const mr_lg__3 = `
  @media (min-width: 992px) {
    .mr-lg--3 {
      margin-right: -24px !important;
    }
  }
`;
    
export const mr_lg__4 = `
  @media (min-width: 992px) {
    .mr-lg--4 {
      margin-right: -32px !important;
    }
  }
`;
    
export const mr_lg__5 = `
  @media (min-width: 992px) {
    .mr-lg--5 {
      margin-right: -40px !important;
    }
  }
`;
    
export const mr_lg__6 = `
  @media (min-width: 992px) {
    .mr-lg--6 {
      margin-right: -48px !important;
    }
  }
`;
    
export const mr_lg__7 = `
  @media (min-width: 992px) {
    .mr-lg--7 {
      margin-right: -56px !important;
    }
  }
`;
    
export const mr_lg__8 = `
  @media (min-width: 992px) {
    .mr-lg--8 {
      margin-right: -64px !important;
    }
  }
`;
    
export const mr_lg_auto = `
  @media (min-width: 992px) {
    .mr-lg-auto {
      margin-right: auto !important;
    }
  }
`;
    
export const mr_md_0 = `
  @media (min-width: 768px) {
    .mr-md-0 {
      margin-right: 0px !important;
    }
  }
`;
    
export const mr_md_1 = `
  @media (min-width: 768px) {
    .mr-md-1 {
      margin-right: 8px !important;
    }
  }
`;
    
export const mr_md_2 = `
  @media (min-width: 768px) {
    .mr-md-2 {
      margin-right: 16px !important;
    }
  }
`;
    
export const mr_md_3 = `
  @media (min-width: 768px) {
    .mr-md-3 {
      margin-right: 24px !important;
    }
  }
`;
    
export const mr_md_4 = `
  @media (min-width: 768px) {
    .mr-md-4 {
      margin-right: 32px !important;
    }
  }
`;
    
export const mr_md_5 = `
  @media (min-width: 768px) {
    .mr-md-5 {
      margin-right: 40px !important;
    }
  }
`;
    
export const mr_md_6 = `
  @media (min-width: 768px) {
    .mr-md-6 {
      margin-right: 48px !important;
    }
  }
`;
    
export const mr_md_7 = `
  @media (min-width: 768px) {
    .mr-md-7 {
      margin-right: 56px !important;
    }
  }
`;
    
export const mr_md_8 = `
  @media (min-width: 768px) {
    .mr-md-8 {
      margin-right: 64px !important;
    }
  }
`;
    
export const mr_md__1 = `
  @media (min-width: 768px) {
    .mr-md--1 {
      margin-right: -8px !important;
    }
  }
`;
    
export const mr_md__2 = `
  @media (min-width: 768px) {
    .mr-md--2 {
      margin-right: -16px !important;
    }
  }
`;
    
export const mr_md__3 = `
  @media (min-width: 768px) {
    .mr-md--3 {
      margin-right: -24px !important;
    }
  }
`;
    
export const mr_md__4 = `
  @media (min-width: 768px) {
    .mr-md--4 {
      margin-right: -32px !important;
    }
  }
`;
    
export const mr_md__5 = `
  @media (min-width: 768px) {
    .mr-md--5 {
      margin-right: -40px !important;
    }
  }
`;
    
export const mr_md__6 = `
  @media (min-width: 768px) {
    .mr-md--6 {
      margin-right: -48px !important;
    }
  }
`;
    
export const mr_md__7 = `
  @media (min-width: 768px) {
    .mr-md--7 {
      margin-right: -56px !important;
    }
  }
`;
    
export const mr_md__8 = `
  @media (min-width: 768px) {
    .mr-md--8 {
      margin-right: -64px !important;
    }
  }
`;
    
export const mr_md_auto = `
  @media (min-width: 768px) {
    .mr-md-auto {
      margin-right: auto !important;
    }
  }
`;
    
export const mr_sm_0 = `
  @media (min-width: 576px) {
    .mr-sm-0 {
      margin-right: 0px !important;
    }
  }
`;
    
export const mr_sm_1 = `
  @media (min-width: 576px) {
    .mr-sm-1 {
      margin-right: 8px !important;
    }
  }
`;
    
export const mr_sm_2 = `
  @media (min-width: 576px) {
    .mr-sm-2 {
      margin-right: 16px !important;
    }
  }
`;
    
export const mr_sm_3 = `
  @media (min-width: 576px) {
    .mr-sm-3 {
      margin-right: 24px !important;
    }
  }
`;
    
export const mr_sm_4 = `
  @media (min-width: 576px) {
    .mr-sm-4 {
      margin-right: 32px !important;
    }
  }
`;
    
export const mr_sm_5 = `
  @media (min-width: 576px) {
    .mr-sm-5 {
      margin-right: 40px !important;
    }
  }
`;
    
export const mr_sm_6 = `
  @media (min-width: 576px) {
    .mr-sm-6 {
      margin-right: 48px !important;
    }
  }
`;
    
export const mr_sm_7 = `
  @media (min-width: 576px) {
    .mr-sm-7 {
      margin-right: 56px !important;
    }
  }
`;
    
export const mr_sm_8 = `
  @media (min-width: 576px) {
    .mr-sm-8 {
      margin-right: 64px !important;
    }
  }
`;
    
export const mr_sm__1 = `
  @media (min-width: 576px) {
    .mr-sm--1 {
      margin-right: -8px !important;
    }
  }
`;
    
export const mr_sm__2 = `
  @media (min-width: 576px) {
    .mr-sm--2 {
      margin-right: -16px !important;
    }
  }
`;
    
export const mr_sm__3 = `
  @media (min-width: 576px) {
    .mr-sm--3 {
      margin-right: -24px !important;
    }
  }
`;
    
export const mr_sm__4 = `
  @media (min-width: 576px) {
    .mr-sm--4 {
      margin-right: -32px !important;
    }
  }
`;
    
export const mr_sm__5 = `
  @media (min-width: 576px) {
    .mr-sm--5 {
      margin-right: -40px !important;
    }
  }
`;
    
export const mr_sm__6 = `
  @media (min-width: 576px) {
    .mr-sm--6 {
      margin-right: -48px !important;
    }
  }
`;
    
export const mr_sm__7 = `
  @media (min-width: 576px) {
    .mr-sm--7 {
      margin-right: -56px !important;
    }
  }
`;
    
export const mr_sm__8 = `
  @media (min-width: 576px) {
    .mr-sm--8 {
      margin-right: -64px !important;
    }
  }
`;
    
export const mr_sm_auto = `
  @media (min-width: 576px) {
    .mr-sm-auto {
      margin-right: auto !important;
    }
  }
`;
    
export const mr_xl_0 = `
  @media (min-width: 1320px) {
    .mr-xl-0 {
      margin-right: 0px !important;
    }
  }
`;
    
export const mr_xl_1 = `
  @media (min-width: 1320px) {
    .mr-xl-1 {
      margin-right: 8px !important;
    }
  }
`;
    
export const mr_xl_2 = `
  @media (min-width: 1320px) {
    .mr-xl-2 {
      margin-right: 16px !important;
    }
  }
`;
    
export const mr_xl_3 = `
  @media (min-width: 1320px) {
    .mr-xl-3 {
      margin-right: 24px !important;
    }
  }
`;
    
export const mr_xl_4 = `
  @media (min-width: 1320px) {
    .mr-xl-4 {
      margin-right: 32px !important;
    }
  }
`;
    
export const mr_xl_5 = `
  @media (min-width: 1320px) {
    .mr-xl-5 {
      margin-right: 40px !important;
    }
  }
`;
    
export const mr_xl_6 = `
  @media (min-width: 1320px) {
    .mr-xl-6 {
      margin-right: 48px !important;
    }
  }
`;
    
export const mr_xl_7 = `
  @media (min-width: 1320px) {
    .mr-xl-7 {
      margin-right: 56px !important;
    }
  }
`;
    
export const mr_xl_8 = `
  @media (min-width: 1320px) {
    .mr-xl-8 {
      margin-right: 64px !important;
    }
  }
`;
    
export const mr_xl__1 = `
  @media (min-width: 1320px) {
    .mr-xl--1 {
      margin-right: -8px !important;
    }
  }
`;
    
export const mr_xl__2 = `
  @media (min-width: 1320px) {
    .mr-xl--2 {
      margin-right: -16px !important;
    }
  }
`;
    
export const mr_xl__3 = `
  @media (min-width: 1320px) {
    .mr-xl--3 {
      margin-right: -24px !important;
    }
  }
`;
    
export const mr_xl__4 = `
  @media (min-width: 1320px) {
    .mr-xl--4 {
      margin-right: -32px !important;
    }
  }
`;
    
export const mr_xl__5 = `
  @media (min-width: 1320px) {
    .mr-xl--5 {
      margin-right: -40px !important;
    }
  }
`;
    
export const mr_xl__6 = `
  @media (min-width: 1320px) {
    .mr-xl--6 {
      margin-right: -48px !important;
    }
  }
`;
    
export const mr_xl__7 = `
  @media (min-width: 1320px) {
    .mr-xl--7 {
      margin-right: -56px !important;
    }
  }
`;
    
export const mr_xl__8 = `
  @media (min-width: 1320px) {
    .mr-xl--8 {
      margin-right: -64px !important;
    }
  }
`;
    
export const mr_xl_auto = `
  @media (min-width: 1320px) {
    .mr-xl-auto {
      margin-right: auto !important;
    }
  }
`;
    
export const mt_0 = `
  .mt-0 {
    margin-top: 0px !important;
  }
`;
    
export const mt_1 = `
  .mt-1 {
    margin-top: 8px !important;
  }
`;
    
export const mt_2 = `
  .mt-2 {
    margin-top: 16px !important;
  }
`;
    
export const mt_3 = `
  .mt-3 {
    margin-top: 24px !important;
  }
`;
    
export const mt_4 = `
  .mt-4 {
    margin-top: 32px !important;
  }
`;
    
export const mt_5 = `
  .mt-5 {
    margin-top: 40px !important;
  }
`;
    
export const mt_6 = `
  .mt-6 {
    margin-top: 48px !important;
  }
`;
    
export const mt_7 = `
  .mt-7 {
    margin-top: 56px !important;
  }
`;
    
export const mt_8 = `
  .mt-8 {
    margin-top: 64px !important;
  }
`;
    
export const mt__1 = `
  .mt--1 {
    margin-top: -8px !important;
  }
`;
    
export const mt__2 = `
  .mt--2 {
    margin-top: -16px !important;
  }
`;
    
export const mt__3 = `
  .mt--3 {
    margin-top: -24px !important;
  }
`;
    
export const mt__4 = `
  .mt--4 {
    margin-top: -32px !important;
  }
`;
    
export const mt__5 = `
  .mt--5 {
    margin-top: -40px !important;
  }
`;
    
export const mt__6 = `
  .mt--6 {
    margin-top: -48px !important;
  }
`;
    
export const mt__7 = `
  .mt--7 {
    margin-top: -56px !important;
  }
`;
    
export const mt__8 = `
  .mt--8 {
    margin-top: -64px !important;
  }
`;
    
export const mt_auto = `
  .mt-auto {
    margin-top: auto !important;
  }
`;
    
export const mt_lg_0 = `
  @media (min-width: 992px) {
    .mt-lg-0 {
      margin-top: 0px !important;
    }
  }
`;
    
export const mt_lg_1 = `
  @media (min-width: 992px) {
    .mt-lg-1 {
      margin-top: 8px !important;
    }
  }
`;
    
export const mt_lg_2 = `
  @media (min-width: 992px) {
    .mt-lg-2 {
      margin-top: 16px !important;
    }
  }
`;
    
export const mt_lg_3 = `
  @media (min-width: 992px) {
    .mt-lg-3 {
      margin-top: 24px !important;
    }
  }
`;
    
export const mt_lg_4 = `
  @media (min-width: 992px) {
    .mt-lg-4 {
      margin-top: 32px !important;
    }
  }
`;
    
export const mt_lg_5 = `
  @media (min-width: 992px) {
    .mt-lg-5 {
      margin-top: 40px !important;
    }
  }
`;
    
export const mt_lg_6 = `
  @media (min-width: 992px) {
    .mt-lg-6 {
      margin-top: 48px !important;
    }
  }
`;
    
export const mt_lg_7 = `
  @media (min-width: 992px) {
    .mt-lg-7 {
      margin-top: 56px !important;
    }
  }
`;
    
export const mt_lg_8 = `
  @media (min-width: 992px) {
    .mt-lg-8 {
      margin-top: 64px !important;
    }
  }
`;
    
export const mt_lg__1 = `
  @media (min-width: 992px) {
    .mt-lg--1 {
      margin-top: -8px !important;
    }
  }
`;
    
export const mt_lg__2 = `
  @media (min-width: 992px) {
    .mt-lg--2 {
      margin-top: -16px !important;
    }
  }
`;
    
export const mt_lg__3 = `
  @media (min-width: 992px) {
    .mt-lg--3 {
      margin-top: -24px !important;
    }
  }
`;
    
export const mt_lg__4 = `
  @media (min-width: 992px) {
    .mt-lg--4 {
      margin-top: -32px !important;
    }
  }
`;
    
export const mt_lg__5 = `
  @media (min-width: 992px) {
    .mt-lg--5 {
      margin-top: -40px !important;
    }
  }
`;
    
export const mt_lg__6 = `
  @media (min-width: 992px) {
    .mt-lg--6 {
      margin-top: -48px !important;
    }
  }
`;
    
export const mt_lg__7 = `
  @media (min-width: 992px) {
    .mt-lg--7 {
      margin-top: -56px !important;
    }
  }
`;
    
export const mt_lg__8 = `
  @media (min-width: 992px) {
    .mt-lg--8 {
      margin-top: -64px !important;
    }
  }
`;
    
export const mt_lg_auto = `
  @media (min-width: 992px) {
    .mt-lg-auto {
      margin-top: auto !important;
    }
  }
`;
    
export const mt_md_0 = `
  @media (min-width: 768px) {
    .mt-md-0 {
      margin-top: 0px !important;
    }
  }
`;
    
export const mt_md_1 = `
  @media (min-width: 768px) {
    .mt-md-1 {
      margin-top: 8px !important;
    }
  }
`;
    
export const mt_md_2 = `
  @media (min-width: 768px) {
    .mt-md-2 {
      margin-top: 16px !important;
    }
  }
`;
    
export const mt_md_3 = `
  @media (min-width: 768px) {
    .mt-md-3 {
      margin-top: 24px !important;
    }
  }
`;
    
export const mt_md_4 = `
  @media (min-width: 768px) {
    .mt-md-4 {
      margin-top: 32px !important;
    }
  }
`;
    
export const mt_md_5 = `
  @media (min-width: 768px) {
    .mt-md-5 {
      margin-top: 40px !important;
    }
  }
`;
    
export const mt_md_6 = `
  @media (min-width: 768px) {
    .mt-md-6 {
      margin-top: 48px !important;
    }
  }
`;
    
export const mt_md_7 = `
  @media (min-width: 768px) {
    .mt-md-7 {
      margin-top: 56px !important;
    }
  }
`;
    
export const mt_md_8 = `
  @media (min-width: 768px) {
    .mt-md-8 {
      margin-top: 64px !important;
    }
  }
`;
    
export const mt_md__1 = `
  @media (min-width: 768px) {
    .mt-md--1 {
      margin-top: -8px !important;
    }
  }
`;
    
export const mt_md__2 = `
  @media (min-width: 768px) {
    .mt-md--2 {
      margin-top: -16px !important;
    }
  }
`;
    
export const mt_md__3 = `
  @media (min-width: 768px) {
    .mt-md--3 {
      margin-top: -24px !important;
    }
  }
`;
    
export const mt_md__4 = `
  @media (min-width: 768px) {
    .mt-md--4 {
      margin-top: -32px !important;
    }
  }
`;
    
export const mt_md__5 = `
  @media (min-width: 768px) {
    .mt-md--5 {
      margin-top: -40px !important;
    }
  }
`;
    
export const mt_md__6 = `
  @media (min-width: 768px) {
    .mt-md--6 {
      margin-top: -48px !important;
    }
  }
`;
    
export const mt_md__7 = `
  @media (min-width: 768px) {
    .mt-md--7 {
      margin-top: -56px !important;
    }
  }
`;
    
export const mt_md__8 = `
  @media (min-width: 768px) {
    .mt-md--8 {
      margin-top: -64px !important;
    }
  }
`;
    
export const mt_md_auto = `
  @media (min-width: 768px) {
    .mt-md-auto {
      margin-top: auto !important;
    }
  }
`;
    
export const mt_sm_0 = `
  @media (min-width: 576px) {
    .mt-sm-0 {
      margin-top: 0px !important;
    }
  }
`;
    
export const mt_sm_1 = `
  @media (min-width: 576px) {
    .mt-sm-1 {
      margin-top: 8px !important;
    }
  }
`;
    
export const mt_sm_2 = `
  @media (min-width: 576px) {
    .mt-sm-2 {
      margin-top: 16px !important;
    }
  }
`;
    
export const mt_sm_3 = `
  @media (min-width: 576px) {
    .mt-sm-3 {
      margin-top: 24px !important;
    }
  }
`;
    
export const mt_sm_4 = `
  @media (min-width: 576px) {
    .mt-sm-4 {
      margin-top: 32px !important;
    }
  }
`;
    
export const mt_sm_5 = `
  @media (min-width: 576px) {
    .mt-sm-5 {
      margin-top: 40px !important;
    }
  }
`;
    
export const mt_sm_6 = `
  @media (min-width: 576px) {
    .mt-sm-6 {
      margin-top: 48px !important;
    }
  }
`;
    
export const mt_sm_7 = `
  @media (min-width: 576px) {
    .mt-sm-7 {
      margin-top: 56px !important;
    }
  }
`;
    
export const mt_sm_8 = `
  @media (min-width: 576px) {
    .mt-sm-8 {
      margin-top: 64px !important;
    }
  }
`;
    
export const mt_sm__1 = `
  @media (min-width: 576px) {
    .mt-sm--1 {
      margin-top: -8px !important;
    }
  }
`;
    
export const mt_sm__2 = `
  @media (min-width: 576px) {
    .mt-sm--2 {
      margin-top: -16px !important;
    }
  }
`;
    
export const mt_sm__3 = `
  @media (min-width: 576px) {
    .mt-sm--3 {
      margin-top: -24px !important;
    }
  }
`;
    
export const mt_sm__4 = `
  @media (min-width: 576px) {
    .mt-sm--4 {
      margin-top: -32px !important;
    }
  }
`;
    
export const mt_sm__5 = `
  @media (min-width: 576px) {
    .mt-sm--5 {
      margin-top: -40px !important;
    }
  }
`;
    
export const mt_sm__6 = `
  @media (min-width: 576px) {
    .mt-sm--6 {
      margin-top: -48px !important;
    }
  }
`;
    
export const mt_sm__7 = `
  @media (min-width: 576px) {
    .mt-sm--7 {
      margin-top: -56px !important;
    }
  }
`;
    
export const mt_sm__8 = `
  @media (min-width: 576px) {
    .mt-sm--8 {
      margin-top: -64px !important;
    }
  }
`;
    
export const mt_sm_auto = `
  @media (min-width: 576px) {
    .mt-sm-auto {
      margin-top: auto !important;
    }
  }
`;
    
export const mt_xl_0 = `
  @media (min-width: 1320px) {
    .mt-xl-0 {
      margin-top: 0px !important;
    }
  }
`;
    
export const mt_xl_1 = `
  @media (min-width: 1320px) {
    .mt-xl-1 {
      margin-top: 8px !important;
    }
  }
`;
    
export const mt_xl_2 = `
  @media (min-width: 1320px) {
    .mt-xl-2 {
      margin-top: 16px !important;
    }
  }
`;
    
export const mt_xl_3 = `
  @media (min-width: 1320px) {
    .mt-xl-3 {
      margin-top: 24px !important;
    }
  }
`;
    
export const mt_xl_4 = `
  @media (min-width: 1320px) {
    .mt-xl-4 {
      margin-top: 32px !important;
    }
  }
`;
    
export const mt_xl_5 = `
  @media (min-width: 1320px) {
    .mt-xl-5 {
      margin-top: 40px !important;
    }
  }
`;
    
export const mt_xl_6 = `
  @media (min-width: 1320px) {
    .mt-xl-6 {
      margin-top: 48px !important;
    }
  }
`;
    
export const mt_xl_7 = `
  @media (min-width: 1320px) {
    .mt-xl-7 {
      margin-top: 56px !important;
    }
  }
`;
    
export const mt_xl_8 = `
  @media (min-width: 1320px) {
    .mt-xl-8 {
      margin-top: 64px !important;
    }
  }
`;
    
export const mt_xl__1 = `
  @media (min-width: 1320px) {
    .mt-xl--1 {
      margin-top: -8px !important;
    }
  }
`;
    
export const mt_xl__2 = `
  @media (min-width: 1320px) {
    .mt-xl--2 {
      margin-top: -16px !important;
    }
  }
`;
    
export const mt_xl__3 = `
  @media (min-width: 1320px) {
    .mt-xl--3 {
      margin-top: -24px !important;
    }
  }
`;
    
export const mt_xl__4 = `
  @media (min-width: 1320px) {
    .mt-xl--4 {
      margin-top: -32px !important;
    }
  }
`;
    
export const mt_xl__5 = `
  @media (min-width: 1320px) {
    .mt-xl--5 {
      margin-top: -40px !important;
    }
  }
`;
    
export const mt_xl__6 = `
  @media (min-width: 1320px) {
    .mt-xl--6 {
      margin-top: -48px !important;
    }
  }
`;
    
export const mt_xl__7 = `
  @media (min-width: 1320px) {
    .mt-xl--7 {
      margin-top: -56px !important;
    }
  }
`;
    
export const mt_xl__8 = `
  @media (min-width: 1320px) {
    .mt-xl--8 {
      margin-top: -64px !important;
    }
  }
`;
    
export const mt_xl_auto = `
  @media (min-width: 1320px) {
    .mt-xl-auto {
      margin-top: auto !important;
    }
  }
`;
    
export const mx_0 = `
  .mx-0 {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
`;
    
export const mx_1 = `
  .mx-1 {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }
`;
    
export const mx_2 = `
  .mx-2 {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
`;
    
export const mx_3 = `
  .mx-3 {
    margin-left: 24px !important;
    margin-right: 24px !important;
  }
`;
    
export const mx_4 = `
  .mx-4 {
    margin-left: 32px !important;
    margin-right: 32px !important;
  }
`;
    
export const mx_5 = `
  .mx-5 {
    margin-left: 40px !important;
    margin-right: 40px !important;
  }
`;
    
export const mx_6 = `
  .mx-6 {
    margin-left: 48px !important;
    margin-right: 48px !important;
  }
`;
    
export const mx_7 = `
  .mx-7 {
    margin-left: 56px !important;
    margin-right: 56px !important;
  }
`;
    
export const mx_8 = `
  .mx-8 {
    margin-left: 64px !important;
    margin-right: 64px !important;
  }
`;
    
export const mx__1 = `
  .mx--1 {
    margin-left: -8px !important;
    margin-right: -8px !important;
  }
`;
    
export const mx__2 = `
  .mx--2 {
    margin-left: -16px !important;
    margin-right: -16px !important;
  }
`;
    
export const mx__3 = `
  .mx--3 {
    margin-left: -24px !important;
    margin-right: -24px !important;
  }
`;
    
export const mx__4 = `
  .mx--4 {
    margin-left: -32px !important;
    margin-right: -32px !important;
  }
`;
    
export const mx__5 = `
  .mx--5 {
    margin-left: -40px !important;
    margin-right: -40px !important;
  }
`;
    
export const mx__6 = `
  .mx--6 {
    margin-left: -48px !important;
    margin-right: -48px !important;
  }
`;
    
export const mx__7 = `
  .mx--7 {
    margin-left: -56px !important;
    margin-right: -56px !important;
  }
`;
    
export const mx__8 = `
  .mx--8 {
    margin-left: -64px !important;
    margin-right: -64px !important;
  }
`;
    
export const mx_auto = `
  .mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
  }
`;
    
export const mx_lg_0 = `
  @media (min-width: 992px) {
    .mx-lg-0 {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
  }
`;
    
export const mx_lg_1 = `
  @media (min-width: 992px) {
    .mx-lg-1 {
      margin-left: 8px !important;
      margin-right: 8px !important;
    }
  }
`;
    
export const mx_lg_2 = `
  @media (min-width: 992px) {
    .mx-lg-2 {
      margin-left: 16px !important;
      margin-right: 16px !important;
    }
  }
`;
    
export const mx_lg_3 = `
  @media (min-width: 992px) {
    .mx-lg-3 {
      margin-left: 24px !important;
      margin-right: 24px !important;
    }
  }
`;
    
export const mx_lg_4 = `
  @media (min-width: 992px) {
    .mx-lg-4 {
      margin-left: 32px !important;
      margin-right: 32px !important;
    }
  }
`;
    
export const mx_lg_5 = `
  @media (min-width: 992px) {
    .mx-lg-5 {
      margin-left: 40px !important;
      margin-right: 40px !important;
    }
  }
`;
    
export const mx_lg_6 = `
  @media (min-width: 992px) {
    .mx-lg-6 {
      margin-left: 48px !important;
      margin-right: 48px !important;
    }
  }
`;
    
export const mx_lg_7 = `
  @media (min-width: 992px) {
    .mx-lg-7 {
      margin-left: 56px !important;
      margin-right: 56px !important;
    }
  }
`;
    
export const mx_lg_8 = `
  @media (min-width: 992px) {
    .mx-lg-8 {
      margin-left: 64px !important;
      margin-right: 64px !important;
    }
  }
`;
    
export const mx_lg__1 = `
  @media (min-width: 992px) {
    .mx-lg--1 {
      margin-left: -8px !important;
      margin-right: -8px !important;
    }
  }
`;
    
export const mx_lg__2 = `
  @media (min-width: 992px) {
    .mx-lg--2 {
      margin-left: -16px !important;
      margin-right: -16px !important;
    }
  }
`;
    
export const mx_lg__3 = `
  @media (min-width: 992px) {
    .mx-lg--3 {
      margin-left: -24px !important;
      margin-right: -24px !important;
    }
  }
`;
    
export const mx_lg__4 = `
  @media (min-width: 992px) {
    .mx-lg--4 {
      margin-left: -32px !important;
      margin-right: -32px !important;
    }
  }
`;
    
export const mx_lg__5 = `
  @media (min-width: 992px) {
    .mx-lg--5 {
      margin-left: -40px !important;
      margin-right: -40px !important;
    }
  }
`;
    
export const mx_lg__6 = `
  @media (min-width: 992px) {
    .mx-lg--6 {
      margin-left: -48px !important;
      margin-right: -48px !important;
    }
  }
`;
    
export const mx_lg__7 = `
  @media (min-width: 992px) {
    .mx-lg--7 {
      margin-left: -56px !important;
      margin-right: -56px !important;
    }
  }
`;
    
export const mx_lg__8 = `
  @media (min-width: 992px) {
    .mx-lg--8 {
      margin-left: -64px !important;
      margin-right: -64px !important;
    }
  }
`;
    
export const mx_lg_auto = `
  @media (min-width: 992px) {
    .mx-lg-auto {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
`;
    
export const mx_md_0 = `
  @media (min-width: 768px) {
    .mx-md-0 {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
  }
`;
    
export const mx_md_1 = `
  @media (min-width: 768px) {
    .mx-md-1 {
      margin-left: 8px !important;
      margin-right: 8px !important;
    }
  }
`;
    
export const mx_md_2 = `
  @media (min-width: 768px) {
    .mx-md-2 {
      margin-left: 16px !important;
      margin-right: 16px !important;
    }
  }
`;
    
export const mx_md_3 = `
  @media (min-width: 768px) {
    .mx-md-3 {
      margin-left: 24px !important;
      margin-right: 24px !important;
    }
  }
`;
    
export const mx_md_4 = `
  @media (min-width: 768px) {
    .mx-md-4 {
      margin-left: 32px !important;
      margin-right: 32px !important;
    }
  }
`;
    
export const mx_md_5 = `
  @media (min-width: 768px) {
    .mx-md-5 {
      margin-left: 40px !important;
      margin-right: 40px !important;
    }
  }
`;
    
export const mx_md_6 = `
  @media (min-width: 768px) {
    .mx-md-6 {
      margin-left: 48px !important;
      margin-right: 48px !important;
    }
  }
`;
    
export const mx_md_7 = `
  @media (min-width: 768px) {
    .mx-md-7 {
      margin-left: 56px !important;
      margin-right: 56px !important;
    }
  }
`;
    
export const mx_md_8 = `
  @media (min-width: 768px) {
    .mx-md-8 {
      margin-left: 64px !important;
      margin-right: 64px !important;
    }
  }
`;
    
export const mx_md__1 = `
  @media (min-width: 768px) {
    .mx-md--1 {
      margin-left: -8px !important;
      margin-right: -8px !important;
    }
  }
`;
    
export const mx_md__2 = `
  @media (min-width: 768px) {
    .mx-md--2 {
      margin-left: -16px !important;
      margin-right: -16px !important;
    }
  }
`;
    
export const mx_md__3 = `
  @media (min-width: 768px) {
    .mx-md--3 {
      margin-left: -24px !important;
      margin-right: -24px !important;
    }
  }
`;
    
export const mx_md__4 = `
  @media (min-width: 768px) {
    .mx-md--4 {
      margin-left: -32px !important;
      margin-right: -32px !important;
    }
  }
`;
    
export const mx_md__5 = `
  @media (min-width: 768px) {
    .mx-md--5 {
      margin-left: -40px !important;
      margin-right: -40px !important;
    }
  }
`;
    
export const mx_md__6 = `
  @media (min-width: 768px) {
    .mx-md--6 {
      margin-left: -48px !important;
      margin-right: -48px !important;
    }
  }
`;
    
export const mx_md__7 = `
  @media (min-width: 768px) {
    .mx-md--7 {
      margin-left: -56px !important;
      margin-right: -56px !important;
    }
  }
`;
    
export const mx_md__8 = `
  @media (min-width: 768px) {
    .mx-md--8 {
      margin-left: -64px !important;
      margin-right: -64px !important;
    }
  }
`;
    
export const mx_md_auto = `
  @media (min-width: 768px) {
    .mx-md-auto {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
`;
    
export const mx_sm_0 = `
  @media (min-width: 576px) {
    .mx-sm-0 {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
  }
`;
    
export const mx_sm_1 = `
  @media (min-width: 576px) {
    .mx-sm-1 {
      margin-left: 8px !important;
      margin-right: 8px !important;
    }
  }
`;
    
export const mx_sm_2 = `
  @media (min-width: 576px) {
    .mx-sm-2 {
      margin-left: 16px !important;
      margin-right: 16px !important;
    }
  }
`;
    
export const mx_sm_3 = `
  @media (min-width: 576px) {
    .mx-sm-3 {
      margin-left: 24px !important;
      margin-right: 24px !important;
    }
  }
`;
    
export const mx_sm_4 = `
  @media (min-width: 576px) {
    .mx-sm-4 {
      margin-left: 32px !important;
      margin-right: 32px !important;
    }
  }
`;
    
export const mx_sm_5 = `
  @media (min-width: 576px) {
    .mx-sm-5 {
      margin-left: 40px !important;
      margin-right: 40px !important;
    }
  }
`;
    
export const mx_sm_6 = `
  @media (min-width: 576px) {
    .mx-sm-6 {
      margin-left: 48px !important;
      margin-right: 48px !important;
    }
  }
`;
    
export const mx_sm_7 = `
  @media (min-width: 576px) {
    .mx-sm-7 {
      margin-left: 56px !important;
      margin-right: 56px !important;
    }
  }
`;
    
export const mx_sm_8 = `
  @media (min-width: 576px) {
    .mx-sm-8 {
      margin-left: 64px !important;
      margin-right: 64px !important;
    }
  }
`;
    
export const mx_sm__1 = `
  @media (min-width: 576px) {
    .mx-sm--1 {
      margin-left: -8px !important;
      margin-right: -8px !important;
    }
  }
`;
    
export const mx_sm__2 = `
  @media (min-width: 576px) {
    .mx-sm--2 {
      margin-left: -16px !important;
      margin-right: -16px !important;
    }
  }
`;
    
export const mx_sm__3 = `
  @media (min-width: 576px) {
    .mx-sm--3 {
      margin-left: -24px !important;
      margin-right: -24px !important;
    }
  }
`;
    
export const mx_sm__4 = `
  @media (min-width: 576px) {
    .mx-sm--4 {
      margin-left: -32px !important;
      margin-right: -32px !important;
    }
  }
`;
    
export const mx_sm__5 = `
  @media (min-width: 576px) {
    .mx-sm--5 {
      margin-left: -40px !important;
      margin-right: -40px !important;
    }
  }
`;
    
export const mx_sm__6 = `
  @media (min-width: 576px) {
    .mx-sm--6 {
      margin-left: -48px !important;
      margin-right: -48px !important;
    }
  }
`;
    
export const mx_sm__7 = `
  @media (min-width: 576px) {
    .mx-sm--7 {
      margin-left: -56px !important;
      margin-right: -56px !important;
    }
  }
`;
    
export const mx_sm__8 = `
  @media (min-width: 576px) {
    .mx-sm--8 {
      margin-left: -64px !important;
      margin-right: -64px !important;
    }
  }
`;
    
export const mx_sm_auto = `
  @media (min-width: 576px) {
    .mx-sm-auto {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
`;
    
export const mx_xl_0 = `
  @media (min-width: 1320px) {
    .mx-xl-0 {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
  }
`;
    
export const mx_xl_1 = `
  @media (min-width: 1320px) {
    .mx-xl-1 {
      margin-left: 8px !important;
      margin-right: 8px !important;
    }
  }
`;
    
export const mx_xl_2 = `
  @media (min-width: 1320px) {
    .mx-xl-2 {
      margin-left: 16px !important;
      margin-right: 16px !important;
    }
  }
`;
    
export const mx_xl_3 = `
  @media (min-width: 1320px) {
    .mx-xl-3 {
      margin-left: 24px !important;
      margin-right: 24px !important;
    }
  }
`;
    
export const mx_xl_4 = `
  @media (min-width: 1320px) {
    .mx-xl-4 {
      margin-left: 32px !important;
      margin-right: 32px !important;
    }
  }
`;
    
export const mx_xl_5 = `
  @media (min-width: 1320px) {
    .mx-xl-5 {
      margin-left: 40px !important;
      margin-right: 40px !important;
    }
  }
`;
    
export const mx_xl_6 = `
  @media (min-width: 1320px) {
    .mx-xl-6 {
      margin-left: 48px !important;
      margin-right: 48px !important;
    }
  }
`;
    
export const mx_xl_7 = `
  @media (min-width: 1320px) {
    .mx-xl-7 {
      margin-left: 56px !important;
      margin-right: 56px !important;
    }
  }
`;
    
export const mx_xl_8 = `
  @media (min-width: 1320px) {
    .mx-xl-8 {
      margin-left: 64px !important;
      margin-right: 64px !important;
    }
  }
`;
    
export const mx_xl__1 = `
  @media (min-width: 1320px) {
    .mx-xl--1 {
      margin-left: -8px !important;
      margin-right: -8px !important;
    }
  }
`;
    
export const mx_xl__2 = `
  @media (min-width: 1320px) {
    .mx-xl--2 {
      margin-left: -16px !important;
      margin-right: -16px !important;
    }
  }
`;
    
export const mx_xl__3 = `
  @media (min-width: 1320px) {
    .mx-xl--3 {
      margin-left: -24px !important;
      margin-right: -24px !important;
    }
  }
`;
    
export const mx_xl__4 = `
  @media (min-width: 1320px) {
    .mx-xl--4 {
      margin-left: -32px !important;
      margin-right: -32px !important;
    }
  }
`;
    
export const mx_xl__5 = `
  @media (min-width: 1320px) {
    .mx-xl--5 {
      margin-left: -40px !important;
      margin-right: -40px !important;
    }
  }
`;
    
export const mx_xl__6 = `
  @media (min-width: 1320px) {
    .mx-xl--6 {
      margin-left: -48px !important;
      margin-right: -48px !important;
    }
  }
`;
    
export const mx_xl__7 = `
  @media (min-width: 1320px) {
    .mx-xl--7 {
      margin-left: -56px !important;
      margin-right: -56px !important;
    }
  }
`;
    
export const mx_xl__8 = `
  @media (min-width: 1320px) {
    .mx-xl--8 {
      margin-left: -64px !important;
      margin-right: -64px !important;
    }
  }
`;
    
export const mx_xl_auto = `
  @media (min-width: 1320px) {
    .mx-xl-auto {
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }
`;
    
export const my_0 = `
  .my-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
`;
    
export const my_1 = `
  .my-1 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
`;
    
export const my_2 = `
  .my-2 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
`;
    
export const my_3 = `
  .my-3 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
`;
    
export const my_4 = `
  .my-4 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
`;
    
export const my_5 = `
  .my-5 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
`;
    
export const my_6 = `
  .my-6 {
    margin-top: 48px !important;
    margin-bottom: 48px !important;
  }
`;
    
export const my_7 = `
  .my-7 {
    margin-top: 56px !important;
    margin-bottom: 56px !important;
  }
`;
    
export const my_8 = `
  .my-8 {
    margin-top: 64px !important;
    margin-bottom: 64px !important;
  }
`;
    
export const my__1 = `
  .my--1 {
    margin-top: -8px !important;
    margin-bottom: -8px !important;
  }
`;
    
export const my__2 = `
  .my--2 {
    margin-top: -16px !important;
    margin-bottom: -16px !important;
  }
`;
    
export const my__3 = `
  .my--3 {
    margin-top: -24px !important;
    margin-bottom: -24px !important;
  }
`;
    
export const my__4 = `
  .my--4 {
    margin-top: -32px !important;
    margin-bottom: -32px !important;
  }
`;
    
export const my__5 = `
  .my--5 {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
`;
    
export const my__6 = `
  .my--6 {
    margin-top: -48px !important;
    margin-bottom: -48px !important;
  }
`;
    
export const my__7 = `
  .my--7 {
    margin-top: -56px !important;
    margin-bottom: -56px !important;
  }
`;
    
export const my__8 = `
  .my--8 {
    margin-top: -64px !important;
    margin-bottom: -64px !important;
  }
`;
    
export const my_auto = `
  .my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
`;
    
export const my_lg_0 = `
  @media (min-width: 992px) {
    .my-lg-0 {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }
  }
`;
    
export const my_lg_1 = `
  @media (min-width: 992px) {
    .my-lg-1 {
      margin-top: 8px !important;
      margin-bottom: 8px !important;
    }
  }
`;
    
export const my_lg_2 = `
  @media (min-width: 992px) {
    .my-lg-2 {
      margin-top: 16px !important;
      margin-bottom: 16px !important;
    }
  }
`;
    
export const my_lg_3 = `
  @media (min-width: 992px) {
    .my-lg-3 {
      margin-top: 24px !important;
      margin-bottom: 24px !important;
    }
  }
`;
    
export const my_lg_4 = `
  @media (min-width: 992px) {
    .my-lg-4 {
      margin-top: 32px !important;
      margin-bottom: 32px !important;
    }
  }
`;
    
export const my_lg_5 = `
  @media (min-width: 992px) {
    .my-lg-5 {
      margin-top: 40px !important;
      margin-bottom: 40px !important;
    }
  }
`;
    
export const my_lg_6 = `
  @media (min-width: 992px) {
    .my-lg-6 {
      margin-top: 48px !important;
      margin-bottom: 48px !important;
    }
  }
`;
    
export const my_lg_7 = `
  @media (min-width: 992px) {
    .my-lg-7 {
      margin-top: 56px !important;
      margin-bottom: 56px !important;
    }
  }
`;
    
export const my_lg_8 = `
  @media (min-width: 992px) {
    .my-lg-8 {
      margin-top: 64px !important;
      margin-bottom: 64px !important;
    }
  }
`;
    
export const my_lg__1 = `
  @media (min-width: 992px) {
    .my-lg--1 {
      margin-top: -8px !important;
      margin-bottom: -8px !important;
    }
  }
`;
    
export const my_lg__2 = `
  @media (min-width: 992px) {
    .my-lg--2 {
      margin-top: -16px !important;
      margin-bottom: -16px !important;
    }
  }
`;
    
export const my_lg__3 = `
  @media (min-width: 992px) {
    .my-lg--3 {
      margin-top: -24px !important;
      margin-bottom: -24px !important;
    }
  }
`;
    
export const my_lg__4 = `
  @media (min-width: 992px) {
    .my-lg--4 {
      margin-top: -32px !important;
      margin-bottom: -32px !important;
    }
  }
`;
    
export const my_lg__5 = `
  @media (min-width: 992px) {
    .my-lg--5 {
      margin-top: -40px !important;
      margin-bottom: -40px !important;
    }
  }
`;
    
export const my_lg__6 = `
  @media (min-width: 992px) {
    .my-lg--6 {
      margin-top: -48px !important;
      margin-bottom: -48px !important;
    }
  }
`;
    
export const my_lg__7 = `
  @media (min-width: 992px) {
    .my-lg--7 {
      margin-top: -56px !important;
      margin-bottom: -56px !important;
    }
  }
`;
    
export const my_lg__8 = `
  @media (min-width: 992px) {
    .my-lg--8 {
      margin-top: -64px !important;
      margin-bottom: -64px !important;
    }
  }
`;
    
export const my_lg_auto = `
  @media (min-width: 992px) {
    .my-lg-auto {
      margin-top: auto !important;
      margin-bottom: auto !important;
    }
  }
`;
    
export const my_md_0 = `
  @media (min-width: 768px) {
    .my-md-0 {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }
  }
`;
    
export const my_md_1 = `
  @media (min-width: 768px) {
    .my-md-1 {
      margin-top: 8px !important;
      margin-bottom: 8px !important;
    }
  }
`;
    
export const my_md_2 = `
  @media (min-width: 768px) {
    .my-md-2 {
      margin-top: 16px !important;
      margin-bottom: 16px !important;
    }
  }
`;
    
export const my_md_3 = `
  @media (min-width: 768px) {
    .my-md-3 {
      margin-top: 24px !important;
      margin-bottom: 24px !important;
    }
  }
`;
    
export const my_md_4 = `
  @media (min-width: 768px) {
    .my-md-4 {
      margin-top: 32px !important;
      margin-bottom: 32px !important;
    }
  }
`;
    
export const my_md_5 = `
  @media (min-width: 768px) {
    .my-md-5 {
      margin-top: 40px !important;
      margin-bottom: 40px !important;
    }
  }
`;
    
export const my_md_6 = `
  @media (min-width: 768px) {
    .my-md-6 {
      margin-top: 48px !important;
      margin-bottom: 48px !important;
    }
  }
`;
    
export const my_md_7 = `
  @media (min-width: 768px) {
    .my-md-7 {
      margin-top: 56px !important;
      margin-bottom: 56px !important;
    }
  }
`;
    
export const my_md_8 = `
  @media (min-width: 768px) {
    .my-md-8 {
      margin-top: 64px !important;
      margin-bottom: 64px !important;
    }
  }
`;
    
export const my_md__1 = `
  @media (min-width: 768px) {
    .my-md--1 {
      margin-top: -8px !important;
      margin-bottom: -8px !important;
    }
  }
`;
    
export const my_md__2 = `
  @media (min-width: 768px) {
    .my-md--2 {
      margin-top: -16px !important;
      margin-bottom: -16px !important;
    }
  }
`;
    
export const my_md__3 = `
  @media (min-width: 768px) {
    .my-md--3 {
      margin-top: -24px !important;
      margin-bottom: -24px !important;
    }
  }
`;
    
export const my_md__4 = `
  @media (min-width: 768px) {
    .my-md--4 {
      margin-top: -32px !important;
      margin-bottom: -32px !important;
    }
  }
`;
    
export const my_md__5 = `
  @media (min-width: 768px) {
    .my-md--5 {
      margin-top: -40px !important;
      margin-bottom: -40px !important;
    }
  }
`;
    
export const my_md__6 = `
  @media (min-width: 768px) {
    .my-md--6 {
      margin-top: -48px !important;
      margin-bottom: -48px !important;
    }
  }
`;
    
export const my_md__7 = `
  @media (min-width: 768px) {
    .my-md--7 {
      margin-top: -56px !important;
      margin-bottom: -56px !important;
    }
  }
`;
    
export const my_md__8 = `
  @media (min-width: 768px) {
    .my-md--8 {
      margin-top: -64px !important;
      margin-bottom: -64px !important;
    }
  }
`;
    
export const my_md_auto = `
  @media (min-width: 768px) {
    .my-md-auto {
      margin-top: auto !important;
      margin-bottom: auto !important;
    }
  }
`;
    
export const my_sm_0 = `
  @media (min-width: 576px) {
    .my-sm-0 {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }
  }
`;
    
export const my_sm_1 = `
  @media (min-width: 576px) {
    .my-sm-1 {
      margin-top: 8px !important;
      margin-bottom: 8px !important;
    }
  }
`;
    
export const my_sm_2 = `
  @media (min-width: 576px) {
    .my-sm-2 {
      margin-top: 16px !important;
      margin-bottom: 16px !important;
    }
  }
`;
    
export const my_sm_3 = `
  @media (min-width: 576px) {
    .my-sm-3 {
      margin-top: 24px !important;
      margin-bottom: 24px !important;
    }
  }
`;
    
export const my_sm_4 = `
  @media (min-width: 576px) {
    .my-sm-4 {
      margin-top: 32px !important;
      margin-bottom: 32px !important;
    }
  }
`;
    
export const my_sm_5 = `
  @media (min-width: 576px) {
    .my-sm-5 {
      margin-top: 40px !important;
      margin-bottom: 40px !important;
    }
  }
`;
    
export const my_sm_6 = `
  @media (min-width: 576px) {
    .my-sm-6 {
      margin-top: 48px !important;
      margin-bottom: 48px !important;
    }
  }
`;
    
export const my_sm_7 = `
  @media (min-width: 576px) {
    .my-sm-7 {
      margin-top: 56px !important;
      margin-bottom: 56px !important;
    }
  }
`;
    
export const my_sm_8 = `
  @media (min-width: 576px) {
    .my-sm-8 {
      margin-top: 64px !important;
      margin-bottom: 64px !important;
    }
  }
`;
    
export const my_sm__1 = `
  @media (min-width: 576px) {
    .my-sm--1 {
      margin-top: -8px !important;
      margin-bottom: -8px !important;
    }
  }
`;
    
export const my_sm__2 = `
  @media (min-width: 576px) {
    .my-sm--2 {
      margin-top: -16px !important;
      margin-bottom: -16px !important;
    }
  }
`;
    
export const my_sm__3 = `
  @media (min-width: 576px) {
    .my-sm--3 {
      margin-top: -24px !important;
      margin-bottom: -24px !important;
    }
  }
`;
    
export const my_sm__4 = `
  @media (min-width: 576px) {
    .my-sm--4 {
      margin-top: -32px !important;
      margin-bottom: -32px !important;
    }
  }
`;
    
export const my_sm__5 = `
  @media (min-width: 576px) {
    .my-sm--5 {
      margin-top: -40px !important;
      margin-bottom: -40px !important;
    }
  }
`;
    
export const my_sm__6 = `
  @media (min-width: 576px) {
    .my-sm--6 {
      margin-top: -48px !important;
      margin-bottom: -48px !important;
    }
  }
`;
    
export const my_sm__7 = `
  @media (min-width: 576px) {
    .my-sm--7 {
      margin-top: -56px !important;
      margin-bottom: -56px !important;
    }
  }
`;
    
export const my_sm__8 = `
  @media (min-width: 576px) {
    .my-sm--8 {
      margin-top: -64px !important;
      margin-bottom: -64px !important;
    }
  }
`;
    
export const my_sm_auto = `
  @media (min-width: 576px) {
    .my-sm-auto {
      margin-top: auto !important;
      margin-bottom: auto !important;
    }
  }
`;
    
export const my_xl_0 = `
  @media (min-width: 1320px) {
    .my-xl-0 {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }
  }
`;
    
export const my_xl_1 = `
  @media (min-width: 1320px) {
    .my-xl-1 {
      margin-top: 8px !important;
      margin-bottom: 8px !important;
    }
  }
`;
    
export const my_xl_2 = `
  @media (min-width: 1320px) {
    .my-xl-2 {
      margin-top: 16px !important;
      margin-bottom: 16px !important;
    }
  }
`;
    
export const my_xl_3 = `
  @media (min-width: 1320px) {
    .my-xl-3 {
      margin-top: 24px !important;
      margin-bottom: 24px !important;
    }
  }
`;
    
export const my_xl_4 = `
  @media (min-width: 1320px) {
    .my-xl-4 {
      margin-top: 32px !important;
      margin-bottom: 32px !important;
    }
  }
`;
    
export const my_xl_5 = `
  @media (min-width: 1320px) {
    .my-xl-5 {
      margin-top: 40px !important;
      margin-bottom: 40px !important;
    }
  }
`;
    
export const my_xl_6 = `
  @media (min-width: 1320px) {
    .my-xl-6 {
      margin-top: 48px !important;
      margin-bottom: 48px !important;
    }
  }
`;
    
export const my_xl_7 = `
  @media (min-width: 1320px) {
    .my-xl-7 {
      margin-top: 56px !important;
      margin-bottom: 56px !important;
    }
  }
`;
    
export const my_xl_8 = `
  @media (min-width: 1320px) {
    .my-xl-8 {
      margin-top: 64px !important;
      margin-bottom: 64px !important;
    }
  }
`;
    
export const my_xl__1 = `
  @media (min-width: 1320px) {
    .my-xl--1 {
      margin-top: -8px !important;
      margin-bottom: -8px !important;
    }
  }
`;
    
export const my_xl__2 = `
  @media (min-width: 1320px) {
    .my-xl--2 {
      margin-top: -16px !important;
      margin-bottom: -16px !important;
    }
  }
`;
    
export const my_xl__3 = `
  @media (min-width: 1320px) {
    .my-xl--3 {
      margin-top: -24px !important;
      margin-bottom: -24px !important;
    }
  }
`;
    
export const my_xl__4 = `
  @media (min-width: 1320px) {
    .my-xl--4 {
      margin-top: -32px !important;
      margin-bottom: -32px !important;
    }
  }
`;
    
export const my_xl__5 = `
  @media (min-width: 1320px) {
    .my-xl--5 {
      margin-top: -40px !important;
      margin-bottom: -40px !important;
    }
  }
`;
    
export const my_xl__6 = `
  @media (min-width: 1320px) {
    .my-xl--6 {
      margin-top: -48px !important;
      margin-bottom: -48px !important;
    }
  }
`;
    
export const my_xl__7 = `
  @media (min-width: 1320px) {
    .my-xl--7 {
      margin-top: -56px !important;
      margin-bottom: -56px !important;
    }
  }
`;
    
export const my_xl__8 = `
  @media (min-width: 1320px) {
    .my-xl--8 {
      margin-top: -64px !important;
      margin-bottom: -64px !important;
    }
  }
`;
    
export const my_xl_auto = `
  @media (min-width: 1320px) {
    .my-xl-auto {
      margin-top: auto !important;
      margin-bottom: auto !important;
    }
  }
`;
    
export const sm_1 = `
  .sm-1 {
    margin: 4px !important;
  }
`;
    
export const sm_2 = `
  .sm-2 {
    margin: 12px !important;
  }
`;
    
export const sm_3 = `
  .sm-3 {
    margin: 20px !important;
  }
`;
    
export const sm__1 = `
  .sm--1 {
    margin: -4px !important;
  }
`;
    
export const sm__2 = `
  .sm--2 {
    margin: -12px !important;
  }
`;
    
export const sm__3 = `
  .sm--3 {
    margin: -20px !important;
  }
`;
    
export const sm_lg_1 = `
  @media (min-width: 992px) {
    .sm-lg-1 {
      margin: 4px !important;
    }
  }
`;
    
export const sm_lg_2 = `
  @media (min-width: 992px) {
    .sm-lg-2 {
      margin: 12px !important;
    }
  }
`;
    
export const sm_lg_3 = `
  @media (min-width: 992px) {
    .sm-lg-3 {
      margin: 20px !important;
    }
  }
`;
    
export const sm_lg__1 = `
  @media (min-width: 992px) {
    .sm-lg--1 {
      margin: -4px !important;
    }
  }
`;
    
export const sm_lg__2 = `
  @media (min-width: 992px) {
    .sm-lg--2 {
      margin: -12px !important;
    }
  }
`;
    
export const sm_lg__3 = `
  @media (min-width: 992px) {
    .sm-lg--3 {
      margin: -20px !important;
    }
  }
`;
    
export const sm_md_1 = `
  @media (min-width: 768px) {
    .sm-md-1 {
      margin: 4px !important;
    }
  }
`;
    
export const sm_md_2 = `
  @media (min-width: 768px) {
    .sm-md-2 {
      margin: 12px !important;
    }
  }
`;
    
export const sm_md_3 = `
  @media (min-width: 768px) {
    .sm-md-3 {
      margin: 20px !important;
    }
  }
`;
    
export const sm_md__1 = `
  @media (min-width: 768px) {
    .sm-md--1 {
      margin: -4px !important;
    }
  }
`;
    
export const sm_md__2 = `
  @media (min-width: 768px) {
    .sm-md--2 {
      margin: -12px !important;
    }
  }
`;
    
export const sm_md__3 = `
  @media (min-width: 768px) {
    .sm-md--3 {
      margin: -20px !important;
    }
  }
`;
    
export const sm_sm_1 = `
  @media (min-width: 576px) {
    .sm-sm-1 {
      margin: 4px !important;
    }
  }
`;
    
export const sm_sm_2 = `
  @media (min-width: 576px) {
    .sm-sm-2 {
      margin: 12px !important;
    }
  }
`;
    
export const sm_sm_3 = `
  @media (min-width: 576px) {
    .sm-sm-3 {
      margin: 20px !important;
    }
  }
`;
    
export const sm_sm__1 = `
  @media (min-width: 576px) {
    .sm-sm--1 {
      margin: -4px !important;
    }
  }
`;
    
export const sm_sm__2 = `
  @media (min-width: 576px) {
    .sm-sm--2 {
      margin: -12px !important;
    }
  }
`;
    
export const sm_sm__3 = `
  @media (min-width: 576px) {
    .sm-sm--3 {
      margin: -20px !important;
    }
  }
`;
    
export const sm_xl_1 = `
  @media (min-width: 1320px) {
    .sm-xl-1 {
      margin: 4px !important;
    }
  }
`;
    
export const sm_xl_2 = `
  @media (min-width: 1320px) {
    .sm-xl-2 {
      margin: 12px !important;
    }
  }
`;
    
export const sm_xl_3 = `
  @media (min-width: 1320px) {
    .sm-xl-3 {
      margin: 20px !important;
    }
  }
`;
    
export const sm_xl__1 = `
  @media (min-width: 1320px) {
    .sm-xl--1 {
      margin: -4px !important;
    }
  }
`;
    
export const sm_xl__2 = `
  @media (min-width: 1320px) {
    .sm-xl--2 {
      margin: -12px !important;
    }
  }
`;
    
export const sm_xl__3 = `
  @media (min-width: 1320px) {
    .sm-xl--3 {
      margin: -20px !important;
    }
  }
`;
    
export const smb_1 = `
  .smb-1 {
    margin-bottom: 4px !important;
  }
`;
    
export const smb_2 = `
  .smb-2 {
    margin-bottom: 12px !important;
  }
`;
    
export const smb_3 = `
  .smb-3 {
    margin-bottom: 20px !important;
  }
`;
    
export const smb__1 = `
  .smb--1 {
    margin-bottom: -4px !important;
  }
`;
    
export const smb__2 = `
  .smb--2 {
    margin-bottom: -12px !important;
  }
`;
    
export const smb__3 = `
  .smb--3 {
    margin-bottom: -20px !important;
  }
`;
    
export const smb_lg_1 = `
  @media (min-width: 992px) {
    .smb-lg-1 {
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smb_lg_2 = `
  @media (min-width: 992px) {
    .smb-lg-2 {
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smb_lg_3 = `
  @media (min-width: 992px) {
    .smb-lg-3 {
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smb_lg__1 = `
  @media (min-width: 992px) {
    .smb-lg--1 {
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smb_lg__2 = `
  @media (min-width: 992px) {
    .smb-lg--2 {
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smb_lg__3 = `
  @media (min-width: 992px) {
    .smb-lg--3 {
      margin-bottom: -20px !important;
    }
  }
`;
    
export const smb_md_1 = `
  @media (min-width: 768px) {
    .smb-md-1 {
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smb_md_2 = `
  @media (min-width: 768px) {
    .smb-md-2 {
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smb_md_3 = `
  @media (min-width: 768px) {
    .smb-md-3 {
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smb_md__1 = `
  @media (min-width: 768px) {
    .smb-md--1 {
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smb_md__2 = `
  @media (min-width: 768px) {
    .smb-md--2 {
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smb_md__3 = `
  @media (min-width: 768px) {
    .smb-md--3 {
      margin-bottom: -20px !important;
    }
  }
`;
    
export const smb_sm_1 = `
  @media (min-width: 576px) {
    .smb-sm-1 {
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smb_sm_2 = `
  @media (min-width: 576px) {
    .smb-sm-2 {
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smb_sm_3 = `
  @media (min-width: 576px) {
    .smb-sm-3 {
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smb_sm__1 = `
  @media (min-width: 576px) {
    .smb-sm--1 {
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smb_sm__2 = `
  @media (min-width: 576px) {
    .smb-sm--2 {
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smb_sm__3 = `
  @media (min-width: 576px) {
    .smb-sm--3 {
      margin-bottom: -20px !important;
    }
  }
`;
    
export const smb_xl_1 = `
  @media (min-width: 1320px) {
    .smb-xl-1 {
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smb_xl_2 = `
  @media (min-width: 1320px) {
    .smb-xl-2 {
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smb_xl_3 = `
  @media (min-width: 1320px) {
    .smb-xl-3 {
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smb_xl__1 = `
  @media (min-width: 1320px) {
    .smb-xl--1 {
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smb_xl__2 = `
  @media (min-width: 1320px) {
    .smb-xl--2 {
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smb_xl__3 = `
  @media (min-width: 1320px) {
    .smb-xl--3 {
      margin-bottom: -20px !important;
    }
  }
`;
    
export const sml_1 = `
  .sml-1 {
    margin-left: 4px !important;
  }
`;
    
export const sml_2 = `
  .sml-2 {
    margin-left: 12px !important;
  }
`;
    
export const sml_3 = `
  .sml-3 {
    margin-left: 20px !important;
  }
`;
    
export const sml__1 = `
  .sml--1 {
    margin-left: -4px !important;
  }
`;
    
export const sml__2 = `
  .sml--2 {
    margin-left: -12px !important;
  }
`;
    
export const sml__3 = `
  .sml--3 {
    margin-left: -20px !important;
  }
`;
    
export const sml_lg_1 = `
  @media (min-width: 992px) {
    .sml-lg-1 {
      margin-left: 4px !important;
    }
  }
`;
    
export const sml_lg_2 = `
  @media (min-width: 992px) {
    .sml-lg-2 {
      margin-left: 12px !important;
    }
  }
`;
    
export const sml_lg_3 = `
  @media (min-width: 992px) {
    .sml-lg-3 {
      margin-left: 20px !important;
    }
  }
`;
    
export const sml_lg__1 = `
  @media (min-width: 992px) {
    .sml-lg--1 {
      margin-left: -4px !important;
    }
  }
`;
    
export const sml_lg__2 = `
  @media (min-width: 992px) {
    .sml-lg--2 {
      margin-left: -12px !important;
    }
  }
`;
    
export const sml_lg__3 = `
  @media (min-width: 992px) {
    .sml-lg--3 {
      margin-left: -20px !important;
    }
  }
`;
    
export const sml_md_1 = `
  @media (min-width: 768px) {
    .sml-md-1 {
      margin-left: 4px !important;
    }
  }
`;
    
export const sml_md_2 = `
  @media (min-width: 768px) {
    .sml-md-2 {
      margin-left: 12px !important;
    }
  }
`;
    
export const sml_md_3 = `
  @media (min-width: 768px) {
    .sml-md-3 {
      margin-left: 20px !important;
    }
  }
`;
    
export const sml_md__1 = `
  @media (min-width: 768px) {
    .sml-md--1 {
      margin-left: -4px !important;
    }
  }
`;
    
export const sml_md__2 = `
  @media (min-width: 768px) {
    .sml-md--2 {
      margin-left: -12px !important;
    }
  }
`;
    
export const sml_md__3 = `
  @media (min-width: 768px) {
    .sml-md--3 {
      margin-left: -20px !important;
    }
  }
`;
    
export const sml_sm_1 = `
  @media (min-width: 576px) {
    .sml-sm-1 {
      margin-left: 4px !important;
    }
  }
`;
    
export const sml_sm_2 = `
  @media (min-width: 576px) {
    .sml-sm-2 {
      margin-left: 12px !important;
    }
  }
`;
    
export const sml_sm_3 = `
  @media (min-width: 576px) {
    .sml-sm-3 {
      margin-left: 20px !important;
    }
  }
`;
    
export const sml_sm__1 = `
  @media (min-width: 576px) {
    .sml-sm--1 {
      margin-left: -4px !important;
    }
  }
`;
    
export const sml_sm__2 = `
  @media (min-width: 576px) {
    .sml-sm--2 {
      margin-left: -12px !important;
    }
  }
`;
    
export const sml_sm__3 = `
  @media (min-width: 576px) {
    .sml-sm--3 {
      margin-left: -20px !important;
    }
  }
`;
    
export const sml_xl_1 = `
  @media (min-width: 1320px) {
    .sml-xl-1 {
      margin-left: 4px !important;
    }
  }
`;
    
export const sml_xl_2 = `
  @media (min-width: 1320px) {
    .sml-xl-2 {
      margin-left: 12px !important;
    }
  }
`;
    
export const sml_xl_3 = `
  @media (min-width: 1320px) {
    .sml-xl-3 {
      margin-left: 20px !important;
    }
  }
`;
    
export const sml_xl__1 = `
  @media (min-width: 1320px) {
    .sml-xl--1 {
      margin-left: -4px !important;
    }
  }
`;
    
export const sml_xl__2 = `
  @media (min-width: 1320px) {
    .sml-xl--2 {
      margin-left: -12px !important;
    }
  }
`;
    
export const sml_xl__3 = `
  @media (min-width: 1320px) {
    .sml-xl--3 {
      margin-left: -20px !important;
    }
  }
`;
    
export const smr_1 = `
  .smr-1 {
    margin-right: 4px !important;
  }
`;
    
export const smr_2 = `
  .smr-2 {
    margin-right: 12px !important;
  }
`;
    
export const smr_3 = `
  .smr-3 {
    margin-right: 20px !important;
  }
`;
    
export const smr__1 = `
  .smr--1 {
    margin-right: -4px !important;
  }
`;
    
export const smr__2 = `
  .smr--2 {
    margin-right: -12px !important;
  }
`;
    
export const smr__3 = `
  .smr--3 {
    margin-right: -20px !important;
  }
`;
    
export const smr_lg_1 = `
  @media (min-width: 992px) {
    .smr-lg-1 {
      margin-right: 4px !important;
    }
  }
`;
    
export const smr_lg_2 = `
  @media (min-width: 992px) {
    .smr-lg-2 {
      margin-right: 12px !important;
    }
  }
`;
    
export const smr_lg_3 = `
  @media (min-width: 992px) {
    .smr-lg-3 {
      margin-right: 20px !important;
    }
  }
`;
    
export const smr_lg__1 = `
  @media (min-width: 992px) {
    .smr-lg--1 {
      margin-right: -4px !important;
    }
  }
`;
    
export const smr_lg__2 = `
  @media (min-width: 992px) {
    .smr-lg--2 {
      margin-right: -12px !important;
    }
  }
`;
    
export const smr_lg__3 = `
  @media (min-width: 992px) {
    .smr-lg--3 {
      margin-right: -20px !important;
    }
  }
`;
    
export const smr_md_1 = `
  @media (min-width: 768px) {
    .smr-md-1 {
      margin-right: 4px !important;
    }
  }
`;
    
export const smr_md_2 = `
  @media (min-width: 768px) {
    .smr-md-2 {
      margin-right: 12px !important;
    }
  }
`;
    
export const smr_md_3 = `
  @media (min-width: 768px) {
    .smr-md-3 {
      margin-right: 20px !important;
    }
  }
`;
    
export const smr_md__1 = `
  @media (min-width: 768px) {
    .smr-md--1 {
      margin-right: -4px !important;
    }
  }
`;
    
export const smr_md__2 = `
  @media (min-width: 768px) {
    .smr-md--2 {
      margin-right: -12px !important;
    }
  }
`;
    
export const smr_md__3 = `
  @media (min-width: 768px) {
    .smr-md--3 {
      margin-right: -20px !important;
    }
  }
`;
    
export const smr_sm_1 = `
  @media (min-width: 576px) {
    .smr-sm-1 {
      margin-right: 4px !important;
    }
  }
`;
    
export const smr_sm_2 = `
  @media (min-width: 576px) {
    .smr-sm-2 {
      margin-right: 12px !important;
    }
  }
`;
    
export const smr_sm_3 = `
  @media (min-width: 576px) {
    .smr-sm-3 {
      margin-right: 20px !important;
    }
  }
`;
    
export const smr_sm__1 = `
  @media (min-width: 576px) {
    .smr-sm--1 {
      margin-right: -4px !important;
    }
  }
`;
    
export const smr_sm__2 = `
  @media (min-width: 576px) {
    .smr-sm--2 {
      margin-right: -12px !important;
    }
  }
`;
    
export const smr_sm__3 = `
  @media (min-width: 576px) {
    .smr-sm--3 {
      margin-right: -20px !important;
    }
  }
`;
    
export const smr_xl_1 = `
  @media (min-width: 1320px) {
    .smr-xl-1 {
      margin-right: 4px !important;
    }
  }
`;
    
export const smr_xl_2 = `
  @media (min-width: 1320px) {
    .smr-xl-2 {
      margin-right: 12px !important;
    }
  }
`;
    
export const smr_xl_3 = `
  @media (min-width: 1320px) {
    .smr-xl-3 {
      margin-right: 20px !important;
    }
  }
`;
    
export const smr_xl__1 = `
  @media (min-width: 1320px) {
    .smr-xl--1 {
      margin-right: -4px !important;
    }
  }
`;
    
export const smr_xl__2 = `
  @media (min-width: 1320px) {
    .smr-xl--2 {
      margin-right: -12px !important;
    }
  }
`;
    
export const smr_xl__3 = `
  @media (min-width: 1320px) {
    .smr-xl--3 {
      margin-right: -20px !important;
    }
  }
`;
    
export const smt_1 = `
  .smt-1 {
    margin-top: 4px !important;
  }
`;
    
export const smt_2 = `
  .smt-2 {
    margin-top: 12px !important;
  }
`;
    
export const smt_3 = `
  .smt-3 {
    margin-top: 20px !important;
  }
`;
    
export const smt__1 = `
  .smt--1 {
    margin-top: -4px !important;
  }
`;
    
export const smt__2 = `
  .smt--2 {
    margin-top: -12px !important;
  }
`;
    
export const smt__3 = `
  .smt--3 {
    margin-top: -20px !important;
  }
`;
    
export const smt_lg_1 = `
  @media (min-width: 992px) {
    .smt-lg-1 {
      margin-top: 4px !important;
    }
  }
`;
    
export const smt_lg_2 = `
  @media (min-width: 992px) {
    .smt-lg-2 {
      margin-top: 12px !important;
    }
  }
`;
    
export const smt_lg_3 = `
  @media (min-width: 992px) {
    .smt-lg-3 {
      margin-top: 20px !important;
    }
  }
`;
    
export const smt_lg__1 = `
  @media (min-width: 992px) {
    .smt-lg--1 {
      margin-top: -4px !important;
    }
  }
`;
    
export const smt_lg__2 = `
  @media (min-width: 992px) {
    .smt-lg--2 {
      margin-top: -12px !important;
    }
  }
`;
    
export const smt_lg__3 = `
  @media (min-width: 992px) {
    .smt-lg--3 {
      margin-top: -20px !important;
    }
  }
`;
    
export const smt_md_1 = `
  @media (min-width: 768px) {
    .smt-md-1 {
      margin-top: 4px !important;
    }
  }
`;
    
export const smt_md_2 = `
  @media (min-width: 768px) {
    .smt-md-2 {
      margin-top: 12px !important;
    }
  }
`;
    
export const smt_md_3 = `
  @media (min-width: 768px) {
    .smt-md-3 {
      margin-top: 20px !important;
    }
  }
`;
    
export const smt_md__1 = `
  @media (min-width: 768px) {
    .smt-md--1 {
      margin-top: -4px !important;
    }
  }
`;
    
export const smt_md__2 = `
  @media (min-width: 768px) {
    .smt-md--2 {
      margin-top: -12px !important;
    }
  }
`;
    
export const smt_md__3 = `
  @media (min-width: 768px) {
    .smt-md--3 {
      margin-top: -20px !important;
    }
  }
`;
    
export const smt_sm_1 = `
  @media (min-width: 576px) {
    .smt-sm-1 {
      margin-top: 4px !important;
    }
  }
`;
    
export const smt_sm_2 = `
  @media (min-width: 576px) {
    .smt-sm-2 {
      margin-top: 12px !important;
    }
  }
`;
    
export const smt_sm_3 = `
  @media (min-width: 576px) {
    .smt-sm-3 {
      margin-top: 20px !important;
    }
  }
`;
    
export const smt_sm__1 = `
  @media (min-width: 576px) {
    .smt-sm--1 {
      margin-top: -4px !important;
    }
  }
`;
    
export const smt_sm__2 = `
  @media (min-width: 576px) {
    .smt-sm--2 {
      margin-top: -12px !important;
    }
  }
`;
    
export const smt_sm__3 = `
  @media (min-width: 576px) {
    .smt-sm--3 {
      margin-top: -20px !important;
    }
  }
`;
    
export const smt_xl_1 = `
  @media (min-width: 1320px) {
    .smt-xl-1 {
      margin-top: 4px !important;
    }
  }
`;
    
export const smt_xl_2 = `
  @media (min-width: 1320px) {
    .smt-xl-2 {
      margin-top: 12px !important;
    }
  }
`;
    
export const smt_xl_3 = `
  @media (min-width: 1320px) {
    .smt-xl-3 {
      margin-top: 20px !important;
    }
  }
`;
    
export const smt_xl__1 = `
  @media (min-width: 1320px) {
    .smt-xl--1 {
      margin-top: -4px !important;
    }
  }
`;
    
export const smt_xl__2 = `
  @media (min-width: 1320px) {
    .smt-xl--2 {
      margin-top: -12px !important;
    }
  }
`;
    
export const smt_xl__3 = `
  @media (min-width: 1320px) {
    .smt-xl--3 {
      margin-top: -20px !important;
    }
  }
`;
    
export const smx_1 = `
  .smx-1 {
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
`;
    
export const smx_2 = `
  .smx-2 {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }
`;
    
export const smx_3 = `
  .smx-3 {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
`;
    
export const smx__1 = `
  .smx--1 {
    margin-left: -4px !important;
    margin-right: -4px !important;
  }
`;
    
export const smx__2 = `
  .smx--2 {
    margin-left: -12px !important;
    margin-right: -12px !important;
  }
`;
    
export const smx__3 = `
  .smx--3 {
    margin-left: -20px !important;
    margin-right: -20px !important;
  }
`;
    
export const smx_lg_1 = `
  @media (min-width: 992px) {
    .smx-lg-1 {
      margin-left: 4px !important;
      margin-right: 4px !important;
    }
  }
`;
    
export const smx_lg_2 = `
  @media (min-width: 992px) {
    .smx-lg-2 {
      margin-left: 12px !important;
      margin-right: 12px !important;
    }
  }
`;
    
export const smx_lg_3 = `
  @media (min-width: 992px) {
    .smx-lg-3 {
      margin-left: 20px !important;
      margin-right: 20px !important;
    }
  }
`;
    
export const smx_lg__1 = `
  @media (min-width: 992px) {
    .smx-lg--1 {
      margin-left: -4px !important;
      margin-right: -4px !important;
    }
  }
`;
    
export const smx_lg__2 = `
  @media (min-width: 992px) {
    .smx-lg--2 {
      margin-left: -12px !important;
      margin-right: -12px !important;
    }
  }
`;
    
export const smx_lg__3 = `
  @media (min-width: 992px) {
    .smx-lg--3 {
      margin-left: -20px !important;
      margin-right: -20px !important;
    }
  }
`;
    
export const smx_md_1 = `
  @media (min-width: 768px) {
    .smx-md-1 {
      margin-left: 4px !important;
      margin-right: 4px !important;
    }
  }
`;
    
export const smx_md_2 = `
  @media (min-width: 768px) {
    .smx-md-2 {
      margin-left: 12px !important;
      margin-right: 12px !important;
    }
  }
`;
    
export const smx_md_3 = `
  @media (min-width: 768px) {
    .smx-md-3 {
      margin-left: 20px !important;
      margin-right: 20px !important;
    }
  }
`;
    
export const smx_md__1 = `
  @media (min-width: 768px) {
    .smx-md--1 {
      margin-left: -4px !important;
      margin-right: -4px !important;
    }
  }
`;
    
export const smx_md__2 = `
  @media (min-width: 768px) {
    .smx-md--2 {
      margin-left: -12px !important;
      margin-right: -12px !important;
    }
  }
`;
    
export const smx_md__3 = `
  @media (min-width: 768px) {
    .smx-md--3 {
      margin-left: -20px !important;
      margin-right: -20px !important;
    }
  }
`;
    
export const smx_sm_1 = `
  @media (min-width: 576px) {
    .smx-sm-1 {
      margin-left: 4px !important;
      margin-right: 4px !important;
    }
  }
`;
    
export const smx_sm_2 = `
  @media (min-width: 576px) {
    .smx-sm-2 {
      margin-left: 12px !important;
      margin-right: 12px !important;
    }
  }
`;
    
export const smx_sm_3 = `
  @media (min-width: 576px) {
    .smx-sm-3 {
      margin-left: 20px !important;
      margin-right: 20px !important;
    }
  }
`;
    
export const smx_sm__1 = `
  @media (min-width: 576px) {
    .smx-sm--1 {
      margin-left: -4px !important;
      margin-right: -4px !important;
    }
  }
`;
    
export const smx_sm__2 = `
  @media (min-width: 576px) {
    .smx-sm--2 {
      margin-left: -12px !important;
      margin-right: -12px !important;
    }
  }
`;
    
export const smx_sm__3 = `
  @media (min-width: 576px) {
    .smx-sm--3 {
      margin-left: -20px !important;
      margin-right: -20px !important;
    }
  }
`;
    
export const smx_xl_1 = `
  @media (min-width: 1320px) {
    .smx-xl-1 {
      margin-left: 4px !important;
      margin-right: 4px !important;
    }
  }
`;
    
export const smx_xl_2 = `
  @media (min-width: 1320px) {
    .smx-xl-2 {
      margin-left: 12px !important;
      margin-right: 12px !important;
    }
  }
`;
    
export const smx_xl_3 = `
  @media (min-width: 1320px) {
    .smx-xl-3 {
      margin-left: 20px !important;
      margin-right: 20px !important;
    }
  }
`;
    
export const smx_xl__1 = `
  @media (min-width: 1320px) {
    .smx-xl--1 {
      margin-left: -4px !important;
      margin-right: -4px !important;
    }
  }
`;
    
export const smx_xl__2 = `
  @media (min-width: 1320px) {
    .smx-xl--2 {
      margin-left: -12px !important;
      margin-right: -12px !important;
    }
  }
`;
    
export const smx_xl__3 = `
  @media (min-width: 1320px) {
    .smx-xl--3 {
      margin-left: -20px !important;
      margin-right: -20px !important;
    }
  }
`;
    
export const smy_1 = `
  .smy-1 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
`;
    
export const smy_2 = `
  .smy-2 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
`;
    
export const smy_3 = `
  .smy-3 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
`;
    
export const smy__1 = `
  .smy--1 {
    margin-top: -4px !important;
    margin-bottom: -4px !important;
  }
`;
    
export const smy__2 = `
  .smy--2 {
    margin-top: -12px !important;
    margin-bottom: -12px !important;
  }
`;
    
export const smy__3 = `
  .smy--3 {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
`;
    
export const smy_lg_1 = `
  @media (min-width: 992px) {
    .smy-lg-1 {
      margin-top: 4px !important;
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smy_lg_2 = `
  @media (min-width: 992px) {
    .smy-lg-2 {
      margin-top: 12px !important;
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smy_lg_3 = `
  @media (min-width: 992px) {
    .smy-lg-3 {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smy_lg__1 = `
  @media (min-width: 992px) {
    .smy-lg--1 {
      margin-top: -4px !important;
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smy_lg__2 = `
  @media (min-width: 992px) {
    .smy-lg--2 {
      margin-top: -12px !important;
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smy_lg__3 = `
  @media (min-width: 992px) {
    .smy-lg--3 {
      margin-top: -20px !important;
      margin-bottom: -20px !important;
    }
  }
`;
    
export const smy_md_1 = `
  @media (min-width: 768px) {
    .smy-md-1 {
      margin-top: 4px !important;
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smy_md_2 = `
  @media (min-width: 768px) {
    .smy-md-2 {
      margin-top: 12px !important;
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smy_md_3 = `
  @media (min-width: 768px) {
    .smy-md-3 {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smy_md__1 = `
  @media (min-width: 768px) {
    .smy-md--1 {
      margin-top: -4px !important;
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smy_md__2 = `
  @media (min-width: 768px) {
    .smy-md--2 {
      margin-top: -12px !important;
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smy_md__3 = `
  @media (min-width: 768px) {
    .smy-md--3 {
      margin-top: -20px !important;
      margin-bottom: -20px !important;
    }
  }
`;
    
export const smy_sm_1 = `
  @media (min-width: 576px) {
    .smy-sm-1 {
      margin-top: 4px !important;
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smy_sm_2 = `
  @media (min-width: 576px) {
    .smy-sm-2 {
      margin-top: 12px !important;
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smy_sm_3 = `
  @media (min-width: 576px) {
    .smy-sm-3 {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smy_sm__1 = `
  @media (min-width: 576px) {
    .smy-sm--1 {
      margin-top: -4px !important;
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smy_sm__2 = `
  @media (min-width: 576px) {
    .smy-sm--2 {
      margin-top: -12px !important;
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smy_sm__3 = `
  @media (min-width: 576px) {
    .smy-sm--3 {
      margin-top: -20px !important;
      margin-bottom: -20px !important;
    }
  }
`;
    
export const smy_xl_1 = `
  @media (min-width: 1320px) {
    .smy-xl-1 {
      margin-top: 4px !important;
      margin-bottom: 4px !important;
    }
  }
`;
    
export const smy_xl_2 = `
  @media (min-width: 1320px) {
    .smy-xl-2 {
      margin-top: 12px !important;
      margin-bottom: 12px !important;
    }
  }
`;
    
export const smy_xl_3 = `
  @media (min-width: 1320px) {
    .smy-xl-3 {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  }
`;
    
export const smy_xl__1 = `
  @media (min-width: 1320px) {
    .smy-xl--1 {
      margin-top: -4px !important;
      margin-bottom: -4px !important;
    }
  }
`;
    
export const smy_xl__2 = `
  @media (min-width: 1320px) {
    .smy-xl--2 {
      margin-top: -12px !important;
      margin-bottom: -12px !important;
    }
  }
`;
    
export const smy_xl__3 = `
  @media (min-width: 1320px) {
    .smy-xl--3 {
      margin-top: -20px !important;
      margin-bottom: -20px !important;
    }
  }
`;
    
export const p_0 = `
  .p-0 {
    padding: 0px !important;
  }
`;
    
export const p_1 = `
  .p-1 {
    padding: 8px !important;
  }
`;
    
export const p_2 = `
  .p-2 {
    padding: 16px !important;
  }
`;
    
export const p_3 = `
  .p-3 {
    padding: 24px !important;
  }
`;
    
export const p_4 = `
  .p-4 {
    padding: 32px !important;
  }
`;
    
export const p_5 = `
  .p-5 {
    padding: 40px !important;
  }
`;
    
export const p_6 = `
  .p-6 {
    padding: 48px !important;
  }
`;
    
export const p_7 = `
  .p-7 {
    padding: 56px !important;
  }
`;
    
export const p_8 = `
  .p-8 {
    padding: 64px !important;
  }
`;
    
export const p__1 = `
  .p--1 {
    padding: -8px !important;
  }
`;
    
export const p__2 = `
  .p--2 {
    padding: -16px !important;
  }
`;
    
export const p__3 = `
  .p--3 {
    padding: -24px !important;
  }
`;
    
export const p__4 = `
  .p--4 {
    padding: -32px !important;
  }
`;
    
export const p__5 = `
  .p--5 {
    padding: -40px !important;
  }
`;
    
export const p__6 = `
  .p--6 {
    padding: -48px !important;
  }
`;
    
export const p__7 = `
  .p--7 {
    padding: -56px !important;
  }
`;
    
export const p__8 = `
  .p--8 {
    padding: -64px !important;
  }
`;
    
export const p_initial = `
  .p-initial {
    padding: initial !important;
  }
`;
    
export const p_lg_0 = `
  @media (min-width: 992px) {
    .p-lg-0 {
      padding: 0px !important;
    }
  }
`;
    
export const p_lg_1 = `
  @media (min-width: 992px) {
    .p-lg-1 {
      padding: 8px !important;
    }
  }
`;
    
export const p_lg_2 = `
  @media (min-width: 992px) {
    .p-lg-2 {
      padding: 16px !important;
    }
  }
`;
    
export const p_lg_3 = `
  @media (min-width: 992px) {
    .p-lg-3 {
      padding: 24px !important;
    }
  }
`;
    
export const p_lg_4 = `
  @media (min-width: 992px) {
    .p-lg-4 {
      padding: 32px !important;
    }
  }
`;
    
export const p_lg_5 = `
  @media (min-width: 992px) {
    .p-lg-5 {
      padding: 40px !important;
    }
  }
`;
    
export const p_lg_6 = `
  @media (min-width: 992px) {
    .p-lg-6 {
      padding: 48px !important;
    }
  }
`;
    
export const p_lg_7 = `
  @media (min-width: 992px) {
    .p-lg-7 {
      padding: 56px !important;
    }
  }
`;
    
export const p_lg_8 = `
  @media (min-width: 992px) {
    .p-lg-8 {
      padding: 64px !important;
    }
  }
`;
    
export const p_lg__1 = `
  @media (min-width: 992px) {
    .p-lg--1 {
      padding: -8px !important;
    }
  }
`;
    
export const p_lg__2 = `
  @media (min-width: 992px) {
    .p-lg--2 {
      padding: -16px !important;
    }
  }
`;
    
export const p_lg__3 = `
  @media (min-width: 992px) {
    .p-lg--3 {
      padding: -24px !important;
    }
  }
`;
    
export const p_lg__4 = `
  @media (min-width: 992px) {
    .p-lg--4 {
      padding: -32px !important;
    }
  }
`;
    
export const p_lg__5 = `
  @media (min-width: 992px) {
    .p-lg--5 {
      padding: -40px !important;
    }
  }
`;
    
export const p_lg__6 = `
  @media (min-width: 992px) {
    .p-lg--6 {
      padding: -48px !important;
    }
  }
`;
    
export const p_lg__7 = `
  @media (min-width: 992px) {
    .p-lg--7 {
      padding: -56px !important;
    }
  }
`;
    
export const p_lg__8 = `
  @media (min-width: 992px) {
    .p-lg--8 {
      padding: -64px !important;
    }
  }
`;
    
export const p_lg_initial = `
  @media (min-width: 992px) {
    .p-lg-initial {
      padding: initial !important;
    }
  }
`;
    
export const p_md_0 = `
  @media (min-width: 768px) {
    .p-md-0 {
      padding: 0px !important;
    }
  }
`;
    
export const p_md_1 = `
  @media (min-width: 768px) {
    .p-md-1 {
      padding: 8px !important;
    }
  }
`;
    
export const p_md_2 = `
  @media (min-width: 768px) {
    .p-md-2 {
      padding: 16px !important;
    }
  }
`;
    
export const p_md_3 = `
  @media (min-width: 768px) {
    .p-md-3 {
      padding: 24px !important;
    }
  }
`;
    
export const p_md_4 = `
  @media (min-width: 768px) {
    .p-md-4 {
      padding: 32px !important;
    }
  }
`;
    
export const p_md_5 = `
  @media (min-width: 768px) {
    .p-md-5 {
      padding: 40px !important;
    }
  }
`;
    
export const p_md_6 = `
  @media (min-width: 768px) {
    .p-md-6 {
      padding: 48px !important;
    }
  }
`;
    
export const p_md_7 = `
  @media (min-width: 768px) {
    .p-md-7 {
      padding: 56px !important;
    }
  }
`;
    
export const p_md_8 = `
  @media (min-width: 768px) {
    .p-md-8 {
      padding: 64px !important;
    }
  }
`;
    
export const p_md__1 = `
  @media (min-width: 768px) {
    .p-md--1 {
      padding: -8px !important;
    }
  }
`;
    
export const p_md__2 = `
  @media (min-width: 768px) {
    .p-md--2 {
      padding: -16px !important;
    }
  }
`;
    
export const p_md__3 = `
  @media (min-width: 768px) {
    .p-md--3 {
      padding: -24px !important;
    }
  }
`;
    
export const p_md__4 = `
  @media (min-width: 768px) {
    .p-md--4 {
      padding: -32px !important;
    }
  }
`;
    
export const p_md__5 = `
  @media (min-width: 768px) {
    .p-md--5 {
      padding: -40px !important;
    }
  }
`;
    
export const p_md__6 = `
  @media (min-width: 768px) {
    .p-md--6 {
      padding: -48px !important;
    }
  }
`;
    
export const p_md__7 = `
  @media (min-width: 768px) {
    .p-md--7 {
      padding: -56px !important;
    }
  }
`;
    
export const p_md__8 = `
  @media (min-width: 768px) {
    .p-md--8 {
      padding: -64px !important;
    }
  }
`;
    
export const p_md_initial = `
  @media (min-width: 768px) {
    .p-md-initial {
      padding: initial !important;
    }
  }
`;
    
export const p_sm_0 = `
  @media (min-width: 576px) {
    .p-sm-0 {
      padding: 0px !important;
    }
  }
`;
    
export const p_sm_1 = `
  @media (min-width: 576px) {
    .p-sm-1 {
      padding: 8px !important;
    }
  }
`;
    
export const p_sm_2 = `
  @media (min-width: 576px) {
    .p-sm-2 {
      padding: 16px !important;
    }
  }
`;
    
export const p_sm_3 = `
  @media (min-width: 576px) {
    .p-sm-3 {
      padding: 24px !important;
    }
  }
`;
    
export const p_sm_4 = `
  @media (min-width: 576px) {
    .p-sm-4 {
      padding: 32px !important;
    }
  }
`;
    
export const p_sm_5 = `
  @media (min-width: 576px) {
    .p-sm-5 {
      padding: 40px !important;
    }
  }
`;
    
export const p_sm_6 = `
  @media (min-width: 576px) {
    .p-sm-6 {
      padding: 48px !important;
    }
  }
`;
    
export const p_sm_7 = `
  @media (min-width: 576px) {
    .p-sm-7 {
      padding: 56px !important;
    }
  }
`;
    
export const p_sm_8 = `
  @media (min-width: 576px) {
    .p-sm-8 {
      padding: 64px !important;
    }
  }
`;
    
export const p_sm__1 = `
  @media (min-width: 576px) {
    .p-sm--1 {
      padding: -8px !important;
    }
  }
`;
    
export const p_sm__2 = `
  @media (min-width: 576px) {
    .p-sm--2 {
      padding: -16px !important;
    }
  }
`;
    
export const p_sm__3 = `
  @media (min-width: 576px) {
    .p-sm--3 {
      padding: -24px !important;
    }
  }
`;
    
export const p_sm__4 = `
  @media (min-width: 576px) {
    .p-sm--4 {
      padding: -32px !important;
    }
  }
`;
    
export const p_sm__5 = `
  @media (min-width: 576px) {
    .p-sm--5 {
      padding: -40px !important;
    }
  }
`;
    
export const p_sm__6 = `
  @media (min-width: 576px) {
    .p-sm--6 {
      padding: -48px !important;
    }
  }
`;
    
export const p_sm__7 = `
  @media (min-width: 576px) {
    .p-sm--7 {
      padding: -56px !important;
    }
  }
`;
    
export const p_sm__8 = `
  @media (min-width: 576px) {
    .p-sm--8 {
      padding: -64px !important;
    }
  }
`;
    
export const p_sm_initial = `
  @media (min-width: 576px) {
    .p-sm-initial {
      padding: initial !important;
    }
  }
`;
    
export const p_xl_0 = `
  @media (min-width: 1320px) {
    .p-xl-0 {
      padding: 0px !important;
    }
  }
`;
    
export const p_xl_1 = `
  @media (min-width: 1320px) {
    .p-xl-1 {
      padding: 8px !important;
    }
  }
`;
    
export const p_xl_2 = `
  @media (min-width: 1320px) {
    .p-xl-2 {
      padding: 16px !important;
    }
  }
`;
    
export const p_xl_3 = `
  @media (min-width: 1320px) {
    .p-xl-3 {
      padding: 24px !important;
    }
  }
`;
    
export const p_xl_4 = `
  @media (min-width: 1320px) {
    .p-xl-4 {
      padding: 32px !important;
    }
  }
`;
    
export const p_xl_5 = `
  @media (min-width: 1320px) {
    .p-xl-5 {
      padding: 40px !important;
    }
  }
`;
    
export const p_xl_6 = `
  @media (min-width: 1320px) {
    .p-xl-6 {
      padding: 48px !important;
    }
  }
`;
    
export const p_xl_7 = `
  @media (min-width: 1320px) {
    .p-xl-7 {
      padding: 56px !important;
    }
  }
`;
    
export const p_xl_8 = `
  @media (min-width: 1320px) {
    .p-xl-8 {
      padding: 64px !important;
    }
  }
`;
    
export const p_xl__1 = `
  @media (min-width: 1320px) {
    .p-xl--1 {
      padding: -8px !important;
    }
  }
`;
    
export const p_xl__2 = `
  @media (min-width: 1320px) {
    .p-xl--2 {
      padding: -16px !important;
    }
  }
`;
    
export const p_xl__3 = `
  @media (min-width: 1320px) {
    .p-xl--3 {
      padding: -24px !important;
    }
  }
`;
    
export const p_xl__4 = `
  @media (min-width: 1320px) {
    .p-xl--4 {
      padding: -32px !important;
    }
  }
`;
    
export const p_xl__5 = `
  @media (min-width: 1320px) {
    .p-xl--5 {
      padding: -40px !important;
    }
  }
`;
    
export const p_xl__6 = `
  @media (min-width: 1320px) {
    .p-xl--6 {
      padding: -48px !important;
    }
  }
`;
    
export const p_xl__7 = `
  @media (min-width: 1320px) {
    .p-xl--7 {
      padding: -56px !important;
    }
  }
`;
    
export const p_xl__8 = `
  @media (min-width: 1320px) {
    .p-xl--8 {
      padding: -64px !important;
    }
  }
`;
    
export const p_xl_initial = `
  @media (min-width: 1320px) {
    .p-xl-initial {
      padding: initial !important;
    }
  }
`;
    
export const pb_0 = `
  .pb-0 {
    padding-bottom: 0px !important;
  }
`;
    
export const pb_1 = `
  .pb-1 {
    padding-bottom: 8px !important;
  }
`;
    
export const pb_2 = `
  .pb-2 {
    padding-bottom: 16px !important;
  }
`;
    
export const pb_3 = `
  .pb-3 {
    padding-bottom: 24px !important;
  }
`;
    
export const pb_4 = `
  .pb-4 {
    padding-bottom: 32px !important;
  }
`;
    
export const pb_5 = `
  .pb-5 {
    padding-bottom: 40px !important;
  }
`;
    
export const pb_6 = `
  .pb-6 {
    padding-bottom: 48px !important;
  }
`;
    
export const pb_7 = `
  .pb-7 {
    padding-bottom: 56px !important;
  }
`;
    
export const pb_8 = `
  .pb-8 {
    padding-bottom: 64px !important;
  }
`;
    
export const pb__1 = `
  .pb--1 {
    padding-bottom: -8px !important;
  }
`;
    
export const pb__2 = `
  .pb--2 {
    padding-bottom: -16px !important;
  }
`;
    
export const pb__3 = `
  .pb--3 {
    padding-bottom: -24px !important;
  }
`;
    
export const pb__4 = `
  .pb--4 {
    padding-bottom: -32px !important;
  }
`;
    
export const pb__5 = `
  .pb--5 {
    padding-bottom: -40px !important;
  }
`;
    
export const pb__6 = `
  .pb--6 {
    padding-bottom: -48px !important;
  }
`;
    
export const pb__7 = `
  .pb--7 {
    padding-bottom: -56px !important;
  }
`;
    
export const pb__8 = `
  .pb--8 {
    padding-bottom: -64px !important;
  }
`;
    
export const pb_initial = `
  .pb-initial {
    padding-bottom: initial !important;
  }
`;
    
export const pb_lg_0 = `
  @media (min-width: 992px) {
    .pb-lg-0 {
      padding-bottom: 0px !important;
    }
  }
`;
    
export const pb_lg_1 = `
  @media (min-width: 992px) {
    .pb-lg-1 {
      padding-bottom: 8px !important;
    }
  }
`;
    
export const pb_lg_2 = `
  @media (min-width: 992px) {
    .pb-lg-2 {
      padding-bottom: 16px !important;
    }
  }
`;
    
export const pb_lg_3 = `
  @media (min-width: 992px) {
    .pb-lg-3 {
      padding-bottom: 24px !important;
    }
  }
`;
    
export const pb_lg_4 = `
  @media (min-width: 992px) {
    .pb-lg-4 {
      padding-bottom: 32px !important;
    }
  }
`;
    
export const pb_lg_5 = `
  @media (min-width: 992px) {
    .pb-lg-5 {
      padding-bottom: 40px !important;
    }
  }
`;
    
export const pb_lg_6 = `
  @media (min-width: 992px) {
    .pb-lg-6 {
      padding-bottom: 48px !important;
    }
  }
`;
    
export const pb_lg_7 = `
  @media (min-width: 992px) {
    .pb-lg-7 {
      padding-bottom: 56px !important;
    }
  }
`;
    
export const pb_lg_8 = `
  @media (min-width: 992px) {
    .pb-lg-8 {
      padding-bottom: 64px !important;
    }
  }
`;
    
export const pb_lg__1 = `
  @media (min-width: 992px) {
    .pb-lg--1 {
      padding-bottom: -8px !important;
    }
  }
`;
    
export const pb_lg__2 = `
  @media (min-width: 992px) {
    .pb-lg--2 {
      padding-bottom: -16px !important;
    }
  }
`;
    
export const pb_lg__3 = `
  @media (min-width: 992px) {
    .pb-lg--3 {
      padding-bottom: -24px !important;
    }
  }
`;
    
export const pb_lg__4 = `
  @media (min-width: 992px) {
    .pb-lg--4 {
      padding-bottom: -32px !important;
    }
  }
`;
    
export const pb_lg__5 = `
  @media (min-width: 992px) {
    .pb-lg--5 {
      padding-bottom: -40px !important;
    }
  }
`;
    
export const pb_lg__6 = `
  @media (min-width: 992px) {
    .pb-lg--6 {
      padding-bottom: -48px !important;
    }
  }
`;
    
export const pb_lg__7 = `
  @media (min-width: 992px) {
    .pb-lg--7 {
      padding-bottom: -56px !important;
    }
  }
`;
    
export const pb_lg__8 = `
  @media (min-width: 992px) {
    .pb-lg--8 {
      padding-bottom: -64px !important;
    }
  }
`;
    
export const pb_lg_initial = `
  @media (min-width: 992px) {
    .pb-lg-initial {
      padding-bottom: initial !important;
    }
  }
`;
    
export const pb_md_0 = `
  @media (min-width: 768px) {
    .pb-md-0 {
      padding-bottom: 0px !important;
    }
  }
`;
    
export const pb_md_1 = `
  @media (min-width: 768px) {
    .pb-md-1 {
      padding-bottom: 8px !important;
    }
  }
`;
    
export const pb_md_2 = `
  @media (min-width: 768px) {
    .pb-md-2 {
      padding-bottom: 16px !important;
    }
  }
`;
    
export const pb_md_3 = `
  @media (min-width: 768px) {
    .pb-md-3 {
      padding-bottom: 24px !important;
    }
  }
`;
    
export const pb_md_4 = `
  @media (min-width: 768px) {
    .pb-md-4 {
      padding-bottom: 32px !important;
    }
  }
`;
    
export const pb_md_5 = `
  @media (min-width: 768px) {
    .pb-md-5 {
      padding-bottom: 40px !important;
    }
  }
`;
    
export const pb_md_6 = `
  @media (min-width: 768px) {
    .pb-md-6 {
      padding-bottom: 48px !important;
    }
  }
`;
    
export const pb_md_7 = `
  @media (min-width: 768px) {
    .pb-md-7 {
      padding-bottom: 56px !important;
    }
  }
`;
    
export const pb_md_8 = `
  @media (min-width: 768px) {
    .pb-md-8 {
      padding-bottom: 64px !important;
    }
  }
`;
    
export const pb_md__1 = `
  @media (min-width: 768px) {
    .pb-md--1 {
      padding-bottom: -8px !important;
    }
  }
`;
    
export const pb_md__2 = `
  @media (min-width: 768px) {
    .pb-md--2 {
      padding-bottom: -16px !important;
    }
  }
`;
    
export const pb_md__3 = `
  @media (min-width: 768px) {
    .pb-md--3 {
      padding-bottom: -24px !important;
    }
  }
`;
    
export const pb_md__4 = `
  @media (min-width: 768px) {
    .pb-md--4 {
      padding-bottom: -32px !important;
    }
  }
`;
    
export const pb_md__5 = `
  @media (min-width: 768px) {
    .pb-md--5 {
      padding-bottom: -40px !important;
    }
  }
`;
    
export const pb_md__6 = `
  @media (min-width: 768px) {
    .pb-md--6 {
      padding-bottom: -48px !important;
    }
  }
`;
    
export const pb_md__7 = `
  @media (min-width: 768px) {
    .pb-md--7 {
      padding-bottom: -56px !important;
    }
  }
`;
    
export const pb_md__8 = `
  @media (min-width: 768px) {
    .pb-md--8 {
      padding-bottom: -64px !important;
    }
  }
`;
    
export const pb_md_initial = `
  @media (min-width: 768px) {
    .pb-md-initial {
      padding-bottom: initial !important;
    }
  }
`;
    
export const pb_sm_0 = `
  @media (min-width: 576px) {
    .pb-sm-0 {
      padding-bottom: 0px !important;
    }
  }
`;
    
export const pb_sm_1 = `
  @media (min-width: 576px) {
    .pb-sm-1 {
      padding-bottom: 8px !important;
    }
  }
`;
    
export const pb_sm_2 = `
  @media (min-width: 576px) {
    .pb-sm-2 {
      padding-bottom: 16px !important;
    }
  }
`;
    
export const pb_sm_3 = `
  @media (min-width: 576px) {
    .pb-sm-3 {
      padding-bottom: 24px !important;
    }
  }
`;
    
export const pb_sm_4 = `
  @media (min-width: 576px) {
    .pb-sm-4 {
      padding-bottom: 32px !important;
    }
  }
`;
    
export const pb_sm_5 = `
  @media (min-width: 576px) {
    .pb-sm-5 {
      padding-bottom: 40px !important;
    }
  }
`;
    
export const pb_sm_6 = `
  @media (min-width: 576px) {
    .pb-sm-6 {
      padding-bottom: 48px !important;
    }
  }
`;
    
export const pb_sm_7 = `
  @media (min-width: 576px) {
    .pb-sm-7 {
      padding-bottom: 56px !important;
    }
  }
`;
    
export const pb_sm_8 = `
  @media (min-width: 576px) {
    .pb-sm-8 {
      padding-bottom: 64px !important;
    }
  }
`;
    
export const pb_sm__1 = `
  @media (min-width: 576px) {
    .pb-sm--1 {
      padding-bottom: -8px !important;
    }
  }
`;
    
export const pb_sm__2 = `
  @media (min-width: 576px) {
    .pb-sm--2 {
      padding-bottom: -16px !important;
    }
  }
`;
    
export const pb_sm__3 = `
  @media (min-width: 576px) {
    .pb-sm--3 {
      padding-bottom: -24px !important;
    }
  }
`;
    
export const pb_sm__4 = `
  @media (min-width: 576px) {
    .pb-sm--4 {
      padding-bottom: -32px !important;
    }
  }
`;
    
export const pb_sm__5 = `
  @media (min-width: 576px) {
    .pb-sm--5 {
      padding-bottom: -40px !important;
    }
  }
`;
    
export const pb_sm__6 = `
  @media (min-width: 576px) {
    .pb-sm--6 {
      padding-bottom: -48px !important;
    }
  }
`;
    
export const pb_sm__7 = `
  @media (min-width: 576px) {
    .pb-sm--7 {
      padding-bottom: -56px !important;
    }
  }
`;
    
export const pb_sm__8 = `
  @media (min-width: 576px) {
    .pb-sm--8 {
      padding-bottom: -64px !important;
    }
  }
`;
    
export const pb_sm_initial = `
  @media (min-width: 576px) {
    .pb-sm-initial {
      padding-bottom: initial !important;
    }
  }
`;
    
export const pb_xl_0 = `
  @media (min-width: 1320px) {
    .pb-xl-0 {
      padding-bottom: 0px !important;
    }
  }
`;
    
export const pb_xl_1 = `
  @media (min-width: 1320px) {
    .pb-xl-1 {
      padding-bottom: 8px !important;
    }
  }
`;
    
export const pb_xl_2 = `
  @media (min-width: 1320px) {
    .pb-xl-2 {
      padding-bottom: 16px !important;
    }
  }
`;
    
export const pb_xl_3 = `
  @media (min-width: 1320px) {
    .pb-xl-3 {
      padding-bottom: 24px !important;
    }
  }
`;
    
export const pb_xl_4 = `
  @media (min-width: 1320px) {
    .pb-xl-4 {
      padding-bottom: 32px !important;
    }
  }
`;
    
export const pb_xl_5 = `
  @media (min-width: 1320px) {
    .pb-xl-5 {
      padding-bottom: 40px !important;
    }
  }
`;
    
export const pb_xl_6 = `
  @media (min-width: 1320px) {
    .pb-xl-6 {
      padding-bottom: 48px !important;
    }
  }
`;
    
export const pb_xl_7 = `
  @media (min-width: 1320px) {
    .pb-xl-7 {
      padding-bottom: 56px !important;
    }
  }
`;
    
export const pb_xl_8 = `
  @media (min-width: 1320px) {
    .pb-xl-8 {
      padding-bottom: 64px !important;
    }
  }
`;
    
export const pb_xl__1 = `
  @media (min-width: 1320px) {
    .pb-xl--1 {
      padding-bottom: -8px !important;
    }
  }
`;
    
export const pb_xl__2 = `
  @media (min-width: 1320px) {
    .pb-xl--2 {
      padding-bottom: -16px !important;
    }
  }
`;
    
export const pb_xl__3 = `
  @media (min-width: 1320px) {
    .pb-xl--3 {
      padding-bottom: -24px !important;
    }
  }
`;
    
export const pb_xl__4 = `
  @media (min-width: 1320px) {
    .pb-xl--4 {
      padding-bottom: -32px !important;
    }
  }
`;
    
export const pb_xl__5 = `
  @media (min-width: 1320px) {
    .pb-xl--5 {
      padding-bottom: -40px !important;
    }
  }
`;
    
export const pb_xl__6 = `
  @media (min-width: 1320px) {
    .pb-xl--6 {
      padding-bottom: -48px !important;
    }
  }
`;
    
export const pb_xl__7 = `
  @media (min-width: 1320px) {
    .pb-xl--7 {
      padding-bottom: -56px !important;
    }
  }
`;
    
export const pb_xl__8 = `
  @media (min-width: 1320px) {
    .pb-xl--8 {
      padding-bottom: -64px !important;
    }
  }
`;
    
export const pb_xl_initial = `
  @media (min-width: 1320px) {
    .pb-xl-initial {
      padding-bottom: initial !important;
    }
  }
`;
    
export const pl_0 = `
  .pl-0 {
    padding-left: 0px !important;
  }
`;
    
export const pl_1 = `
  .pl-1 {
    padding-left: 8px !important;
  }
`;
    
export const pl_2 = `
  .pl-2 {
    padding-left: 16px !important;
  }
`;
    
export const pl_3 = `
  .pl-3 {
    padding-left: 24px !important;
  }
`;
    
export const pl_4 = `
  .pl-4 {
    padding-left: 32px !important;
  }
`;
    
export const pl_5 = `
  .pl-5 {
    padding-left: 40px !important;
  }
`;
    
export const pl_6 = `
  .pl-6 {
    padding-left: 48px !important;
  }
`;
    
export const pl_7 = `
  .pl-7 {
    padding-left: 56px !important;
  }
`;
    
export const pl_8 = `
  .pl-8 {
    padding-left: 64px !important;
  }
`;
    
export const pl__1 = `
  .pl--1 {
    padding-left: -8px !important;
  }
`;
    
export const pl__2 = `
  .pl--2 {
    padding-left: -16px !important;
  }
`;
    
export const pl__3 = `
  .pl--3 {
    padding-left: -24px !important;
  }
`;
    
export const pl__4 = `
  .pl--4 {
    padding-left: -32px !important;
  }
`;
    
export const pl__5 = `
  .pl--5 {
    padding-left: -40px !important;
  }
`;
    
export const pl__6 = `
  .pl--6 {
    padding-left: -48px !important;
  }
`;
    
export const pl__7 = `
  .pl--7 {
    padding-left: -56px !important;
  }
`;
    
export const pl__8 = `
  .pl--8 {
    padding-left: -64px !important;
  }
`;
    
export const pl_initial = `
  .pl-initial {
    padding-left: initial !important;
  }
`;
    
export const pl_lg_0 = `
  @media (min-width: 992px) {
    .pl-lg-0 {
      padding-left: 0px !important;
    }
  }
`;
    
export const pl_lg_1 = `
  @media (min-width: 992px) {
    .pl-lg-1 {
      padding-left: 8px !important;
    }
  }
`;
    
export const pl_lg_2 = `
  @media (min-width: 992px) {
    .pl-lg-2 {
      padding-left: 16px !important;
    }
  }
`;
    
export const pl_lg_3 = `
  @media (min-width: 992px) {
    .pl-lg-3 {
      padding-left: 24px !important;
    }
  }
`;
    
export const pl_lg_4 = `
  @media (min-width: 992px) {
    .pl-lg-4 {
      padding-left: 32px !important;
    }
  }
`;
    
export const pl_lg_5 = `
  @media (min-width: 992px) {
    .pl-lg-5 {
      padding-left: 40px !important;
    }
  }
`;
    
export const pl_lg_6 = `
  @media (min-width: 992px) {
    .pl-lg-6 {
      padding-left: 48px !important;
    }
  }
`;
    
export const pl_lg_7 = `
  @media (min-width: 992px) {
    .pl-lg-7 {
      padding-left: 56px !important;
    }
  }
`;
    
export const pl_lg_8 = `
  @media (min-width: 992px) {
    .pl-lg-8 {
      padding-left: 64px !important;
    }
  }
`;
    
export const pl_lg__1 = `
  @media (min-width: 992px) {
    .pl-lg--1 {
      padding-left: -8px !important;
    }
  }
`;
    
export const pl_lg__2 = `
  @media (min-width: 992px) {
    .pl-lg--2 {
      padding-left: -16px !important;
    }
  }
`;
    
export const pl_lg__3 = `
  @media (min-width: 992px) {
    .pl-lg--3 {
      padding-left: -24px !important;
    }
  }
`;
    
export const pl_lg__4 = `
  @media (min-width: 992px) {
    .pl-lg--4 {
      padding-left: -32px !important;
    }
  }
`;
    
export const pl_lg__5 = `
  @media (min-width: 992px) {
    .pl-lg--5 {
      padding-left: -40px !important;
    }
  }
`;
    
export const pl_lg__6 = `
  @media (min-width: 992px) {
    .pl-lg--6 {
      padding-left: -48px !important;
    }
  }
`;
    
export const pl_lg__7 = `
  @media (min-width: 992px) {
    .pl-lg--7 {
      padding-left: -56px !important;
    }
  }
`;
    
export const pl_lg__8 = `
  @media (min-width: 992px) {
    .pl-lg--8 {
      padding-left: -64px !important;
    }
  }
`;
    
export const pl_lg_initial = `
  @media (min-width: 992px) {
    .pl-lg-initial {
      padding-left: initial !important;
    }
  }
`;
    
export const pl_md_0 = `
  @media (min-width: 768px) {
    .pl-md-0 {
      padding-left: 0px !important;
    }
  }
`;
    
export const pl_md_1 = `
  @media (min-width: 768px) {
    .pl-md-1 {
      padding-left: 8px !important;
    }
  }
`;
    
export const pl_md_2 = `
  @media (min-width: 768px) {
    .pl-md-2 {
      padding-left: 16px !important;
    }
  }
`;
    
export const pl_md_3 = `
  @media (min-width: 768px) {
    .pl-md-3 {
      padding-left: 24px !important;
    }
  }
`;
    
export const pl_md_4 = `
  @media (min-width: 768px) {
    .pl-md-4 {
      padding-left: 32px !important;
    }
  }
`;
    
export const pl_md_5 = `
  @media (min-width: 768px) {
    .pl-md-5 {
      padding-left: 40px !important;
    }
  }
`;
    
export const pl_md_6 = `
  @media (min-width: 768px) {
    .pl-md-6 {
      padding-left: 48px !important;
    }
  }
`;
    
export const pl_md_7 = `
  @media (min-width: 768px) {
    .pl-md-7 {
      padding-left: 56px !important;
    }
  }
`;
    
export const pl_md_8 = `
  @media (min-width: 768px) {
    .pl-md-8 {
      padding-left: 64px !important;
    }
  }
`;
    
export const pl_md__1 = `
  @media (min-width: 768px) {
    .pl-md--1 {
      padding-left: -8px !important;
    }
  }
`;
    
export const pl_md__2 = `
  @media (min-width: 768px) {
    .pl-md--2 {
      padding-left: -16px !important;
    }
  }
`;
    
export const pl_md__3 = `
  @media (min-width: 768px) {
    .pl-md--3 {
      padding-left: -24px !important;
    }
  }
`;
    
export const pl_md__4 = `
  @media (min-width: 768px) {
    .pl-md--4 {
      padding-left: -32px !important;
    }
  }
`;
    
export const pl_md__5 = `
  @media (min-width: 768px) {
    .pl-md--5 {
      padding-left: -40px !important;
    }
  }
`;
    
export const pl_md__6 = `
  @media (min-width: 768px) {
    .pl-md--6 {
      padding-left: -48px !important;
    }
  }
`;
    
export const pl_md__7 = `
  @media (min-width: 768px) {
    .pl-md--7 {
      padding-left: -56px !important;
    }
  }
`;
    
export const pl_md__8 = `
  @media (min-width: 768px) {
    .pl-md--8 {
      padding-left: -64px !important;
    }
  }
`;
    
export const pl_md_initial = `
  @media (min-width: 768px) {
    .pl-md-initial {
      padding-left: initial !important;
    }
  }
`;
    
export const pl_sm_0 = `
  @media (min-width: 576px) {
    .pl-sm-0 {
      padding-left: 0px !important;
    }
  }
`;
    
export const pl_sm_1 = `
  @media (min-width: 576px) {
    .pl-sm-1 {
      padding-left: 8px !important;
    }
  }
`;
    
export const pl_sm_2 = `
  @media (min-width: 576px) {
    .pl-sm-2 {
      padding-left: 16px !important;
    }
  }
`;
    
export const pl_sm_3 = `
  @media (min-width: 576px) {
    .pl-sm-3 {
      padding-left: 24px !important;
    }
  }
`;
    
export const pl_sm_4 = `
  @media (min-width: 576px) {
    .pl-sm-4 {
      padding-left: 32px !important;
    }
  }
`;
    
export const pl_sm_5 = `
  @media (min-width: 576px) {
    .pl-sm-5 {
      padding-left: 40px !important;
    }
  }
`;
    
export const pl_sm_6 = `
  @media (min-width: 576px) {
    .pl-sm-6 {
      padding-left: 48px !important;
    }
  }
`;
    
export const pl_sm_7 = `
  @media (min-width: 576px) {
    .pl-sm-7 {
      padding-left: 56px !important;
    }
  }
`;
    
export const pl_sm_8 = `
  @media (min-width: 576px) {
    .pl-sm-8 {
      padding-left: 64px !important;
    }
  }
`;
    
export const pl_sm__1 = `
  @media (min-width: 576px) {
    .pl-sm--1 {
      padding-left: -8px !important;
    }
  }
`;
    
export const pl_sm__2 = `
  @media (min-width: 576px) {
    .pl-sm--2 {
      padding-left: -16px !important;
    }
  }
`;
    
export const pl_sm__3 = `
  @media (min-width: 576px) {
    .pl-sm--3 {
      padding-left: -24px !important;
    }
  }
`;
    
export const pl_sm__4 = `
  @media (min-width: 576px) {
    .pl-sm--4 {
      padding-left: -32px !important;
    }
  }
`;
    
export const pl_sm__5 = `
  @media (min-width: 576px) {
    .pl-sm--5 {
      padding-left: -40px !important;
    }
  }
`;
    
export const pl_sm__6 = `
  @media (min-width: 576px) {
    .pl-sm--6 {
      padding-left: -48px !important;
    }
  }
`;
    
export const pl_sm__7 = `
  @media (min-width: 576px) {
    .pl-sm--7 {
      padding-left: -56px !important;
    }
  }
`;
    
export const pl_sm__8 = `
  @media (min-width: 576px) {
    .pl-sm--8 {
      padding-left: -64px !important;
    }
  }
`;
    
export const pl_sm_initial = `
  @media (min-width: 576px) {
    .pl-sm-initial {
      padding-left: initial !important;
    }
  }
`;
    
export const pl_xl_0 = `
  @media (min-width: 1320px) {
    .pl-xl-0 {
      padding-left: 0px !important;
    }
  }
`;
    
export const pl_xl_1 = `
  @media (min-width: 1320px) {
    .pl-xl-1 {
      padding-left: 8px !important;
    }
  }
`;
    
export const pl_xl_2 = `
  @media (min-width: 1320px) {
    .pl-xl-2 {
      padding-left: 16px !important;
    }
  }
`;
    
export const pl_xl_3 = `
  @media (min-width: 1320px) {
    .pl-xl-3 {
      padding-left: 24px !important;
    }
  }
`;
    
export const pl_xl_4 = `
  @media (min-width: 1320px) {
    .pl-xl-4 {
      padding-left: 32px !important;
    }
  }
`;
    
export const pl_xl_5 = `
  @media (min-width: 1320px) {
    .pl-xl-5 {
      padding-left: 40px !important;
    }
  }
`;
    
export const pl_xl_6 = `
  @media (min-width: 1320px) {
    .pl-xl-6 {
      padding-left: 48px !important;
    }
  }
`;
    
export const pl_xl_7 = `
  @media (min-width: 1320px) {
    .pl-xl-7 {
      padding-left: 56px !important;
    }
  }
`;
    
export const pl_xl_8 = `
  @media (min-width: 1320px) {
    .pl-xl-8 {
      padding-left: 64px !important;
    }
  }
`;
    
export const pl_xl__1 = `
  @media (min-width: 1320px) {
    .pl-xl--1 {
      padding-left: -8px !important;
    }
  }
`;
    
export const pl_xl__2 = `
  @media (min-width: 1320px) {
    .pl-xl--2 {
      padding-left: -16px !important;
    }
  }
`;
    
export const pl_xl__3 = `
  @media (min-width: 1320px) {
    .pl-xl--3 {
      padding-left: -24px !important;
    }
  }
`;
    
export const pl_xl__4 = `
  @media (min-width: 1320px) {
    .pl-xl--4 {
      padding-left: -32px !important;
    }
  }
`;
    
export const pl_xl__5 = `
  @media (min-width: 1320px) {
    .pl-xl--5 {
      padding-left: -40px !important;
    }
  }
`;
    
export const pl_xl__6 = `
  @media (min-width: 1320px) {
    .pl-xl--6 {
      padding-left: -48px !important;
    }
  }
`;
    
export const pl_xl__7 = `
  @media (min-width: 1320px) {
    .pl-xl--7 {
      padding-left: -56px !important;
    }
  }
`;
    
export const pl_xl__8 = `
  @media (min-width: 1320px) {
    .pl-xl--8 {
      padding-left: -64px !important;
    }
  }
`;
    
export const pl_xl_initial = `
  @media (min-width: 1320px) {
    .pl-xl-initial {
      padding-left: initial !important;
    }
  }
`;
    
export const pr_0 = `
  .pr-0 {
    padding-right: 0px !important;
  }
`;
    
export const pr_1 = `
  .pr-1 {
    padding-right: 8px !important;
  }
`;
    
export const pr_2 = `
  .pr-2 {
    padding-right: 16px !important;
  }
`;
    
export const pr_3 = `
  .pr-3 {
    padding-right: 24px !important;
  }
`;
    
export const pr_4 = `
  .pr-4 {
    padding-right: 32px !important;
  }
`;
    
export const pr_5 = `
  .pr-5 {
    padding-right: 40px !important;
  }
`;
    
export const pr_6 = `
  .pr-6 {
    padding-right: 48px !important;
  }
`;
    
export const pr_7 = `
  .pr-7 {
    padding-right: 56px !important;
  }
`;
    
export const pr_8 = `
  .pr-8 {
    padding-right: 64px !important;
  }
`;
    
export const pr__1 = `
  .pr--1 {
    padding-right: -8px !important;
  }
`;
    
export const pr__2 = `
  .pr--2 {
    padding-right: -16px !important;
  }
`;
    
export const pr__3 = `
  .pr--3 {
    padding-right: -24px !important;
  }
`;
    
export const pr__4 = `
  .pr--4 {
    padding-right: -32px !important;
  }
`;
    
export const pr__5 = `
  .pr--5 {
    padding-right: -40px !important;
  }
`;
    
export const pr__6 = `
  .pr--6 {
    padding-right: -48px !important;
  }
`;
    
export const pr__7 = `
  .pr--7 {
    padding-right: -56px !important;
  }
`;
    
export const pr__8 = `
  .pr--8 {
    padding-right: -64px !important;
  }
`;
    
export const pr_initial = `
  .pr-initial {
    padding-right: initial !important;
  }
`;
    
export const pr_lg_0 = `
  @media (min-width: 992px) {
    .pr-lg-0 {
      padding-right: 0px !important;
    }
  }
`;
    
export const pr_lg_1 = `
  @media (min-width: 992px) {
    .pr-lg-1 {
      padding-right: 8px !important;
    }
  }
`;
    
export const pr_lg_2 = `
  @media (min-width: 992px) {
    .pr-lg-2 {
      padding-right: 16px !important;
    }
  }
`;
    
export const pr_lg_3 = `
  @media (min-width: 992px) {
    .pr-lg-3 {
      padding-right: 24px !important;
    }
  }
`;
    
export const pr_lg_4 = `
  @media (min-width: 992px) {
    .pr-lg-4 {
      padding-right: 32px !important;
    }
  }
`;
    
export const pr_lg_5 = `
  @media (min-width: 992px) {
    .pr-lg-5 {
      padding-right: 40px !important;
    }
  }
`;
    
export const pr_lg_6 = `
  @media (min-width: 992px) {
    .pr-lg-6 {
      padding-right: 48px !important;
    }
  }
`;
    
export const pr_lg_7 = `
  @media (min-width: 992px) {
    .pr-lg-7 {
      padding-right: 56px !important;
    }
  }
`;
    
export const pr_lg_8 = `
  @media (min-width: 992px) {
    .pr-lg-8 {
      padding-right: 64px !important;
    }
  }
`;
    
export const pr_lg__1 = `
  @media (min-width: 992px) {
    .pr-lg--1 {
      padding-right: -8px !important;
    }
  }
`;
    
export const pr_lg__2 = `
  @media (min-width: 992px) {
    .pr-lg--2 {
      padding-right: -16px !important;
    }
  }
`;
    
export const pr_lg__3 = `
  @media (min-width: 992px) {
    .pr-lg--3 {
      padding-right: -24px !important;
    }
  }
`;
    
export const pr_lg__4 = `
  @media (min-width: 992px) {
    .pr-lg--4 {
      padding-right: -32px !important;
    }
  }
`;
    
export const pr_lg__5 = `
  @media (min-width: 992px) {
    .pr-lg--5 {
      padding-right: -40px !important;
    }
  }
`;
    
export const pr_lg__6 = `
  @media (min-width: 992px) {
    .pr-lg--6 {
      padding-right: -48px !important;
    }
  }
`;
    
export const pr_lg__7 = `
  @media (min-width: 992px) {
    .pr-lg--7 {
      padding-right: -56px !important;
    }
  }
`;
    
export const pr_lg__8 = `
  @media (min-width: 992px) {
    .pr-lg--8 {
      padding-right: -64px !important;
    }
  }
`;
    
export const pr_lg_initial = `
  @media (min-width: 992px) {
    .pr-lg-initial {
      padding-right: initial !important;
    }
  }
`;
    
export const pr_md_0 = `
  @media (min-width: 768px) {
    .pr-md-0 {
      padding-right: 0px !important;
    }
  }
`;
    
export const pr_md_1 = `
  @media (min-width: 768px) {
    .pr-md-1 {
      padding-right: 8px !important;
    }
  }
`;
    
export const pr_md_2 = `
  @media (min-width: 768px) {
    .pr-md-2 {
      padding-right: 16px !important;
    }
  }
`;
    
export const pr_md_3 = `
  @media (min-width: 768px) {
    .pr-md-3 {
      padding-right: 24px !important;
    }
  }
`;
    
export const pr_md_4 = `
  @media (min-width: 768px) {
    .pr-md-4 {
      padding-right: 32px !important;
    }
  }
`;
    
export const pr_md_5 = `
  @media (min-width: 768px) {
    .pr-md-5 {
      padding-right: 40px !important;
    }
  }
`;
    
export const pr_md_6 = `
  @media (min-width: 768px) {
    .pr-md-6 {
      padding-right: 48px !important;
    }
  }
`;
    
export const pr_md_7 = `
  @media (min-width: 768px) {
    .pr-md-7 {
      padding-right: 56px !important;
    }
  }
`;
    
export const pr_md_8 = `
  @media (min-width: 768px) {
    .pr-md-8 {
      padding-right: 64px !important;
    }
  }
`;
    
export const pr_md__1 = `
  @media (min-width: 768px) {
    .pr-md--1 {
      padding-right: -8px !important;
    }
  }
`;
    
export const pr_md__2 = `
  @media (min-width: 768px) {
    .pr-md--2 {
      padding-right: -16px !important;
    }
  }
`;
    
export const pr_md__3 = `
  @media (min-width: 768px) {
    .pr-md--3 {
      padding-right: -24px !important;
    }
  }
`;
    
export const pr_md__4 = `
  @media (min-width: 768px) {
    .pr-md--4 {
      padding-right: -32px !important;
    }
  }
`;
    
export const pr_md__5 = `
  @media (min-width: 768px) {
    .pr-md--5 {
      padding-right: -40px !important;
    }
  }
`;
    
export const pr_md__6 = `
  @media (min-width: 768px) {
    .pr-md--6 {
      padding-right: -48px !important;
    }
  }
`;
    
export const pr_md__7 = `
  @media (min-width: 768px) {
    .pr-md--7 {
      padding-right: -56px !important;
    }
  }
`;
    
export const pr_md__8 = `
  @media (min-width: 768px) {
    .pr-md--8 {
      padding-right: -64px !important;
    }
  }
`;
    
export const pr_md_initial = `
  @media (min-width: 768px) {
    .pr-md-initial {
      padding-right: initial !important;
    }
  }
`;
    
export const pr_sm_0 = `
  @media (min-width: 576px) {
    .pr-sm-0 {
      padding-right: 0px !important;
    }
  }
`;
    
export const pr_sm_1 = `
  @media (min-width: 576px) {
    .pr-sm-1 {
      padding-right: 8px !important;
    }
  }
`;
    
export const pr_sm_2 = `
  @media (min-width: 576px) {
    .pr-sm-2 {
      padding-right: 16px !important;
    }
  }
`;
    
export const pr_sm_3 = `
  @media (min-width: 576px) {
    .pr-sm-3 {
      padding-right: 24px !important;
    }
  }
`;
    
export const pr_sm_4 = `
  @media (min-width: 576px) {
    .pr-sm-4 {
      padding-right: 32px !important;
    }
  }
`;
    
export const pr_sm_5 = `
  @media (min-width: 576px) {
    .pr-sm-5 {
      padding-right: 40px !important;
    }
  }
`;
    
export const pr_sm_6 = `
  @media (min-width: 576px) {
    .pr-sm-6 {
      padding-right: 48px !important;
    }
  }
`;
    
export const pr_sm_7 = `
  @media (min-width: 576px) {
    .pr-sm-7 {
      padding-right: 56px !important;
    }
  }
`;
    
export const pr_sm_8 = `
  @media (min-width: 576px) {
    .pr-sm-8 {
      padding-right: 64px !important;
    }
  }
`;
    
export const pr_sm__1 = `
  @media (min-width: 576px) {
    .pr-sm--1 {
      padding-right: -8px !important;
    }
  }
`;
    
export const pr_sm__2 = `
  @media (min-width: 576px) {
    .pr-sm--2 {
      padding-right: -16px !important;
    }
  }
`;
    
export const pr_sm__3 = `
  @media (min-width: 576px) {
    .pr-sm--3 {
      padding-right: -24px !important;
    }
  }
`;
    
export const pr_sm__4 = `
  @media (min-width: 576px) {
    .pr-sm--4 {
      padding-right: -32px !important;
    }
  }
`;
    
export const pr_sm__5 = `
  @media (min-width: 576px) {
    .pr-sm--5 {
      padding-right: -40px !important;
    }
  }
`;
    
export const pr_sm__6 = `
  @media (min-width: 576px) {
    .pr-sm--6 {
      padding-right: -48px !important;
    }
  }
`;
    
export const pr_sm__7 = `
  @media (min-width: 576px) {
    .pr-sm--7 {
      padding-right: -56px !important;
    }
  }
`;
    
export const pr_sm__8 = `
  @media (min-width: 576px) {
    .pr-sm--8 {
      padding-right: -64px !important;
    }
  }
`;
    
export const pr_sm_initial = `
  @media (min-width: 576px) {
    .pr-sm-initial {
      padding-right: initial !important;
    }
  }
`;
    
export const pr_xl_0 = `
  @media (min-width: 1320px) {
    .pr-xl-0 {
      padding-right: 0px !important;
    }
  }
`;
    
export const pr_xl_1 = `
  @media (min-width: 1320px) {
    .pr-xl-1 {
      padding-right: 8px !important;
    }
  }
`;
    
export const pr_xl_2 = `
  @media (min-width: 1320px) {
    .pr-xl-2 {
      padding-right: 16px !important;
    }
  }
`;
    
export const pr_xl_3 = `
  @media (min-width: 1320px) {
    .pr-xl-3 {
      padding-right: 24px !important;
    }
  }
`;
    
export const pr_xl_4 = `
  @media (min-width: 1320px) {
    .pr-xl-4 {
      padding-right: 32px !important;
    }
  }
`;
    
export const pr_xl_5 = `
  @media (min-width: 1320px) {
    .pr-xl-5 {
      padding-right: 40px !important;
    }
  }
`;
    
export const pr_xl_6 = `
  @media (min-width: 1320px) {
    .pr-xl-6 {
      padding-right: 48px !important;
    }
  }
`;
    
export const pr_xl_7 = `
  @media (min-width: 1320px) {
    .pr-xl-7 {
      padding-right: 56px !important;
    }
  }
`;
    
export const pr_xl_8 = `
  @media (min-width: 1320px) {
    .pr-xl-8 {
      padding-right: 64px !important;
    }
  }
`;
    
export const pr_xl__1 = `
  @media (min-width: 1320px) {
    .pr-xl--1 {
      padding-right: -8px !important;
    }
  }
`;
    
export const pr_xl__2 = `
  @media (min-width: 1320px) {
    .pr-xl--2 {
      padding-right: -16px !important;
    }
  }
`;
    
export const pr_xl__3 = `
  @media (min-width: 1320px) {
    .pr-xl--3 {
      padding-right: -24px !important;
    }
  }
`;
    
export const pr_xl__4 = `
  @media (min-width: 1320px) {
    .pr-xl--4 {
      padding-right: -32px !important;
    }
  }
`;
    
export const pr_xl__5 = `
  @media (min-width: 1320px) {
    .pr-xl--5 {
      padding-right: -40px !important;
    }
  }
`;
    
export const pr_xl__6 = `
  @media (min-width: 1320px) {
    .pr-xl--6 {
      padding-right: -48px !important;
    }
  }
`;
    
export const pr_xl__7 = `
  @media (min-width: 1320px) {
    .pr-xl--7 {
      padding-right: -56px !important;
    }
  }
`;
    
export const pr_xl__8 = `
  @media (min-width: 1320px) {
    .pr-xl--8 {
      padding-right: -64px !important;
    }
  }
`;
    
export const pr_xl_initial = `
  @media (min-width: 1320px) {
    .pr-xl-initial {
      padding-right: initial !important;
    }
  }
`;
    
export const pt_0 = `
  .pt-0 {
    padding-top: 0px !important;
  }
`;
    
export const pt_1 = `
  .pt-1 {
    padding-top: 8px !important;
  }
`;
    
export const pt_2 = `
  .pt-2 {
    padding-top: 16px !important;
  }
`;
    
export const pt_3 = `
  .pt-3 {
    padding-top: 24px !important;
  }
`;
    
export const pt_4 = `
  .pt-4 {
    padding-top: 32px !important;
  }
`;
    
export const pt_5 = `
  .pt-5 {
    padding-top: 40px !important;
  }
`;
    
export const pt_6 = `
  .pt-6 {
    padding-top: 48px !important;
  }
`;
    
export const pt_7 = `
  .pt-7 {
    padding-top: 56px !important;
  }
`;
    
export const pt_8 = `
  .pt-8 {
    padding-top: 64px !important;
  }
`;
    
export const pt__1 = `
  .pt--1 {
    padding-top: -8px !important;
  }
`;
    
export const pt__2 = `
  .pt--2 {
    padding-top: -16px !important;
  }
`;
    
export const pt__3 = `
  .pt--3 {
    padding-top: -24px !important;
  }
`;
    
export const pt__4 = `
  .pt--4 {
    padding-top: -32px !important;
  }
`;
    
export const pt__5 = `
  .pt--5 {
    padding-top: -40px !important;
  }
`;
    
export const pt__6 = `
  .pt--6 {
    padding-top: -48px !important;
  }
`;
    
export const pt__7 = `
  .pt--7 {
    padding-top: -56px !important;
  }
`;
    
export const pt__8 = `
  .pt--8 {
    padding-top: -64px !important;
  }
`;
    
export const pt_initial = `
  .pt-initial {
    padding-top: initial !important;
  }
`;
    
export const pt_lg_0 = `
  @media (min-width: 992px) {
    .pt-lg-0 {
      padding-top: 0px !important;
    }
  }
`;
    
export const pt_lg_1 = `
  @media (min-width: 992px) {
    .pt-lg-1 {
      padding-top: 8px !important;
    }
  }
`;
    
export const pt_lg_2 = `
  @media (min-width: 992px) {
    .pt-lg-2 {
      padding-top: 16px !important;
    }
  }
`;
    
export const pt_lg_3 = `
  @media (min-width: 992px) {
    .pt-lg-3 {
      padding-top: 24px !important;
    }
  }
`;
    
export const pt_lg_4 = `
  @media (min-width: 992px) {
    .pt-lg-4 {
      padding-top: 32px !important;
    }
  }
`;
    
export const pt_lg_5 = `
  @media (min-width: 992px) {
    .pt-lg-5 {
      padding-top: 40px !important;
    }
  }
`;
    
export const pt_lg_6 = `
  @media (min-width: 992px) {
    .pt-lg-6 {
      padding-top: 48px !important;
    }
  }
`;
    
export const pt_lg_7 = `
  @media (min-width: 992px) {
    .pt-lg-7 {
      padding-top: 56px !important;
    }
  }
`;
    
export const pt_lg_8 = `
  @media (min-width: 992px) {
    .pt-lg-8 {
      padding-top: 64px !important;
    }
  }
`;
    
export const pt_lg__1 = `
  @media (min-width: 992px) {
    .pt-lg--1 {
      padding-top: -8px !important;
    }
  }
`;
    
export const pt_lg__2 = `
  @media (min-width: 992px) {
    .pt-lg--2 {
      padding-top: -16px !important;
    }
  }
`;
    
export const pt_lg__3 = `
  @media (min-width: 992px) {
    .pt-lg--3 {
      padding-top: -24px !important;
    }
  }
`;
    
export const pt_lg__4 = `
  @media (min-width: 992px) {
    .pt-lg--4 {
      padding-top: -32px !important;
    }
  }
`;
    
export const pt_lg__5 = `
  @media (min-width: 992px) {
    .pt-lg--5 {
      padding-top: -40px !important;
    }
  }
`;
    
export const pt_lg__6 = `
  @media (min-width: 992px) {
    .pt-lg--6 {
      padding-top: -48px !important;
    }
  }
`;
    
export const pt_lg__7 = `
  @media (min-width: 992px) {
    .pt-lg--7 {
      padding-top: -56px !important;
    }
  }
`;
    
export const pt_lg__8 = `
  @media (min-width: 992px) {
    .pt-lg--8 {
      padding-top: -64px !important;
    }
  }
`;
    
export const pt_lg_initial = `
  @media (min-width: 992px) {
    .pt-lg-initial {
      padding-top: initial !important;
    }
  }
`;
    
export const pt_md_0 = `
  @media (min-width: 768px) {
    .pt-md-0 {
      padding-top: 0px !important;
    }
  }
`;
    
export const pt_md_1 = `
  @media (min-width: 768px) {
    .pt-md-1 {
      padding-top: 8px !important;
    }
  }
`;
    
export const pt_md_2 = `
  @media (min-width: 768px) {
    .pt-md-2 {
      padding-top: 16px !important;
    }
  }
`;
    
export const pt_md_3 = `
  @media (min-width: 768px) {
    .pt-md-3 {
      padding-top: 24px !important;
    }
  }
`;
    
export const pt_md_4 = `
  @media (min-width: 768px) {
    .pt-md-4 {
      padding-top: 32px !important;
    }
  }
`;
    
export const pt_md_5 = `
  @media (min-width: 768px) {
    .pt-md-5 {
      padding-top: 40px !important;
    }
  }
`;
    
export const pt_md_6 = `
  @media (min-width: 768px) {
    .pt-md-6 {
      padding-top: 48px !important;
    }
  }
`;
    
export const pt_md_7 = `
  @media (min-width: 768px) {
    .pt-md-7 {
      padding-top: 56px !important;
    }
  }
`;
    
export const pt_md_8 = `
  @media (min-width: 768px) {
    .pt-md-8 {
      padding-top: 64px !important;
    }
  }
`;
    
export const pt_md__1 = `
  @media (min-width: 768px) {
    .pt-md--1 {
      padding-top: -8px !important;
    }
  }
`;
    
export const pt_md__2 = `
  @media (min-width: 768px) {
    .pt-md--2 {
      padding-top: -16px !important;
    }
  }
`;
    
export const pt_md__3 = `
  @media (min-width: 768px) {
    .pt-md--3 {
      padding-top: -24px !important;
    }
  }
`;
    
export const pt_md__4 = `
  @media (min-width: 768px) {
    .pt-md--4 {
      padding-top: -32px !important;
    }
  }
`;
    
export const pt_md__5 = `
  @media (min-width: 768px) {
    .pt-md--5 {
      padding-top: -40px !important;
    }
  }
`;
    
export const pt_md__6 = `
  @media (min-width: 768px) {
    .pt-md--6 {
      padding-top: -48px !important;
    }
  }
`;
    
export const pt_md__7 = `
  @media (min-width: 768px) {
    .pt-md--7 {
      padding-top: -56px !important;
    }
  }
`;
    
export const pt_md__8 = `
  @media (min-width: 768px) {
    .pt-md--8 {
      padding-top: -64px !important;
    }
  }
`;
    
export const pt_md_initial = `
  @media (min-width: 768px) {
    .pt-md-initial {
      padding-top: initial !important;
    }
  }
`;
    
export const pt_sm_0 = `
  @media (min-width: 576px) {
    .pt-sm-0 {
      padding-top: 0px !important;
    }
  }
`;
    
export const pt_sm_1 = `
  @media (min-width: 576px) {
    .pt-sm-1 {
      padding-top: 8px !important;
    }
  }
`;
    
export const pt_sm_2 = `
  @media (min-width: 576px) {
    .pt-sm-2 {
      padding-top: 16px !important;
    }
  }
`;
    
export const pt_sm_3 = `
  @media (min-width: 576px) {
    .pt-sm-3 {
      padding-top: 24px !important;
    }
  }
`;
    
export const pt_sm_4 = `
  @media (min-width: 576px) {
    .pt-sm-4 {
      padding-top: 32px !important;
    }
  }
`;
    
export const pt_sm_5 = `
  @media (min-width: 576px) {
    .pt-sm-5 {
      padding-top: 40px !important;
    }
  }
`;
    
export const pt_sm_6 = `
  @media (min-width: 576px) {
    .pt-sm-6 {
      padding-top: 48px !important;
    }
  }
`;
    
export const pt_sm_7 = `
  @media (min-width: 576px) {
    .pt-sm-7 {
      padding-top: 56px !important;
    }
  }
`;
    
export const pt_sm_8 = `
  @media (min-width: 576px) {
    .pt-sm-8 {
      padding-top: 64px !important;
    }
  }
`;
    
export const pt_sm__1 = `
  @media (min-width: 576px) {
    .pt-sm--1 {
      padding-top: -8px !important;
    }
  }
`;
    
export const pt_sm__2 = `
  @media (min-width: 576px) {
    .pt-sm--2 {
      padding-top: -16px !important;
    }
  }
`;
    
export const pt_sm__3 = `
  @media (min-width: 576px) {
    .pt-sm--3 {
      padding-top: -24px !important;
    }
  }
`;
    
export const pt_sm__4 = `
  @media (min-width: 576px) {
    .pt-sm--4 {
      padding-top: -32px !important;
    }
  }
`;
    
export const pt_sm__5 = `
  @media (min-width: 576px) {
    .pt-sm--5 {
      padding-top: -40px !important;
    }
  }
`;
    
export const pt_sm__6 = `
  @media (min-width: 576px) {
    .pt-sm--6 {
      padding-top: -48px !important;
    }
  }
`;
    
export const pt_sm__7 = `
  @media (min-width: 576px) {
    .pt-sm--7 {
      padding-top: -56px !important;
    }
  }
`;
    
export const pt_sm__8 = `
  @media (min-width: 576px) {
    .pt-sm--8 {
      padding-top: -64px !important;
    }
  }
`;
    
export const pt_sm_initial = `
  @media (min-width: 576px) {
    .pt-sm-initial {
      padding-top: initial !important;
    }
  }
`;
    
export const pt_xl_0 = `
  @media (min-width: 1320px) {
    .pt-xl-0 {
      padding-top: 0px !important;
    }
  }
`;
    
export const pt_xl_1 = `
  @media (min-width: 1320px) {
    .pt-xl-1 {
      padding-top: 8px !important;
    }
  }
`;
    
export const pt_xl_2 = `
  @media (min-width: 1320px) {
    .pt-xl-2 {
      padding-top: 16px !important;
    }
  }
`;
    
export const pt_xl_3 = `
  @media (min-width: 1320px) {
    .pt-xl-3 {
      padding-top: 24px !important;
    }
  }
`;
    
export const pt_xl_4 = `
  @media (min-width: 1320px) {
    .pt-xl-4 {
      padding-top: 32px !important;
    }
  }
`;
    
export const pt_xl_5 = `
  @media (min-width: 1320px) {
    .pt-xl-5 {
      padding-top: 40px !important;
    }
  }
`;
    
export const pt_xl_6 = `
  @media (min-width: 1320px) {
    .pt-xl-6 {
      padding-top: 48px !important;
    }
  }
`;
    
export const pt_xl_7 = `
  @media (min-width: 1320px) {
    .pt-xl-7 {
      padding-top: 56px !important;
    }
  }
`;
    
export const pt_xl_8 = `
  @media (min-width: 1320px) {
    .pt-xl-8 {
      padding-top: 64px !important;
    }
  }
`;
    
export const pt_xl__1 = `
  @media (min-width: 1320px) {
    .pt-xl--1 {
      padding-top: -8px !important;
    }
  }
`;
    
export const pt_xl__2 = `
  @media (min-width: 1320px) {
    .pt-xl--2 {
      padding-top: -16px !important;
    }
  }
`;
    
export const pt_xl__3 = `
  @media (min-width: 1320px) {
    .pt-xl--3 {
      padding-top: -24px !important;
    }
  }
`;
    
export const pt_xl__4 = `
  @media (min-width: 1320px) {
    .pt-xl--4 {
      padding-top: -32px !important;
    }
  }
`;
    
export const pt_xl__5 = `
  @media (min-width: 1320px) {
    .pt-xl--5 {
      padding-top: -40px !important;
    }
  }
`;
    
export const pt_xl__6 = `
  @media (min-width: 1320px) {
    .pt-xl--6 {
      padding-top: -48px !important;
    }
  }
`;
    
export const pt_xl__7 = `
  @media (min-width: 1320px) {
    .pt-xl--7 {
      padding-top: -56px !important;
    }
  }
`;
    
export const pt_xl__8 = `
  @media (min-width: 1320px) {
    .pt-xl--8 {
      padding-top: -64px !important;
    }
  }
`;
    
export const pt_xl_initial = `
  @media (min-width: 1320px) {
    .pt-xl-initial {
      padding-top: initial !important;
    }
  }
`;
    
export const px_0 = `
  .px-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
`;
    
export const px_1 = `
  .px-1 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
`;
    
export const px_2 = `
  .px-2 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
`;
    
export const px_3 = `
  .px-3 {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
`;
    
export const px_4 = `
  .px-4 {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
`;
    
export const px_5 = `
  .px-5 {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
`;
    
export const px_6 = `
  .px-6 {
    padding-left: 48px !important;
    padding-right: 48px !important;
  }
`;
    
export const px_7 = `
  .px-7 {
    padding-left: 56px !important;
    padding-right: 56px !important;
  }
`;
    
export const px_8 = `
  .px-8 {
    padding-left: 64px !important;
    padding-right: 64px !important;
  }
`;
    
export const px__1 = `
  .px--1 {
    padding-left: -8px !important;
    padding-right: -8px !important;
  }
`;
    
export const px__2 = `
  .px--2 {
    padding-left: -16px !important;
    padding-right: -16px !important;
  }
`;
    
export const px__3 = `
  .px--3 {
    padding-left: -24px !important;
    padding-right: -24px !important;
  }
`;
    
export const px__4 = `
  .px--4 {
    padding-left: -32px !important;
    padding-right: -32px !important;
  }
`;
    
export const px__5 = `
  .px--5 {
    padding-left: -40px !important;
    padding-right: -40px !important;
  }
`;
    
export const px__6 = `
  .px--6 {
    padding-left: -48px !important;
    padding-right: -48px !important;
  }
`;
    
export const px__7 = `
  .px--7 {
    padding-left: -56px !important;
    padding-right: -56px !important;
  }
`;
    
export const px__8 = `
  .px--8 {
    padding-left: -64px !important;
    padding-right: -64px !important;
  }
`;
    
export const px_initial = `
  .px-initial {
    padding-left: initial !important;
    padding-right: initial !important;
  }
`;
    
export const px_lg_0 = `
  @media (min-width: 992px) {
    .px-lg-0 {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
`;
    
export const px_lg_1 = `
  @media (min-width: 992px) {
    .px-lg-1 {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
  }
`;
    
export const px_lg_2 = `
  @media (min-width: 992px) {
    .px-lg-2 {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
`;
    
export const px_lg_3 = `
  @media (min-width: 992px) {
    .px-lg-3 {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
`;
    
export const px_lg_4 = `
  @media (min-width: 992px) {
    .px-lg-4 {
      padding-left: 32px !important;
      padding-right: 32px !important;
    }
  }
`;
    
export const px_lg_5 = `
  @media (min-width: 992px) {
    .px-lg-5 {
      padding-left: 40px !important;
      padding-right: 40px !important;
    }
  }
`;
    
export const px_lg_6 = `
  @media (min-width: 992px) {
    .px-lg-6 {
      padding-left: 48px !important;
      padding-right: 48px !important;
    }
  }
`;
    
export const px_lg_7 = `
  @media (min-width: 992px) {
    .px-lg-7 {
      padding-left: 56px !important;
      padding-right: 56px !important;
    }
  }
`;
    
export const px_lg_8 = `
  @media (min-width: 992px) {
    .px-lg-8 {
      padding-left: 64px !important;
      padding-right: 64px !important;
    }
  }
`;
    
export const px_lg__1 = `
  @media (min-width: 992px) {
    .px-lg--1 {
      padding-left: -8px !important;
      padding-right: -8px !important;
    }
  }
`;
    
export const px_lg__2 = `
  @media (min-width: 992px) {
    .px-lg--2 {
      padding-left: -16px !important;
      padding-right: -16px !important;
    }
  }
`;
    
export const px_lg__3 = `
  @media (min-width: 992px) {
    .px-lg--3 {
      padding-left: -24px !important;
      padding-right: -24px !important;
    }
  }
`;
    
export const px_lg__4 = `
  @media (min-width: 992px) {
    .px-lg--4 {
      padding-left: -32px !important;
      padding-right: -32px !important;
    }
  }
`;
    
export const px_lg__5 = `
  @media (min-width: 992px) {
    .px-lg--5 {
      padding-left: -40px !important;
      padding-right: -40px !important;
    }
  }
`;
    
export const px_lg__6 = `
  @media (min-width: 992px) {
    .px-lg--6 {
      padding-left: -48px !important;
      padding-right: -48px !important;
    }
  }
`;
    
export const px_lg__7 = `
  @media (min-width: 992px) {
    .px-lg--7 {
      padding-left: -56px !important;
      padding-right: -56px !important;
    }
  }
`;
    
export const px_lg__8 = `
  @media (min-width: 992px) {
    .px-lg--8 {
      padding-left: -64px !important;
      padding-right: -64px !important;
    }
  }
`;
    
export const px_lg_initial = `
  @media (min-width: 992px) {
    .px-lg-initial {
      padding-left: initial !important;
      padding-right: initial !important;
    }
  }
`;
    
export const px_md_0 = `
  @media (min-width: 768px) {
    .px-md-0 {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
`;
    
export const px_md_1 = `
  @media (min-width: 768px) {
    .px-md-1 {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
  }
`;
    
export const px_md_2 = `
  @media (min-width: 768px) {
    .px-md-2 {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
`;
    
export const px_md_3 = `
  @media (min-width: 768px) {
    .px-md-3 {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
`;
    
export const px_md_4 = `
  @media (min-width: 768px) {
    .px-md-4 {
      padding-left: 32px !important;
      padding-right: 32px !important;
    }
  }
`;
    
export const px_md_5 = `
  @media (min-width: 768px) {
    .px-md-5 {
      padding-left: 40px !important;
      padding-right: 40px !important;
    }
  }
`;
    
export const px_md_6 = `
  @media (min-width: 768px) {
    .px-md-6 {
      padding-left: 48px !important;
      padding-right: 48px !important;
    }
  }
`;
    
export const px_md_7 = `
  @media (min-width: 768px) {
    .px-md-7 {
      padding-left: 56px !important;
      padding-right: 56px !important;
    }
  }
`;
    
export const px_md_8 = `
  @media (min-width: 768px) {
    .px-md-8 {
      padding-left: 64px !important;
      padding-right: 64px !important;
    }
  }
`;
    
export const px_md__1 = `
  @media (min-width: 768px) {
    .px-md--1 {
      padding-left: -8px !important;
      padding-right: -8px !important;
    }
  }
`;
    
export const px_md__2 = `
  @media (min-width: 768px) {
    .px-md--2 {
      padding-left: -16px !important;
      padding-right: -16px !important;
    }
  }
`;
    
export const px_md__3 = `
  @media (min-width: 768px) {
    .px-md--3 {
      padding-left: -24px !important;
      padding-right: -24px !important;
    }
  }
`;
    
export const px_md__4 = `
  @media (min-width: 768px) {
    .px-md--4 {
      padding-left: -32px !important;
      padding-right: -32px !important;
    }
  }
`;
    
export const px_md__5 = `
  @media (min-width: 768px) {
    .px-md--5 {
      padding-left: -40px !important;
      padding-right: -40px !important;
    }
  }
`;
    
export const px_md__6 = `
  @media (min-width: 768px) {
    .px-md--6 {
      padding-left: -48px !important;
      padding-right: -48px !important;
    }
  }
`;
    
export const px_md__7 = `
  @media (min-width: 768px) {
    .px-md--7 {
      padding-left: -56px !important;
      padding-right: -56px !important;
    }
  }
`;
    
export const px_md__8 = `
  @media (min-width: 768px) {
    .px-md--8 {
      padding-left: -64px !important;
      padding-right: -64px !important;
    }
  }
`;
    
export const px_md_initial = `
  @media (min-width: 768px) {
    .px-md-initial {
      padding-left: initial !important;
      padding-right: initial !important;
    }
  }
`;
    
export const px_sm_0 = `
  @media (min-width: 576px) {
    .px-sm-0 {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
`;
    
export const px_sm_1 = `
  @media (min-width: 576px) {
    .px-sm-1 {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
  }
`;
    
export const px_sm_2 = `
  @media (min-width: 576px) {
    .px-sm-2 {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
`;
    
export const px_sm_3 = `
  @media (min-width: 576px) {
    .px-sm-3 {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
`;
    
export const px_sm_4 = `
  @media (min-width: 576px) {
    .px-sm-4 {
      padding-left: 32px !important;
      padding-right: 32px !important;
    }
  }
`;
    
export const px_sm_5 = `
  @media (min-width: 576px) {
    .px-sm-5 {
      padding-left: 40px !important;
      padding-right: 40px !important;
    }
  }
`;
    
export const px_sm_6 = `
  @media (min-width: 576px) {
    .px-sm-6 {
      padding-left: 48px !important;
      padding-right: 48px !important;
    }
  }
`;
    
export const px_sm_7 = `
  @media (min-width: 576px) {
    .px-sm-7 {
      padding-left: 56px !important;
      padding-right: 56px !important;
    }
  }
`;
    
export const px_sm_8 = `
  @media (min-width: 576px) {
    .px-sm-8 {
      padding-left: 64px !important;
      padding-right: 64px !important;
    }
  }
`;
    
export const px_sm__1 = `
  @media (min-width: 576px) {
    .px-sm--1 {
      padding-left: -8px !important;
      padding-right: -8px !important;
    }
  }
`;
    
export const px_sm__2 = `
  @media (min-width: 576px) {
    .px-sm--2 {
      padding-left: -16px !important;
      padding-right: -16px !important;
    }
  }
`;
    
export const px_sm__3 = `
  @media (min-width: 576px) {
    .px-sm--3 {
      padding-left: -24px !important;
      padding-right: -24px !important;
    }
  }
`;
    
export const px_sm__4 = `
  @media (min-width: 576px) {
    .px-sm--4 {
      padding-left: -32px !important;
      padding-right: -32px !important;
    }
  }
`;
    
export const px_sm__5 = `
  @media (min-width: 576px) {
    .px-sm--5 {
      padding-left: -40px !important;
      padding-right: -40px !important;
    }
  }
`;
    
export const px_sm__6 = `
  @media (min-width: 576px) {
    .px-sm--6 {
      padding-left: -48px !important;
      padding-right: -48px !important;
    }
  }
`;
    
export const px_sm__7 = `
  @media (min-width: 576px) {
    .px-sm--7 {
      padding-left: -56px !important;
      padding-right: -56px !important;
    }
  }
`;
    
export const px_sm__8 = `
  @media (min-width: 576px) {
    .px-sm--8 {
      padding-left: -64px !important;
      padding-right: -64px !important;
    }
  }
`;
    
export const px_sm_initial = `
  @media (min-width: 576px) {
    .px-sm-initial {
      padding-left: initial !important;
      padding-right: initial !important;
    }
  }
`;
    
export const px_xl_0 = `
  @media (min-width: 1320px) {
    .px-xl-0 {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
`;
    
export const px_xl_1 = `
  @media (min-width: 1320px) {
    .px-xl-1 {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
  }
`;
    
export const px_xl_2 = `
  @media (min-width: 1320px) {
    .px-xl-2 {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }
`;
    
export const px_xl_3 = `
  @media (min-width: 1320px) {
    .px-xl-3 {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
`;
    
export const px_xl_4 = `
  @media (min-width: 1320px) {
    .px-xl-4 {
      padding-left: 32px !important;
      padding-right: 32px !important;
    }
  }
`;
    
export const px_xl_5 = `
  @media (min-width: 1320px) {
    .px-xl-5 {
      padding-left: 40px !important;
      padding-right: 40px !important;
    }
  }
`;
    
export const px_xl_6 = `
  @media (min-width: 1320px) {
    .px-xl-6 {
      padding-left: 48px !important;
      padding-right: 48px !important;
    }
  }
`;
    
export const px_xl_7 = `
  @media (min-width: 1320px) {
    .px-xl-7 {
      padding-left: 56px !important;
      padding-right: 56px !important;
    }
  }
`;
    
export const px_xl_8 = `
  @media (min-width: 1320px) {
    .px-xl-8 {
      padding-left: 64px !important;
      padding-right: 64px !important;
    }
  }
`;
    
export const px_xl__1 = `
  @media (min-width: 1320px) {
    .px-xl--1 {
      padding-left: -8px !important;
      padding-right: -8px !important;
    }
  }
`;
    
export const px_xl__2 = `
  @media (min-width: 1320px) {
    .px-xl--2 {
      padding-left: -16px !important;
      padding-right: -16px !important;
    }
  }
`;
    
export const px_xl__3 = `
  @media (min-width: 1320px) {
    .px-xl--3 {
      padding-left: -24px !important;
      padding-right: -24px !important;
    }
  }
`;
    
export const px_xl__4 = `
  @media (min-width: 1320px) {
    .px-xl--4 {
      padding-left: -32px !important;
      padding-right: -32px !important;
    }
  }
`;
    
export const px_xl__5 = `
  @media (min-width: 1320px) {
    .px-xl--5 {
      padding-left: -40px !important;
      padding-right: -40px !important;
    }
  }
`;
    
export const px_xl__6 = `
  @media (min-width: 1320px) {
    .px-xl--6 {
      padding-left: -48px !important;
      padding-right: -48px !important;
    }
  }
`;
    
export const px_xl__7 = `
  @media (min-width: 1320px) {
    .px-xl--7 {
      padding-left: -56px !important;
      padding-right: -56px !important;
    }
  }
`;
    
export const px_xl__8 = `
  @media (min-width: 1320px) {
    .px-xl--8 {
      padding-left: -64px !important;
      padding-right: -64px !important;
    }
  }
`;
    
export const px_xl_initial = `
  @media (min-width: 1320px) {
    .px-xl-initial {
      padding-left: initial !important;
      padding-right: initial !important;
    }
  }
`;
    
export const py_0 = `
  .py-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
`;
    
export const py_1 = `
  .py-1 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
`;
    
export const py_2 = `
  .py-2 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
`;
    
export const py_3 = `
  .py-3 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
`;
    
export const py_4 = `
  .py-4 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
`;
    
export const py_5 = `
  .py-5 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
`;
    
export const py_6 = `
  .py-6 {
    padding-top: 48px !important;
    padding-bottom: 48px !important;
  }
`;
    
export const py_7 = `
  .py-7 {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }
`;
    
export const py_8 = `
  .py-8 {
    padding-top: 64px !important;
    padding-bottom: 64px !important;
  }
`;
    
export const py__1 = `
  .py--1 {
    padding-top: -8px !important;
    padding-bottom: -8px !important;
  }
`;
    
export const py__2 = `
  .py--2 {
    padding-top: -16px !important;
    padding-bottom: -16px !important;
  }
`;
    
export const py__3 = `
  .py--3 {
    padding-top: -24px !important;
    padding-bottom: -24px !important;
  }
`;
    
export const py__4 = `
  .py--4 {
    padding-top: -32px !important;
    padding-bottom: -32px !important;
  }
`;
    
export const py__5 = `
  .py--5 {
    padding-top: -40px !important;
    padding-bottom: -40px !important;
  }
`;
    
export const py__6 = `
  .py--6 {
    padding-top: -48px !important;
    padding-bottom: -48px !important;
  }
`;
    
export const py__7 = `
  .py--7 {
    padding-top: -56px !important;
    padding-bottom: -56px !important;
  }
`;
    
export const py__8 = `
  .py--8 {
    padding-top: -64px !important;
    padding-bottom: -64px !important;
  }
`;
    
export const py_initial = `
  .py-initial {
    padding-top: initial !important;
    padding-bottom: initial !important;
  }
`;
    
export const py_lg_0 = `
  @media (min-width: 992px) {
    .py-lg-0 {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  }
`;
    
export const py_lg_1 = `
  @media (min-width: 992px) {
    .py-lg-1 {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
  }
`;
    
export const py_lg_2 = `
  @media (min-width: 992px) {
    .py-lg-2 {
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }
  }
`;
    
export const py_lg_3 = `
  @media (min-width: 992px) {
    .py-lg-3 {
      padding-top: 24px !important;
      padding-bottom: 24px !important;
    }
  }
`;
    
export const py_lg_4 = `
  @media (min-width: 992px) {
    .py-lg-4 {
      padding-top: 32px !important;
      padding-bottom: 32px !important;
    }
  }
`;
    
export const py_lg_5 = `
  @media (min-width: 992px) {
    .py-lg-5 {
      padding-top: 40px !important;
      padding-bottom: 40px !important;
    }
  }
`;
    
export const py_lg_6 = `
  @media (min-width: 992px) {
    .py-lg-6 {
      padding-top: 48px !important;
      padding-bottom: 48px !important;
    }
  }
`;
    
export const py_lg_7 = `
  @media (min-width: 992px) {
    .py-lg-7 {
      padding-top: 56px !important;
      padding-bottom: 56px !important;
    }
  }
`;
    
export const py_lg_8 = `
  @media (min-width: 992px) {
    .py-lg-8 {
      padding-top: 64px !important;
      padding-bottom: 64px !important;
    }
  }
`;
    
export const py_lg__1 = `
  @media (min-width: 992px) {
    .py-lg--1 {
      padding-top: -8px !important;
      padding-bottom: -8px !important;
    }
  }
`;
    
export const py_lg__2 = `
  @media (min-width: 992px) {
    .py-lg--2 {
      padding-top: -16px !important;
      padding-bottom: -16px !important;
    }
  }
`;
    
export const py_lg__3 = `
  @media (min-width: 992px) {
    .py-lg--3 {
      padding-top: -24px !important;
      padding-bottom: -24px !important;
    }
  }
`;
    
export const py_lg__4 = `
  @media (min-width: 992px) {
    .py-lg--4 {
      padding-top: -32px !important;
      padding-bottom: -32px !important;
    }
  }
`;
    
export const py_lg__5 = `
  @media (min-width: 992px) {
    .py-lg--5 {
      padding-top: -40px !important;
      padding-bottom: -40px !important;
    }
  }
`;
    
export const py_lg__6 = `
  @media (min-width: 992px) {
    .py-lg--6 {
      padding-top: -48px !important;
      padding-bottom: -48px !important;
    }
  }
`;
    
export const py_lg__7 = `
  @media (min-width: 992px) {
    .py-lg--7 {
      padding-top: -56px !important;
      padding-bottom: -56px !important;
    }
  }
`;
    
export const py_lg__8 = `
  @media (min-width: 992px) {
    .py-lg--8 {
      padding-top: -64px !important;
      padding-bottom: -64px !important;
    }
  }
`;
    
export const py_lg_initial = `
  @media (min-width: 992px) {
    .py-lg-initial {
      padding-top: initial !important;
      padding-bottom: initial !important;
    }
  }
`;
    
export const py_md_0 = `
  @media (min-width: 768px) {
    .py-md-0 {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  }
`;
    
export const py_md_1 = `
  @media (min-width: 768px) {
    .py-md-1 {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
  }
`;
    
export const py_md_2 = `
  @media (min-width: 768px) {
    .py-md-2 {
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }
  }
`;
    
export const py_md_3 = `
  @media (min-width: 768px) {
    .py-md-3 {
      padding-top: 24px !important;
      padding-bottom: 24px !important;
    }
  }
`;
    
export const py_md_4 = `
  @media (min-width: 768px) {
    .py-md-4 {
      padding-top: 32px !important;
      padding-bottom: 32px !important;
    }
  }
`;
    
export const py_md_5 = `
  @media (min-width: 768px) {
    .py-md-5 {
      padding-top: 40px !important;
      padding-bottom: 40px !important;
    }
  }
`;
    
export const py_md_6 = `
  @media (min-width: 768px) {
    .py-md-6 {
      padding-top: 48px !important;
      padding-bottom: 48px !important;
    }
  }
`;
    
export const py_md_7 = `
  @media (min-width: 768px) {
    .py-md-7 {
      padding-top: 56px !important;
      padding-bottom: 56px !important;
    }
  }
`;
    
export const py_md_8 = `
  @media (min-width: 768px) {
    .py-md-8 {
      padding-top: 64px !important;
      padding-bottom: 64px !important;
    }
  }
`;
    
export const py_md__1 = `
  @media (min-width: 768px) {
    .py-md--1 {
      padding-top: -8px !important;
      padding-bottom: -8px !important;
    }
  }
`;
    
export const py_md__2 = `
  @media (min-width: 768px) {
    .py-md--2 {
      padding-top: -16px !important;
      padding-bottom: -16px !important;
    }
  }
`;
    
export const py_md__3 = `
  @media (min-width: 768px) {
    .py-md--3 {
      padding-top: -24px !important;
      padding-bottom: -24px !important;
    }
  }
`;
    
export const py_md__4 = `
  @media (min-width: 768px) {
    .py-md--4 {
      padding-top: -32px !important;
      padding-bottom: -32px !important;
    }
  }
`;
    
export const py_md__5 = `
  @media (min-width: 768px) {
    .py-md--5 {
      padding-top: -40px !important;
      padding-bottom: -40px !important;
    }
  }
`;
    
export const py_md__6 = `
  @media (min-width: 768px) {
    .py-md--6 {
      padding-top: -48px !important;
      padding-bottom: -48px !important;
    }
  }
`;
    
export const py_md__7 = `
  @media (min-width: 768px) {
    .py-md--7 {
      padding-top: -56px !important;
      padding-bottom: -56px !important;
    }
  }
`;
    
export const py_md__8 = `
  @media (min-width: 768px) {
    .py-md--8 {
      padding-top: -64px !important;
      padding-bottom: -64px !important;
    }
  }
`;
    
export const py_md_initial = `
  @media (min-width: 768px) {
    .py-md-initial {
      padding-top: initial !important;
      padding-bottom: initial !important;
    }
  }
`;
    
export const py_sm_0 = `
  @media (min-width: 576px) {
    .py-sm-0 {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  }
`;
    
export const py_sm_1 = `
  @media (min-width: 576px) {
    .py-sm-1 {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
  }
`;
    
export const py_sm_2 = `
  @media (min-width: 576px) {
    .py-sm-2 {
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }
  }
`;
    
export const py_sm_3 = `
  @media (min-width: 576px) {
    .py-sm-3 {
      padding-top: 24px !important;
      padding-bottom: 24px !important;
    }
  }
`;
    
export const py_sm_4 = `
  @media (min-width: 576px) {
    .py-sm-4 {
      padding-top: 32px !important;
      padding-bottom: 32px !important;
    }
  }
`;
    
export const py_sm_5 = `
  @media (min-width: 576px) {
    .py-sm-5 {
      padding-top: 40px !important;
      padding-bottom: 40px !important;
    }
  }
`;
    
export const py_sm_6 = `
  @media (min-width: 576px) {
    .py-sm-6 {
      padding-top: 48px !important;
      padding-bottom: 48px !important;
    }
  }
`;
    
export const py_sm_7 = `
  @media (min-width: 576px) {
    .py-sm-7 {
      padding-top: 56px !important;
      padding-bottom: 56px !important;
    }
  }
`;
    
export const py_sm_8 = `
  @media (min-width: 576px) {
    .py-sm-8 {
      padding-top: 64px !important;
      padding-bottom: 64px !important;
    }
  }
`;
    
export const py_sm__1 = `
  @media (min-width: 576px) {
    .py-sm--1 {
      padding-top: -8px !important;
      padding-bottom: -8px !important;
    }
  }
`;
    
export const py_sm__2 = `
  @media (min-width: 576px) {
    .py-sm--2 {
      padding-top: -16px !important;
      padding-bottom: -16px !important;
    }
  }
`;
    
export const py_sm__3 = `
  @media (min-width: 576px) {
    .py-sm--3 {
      padding-top: -24px !important;
      padding-bottom: -24px !important;
    }
  }
`;
    
export const py_sm__4 = `
  @media (min-width: 576px) {
    .py-sm--4 {
      padding-top: -32px !important;
      padding-bottom: -32px !important;
    }
  }
`;
    
export const py_sm__5 = `
  @media (min-width: 576px) {
    .py-sm--5 {
      padding-top: -40px !important;
      padding-bottom: -40px !important;
    }
  }
`;
    
export const py_sm__6 = `
  @media (min-width: 576px) {
    .py-sm--6 {
      padding-top: -48px !important;
      padding-bottom: -48px !important;
    }
  }
`;
    
export const py_sm__7 = `
  @media (min-width: 576px) {
    .py-sm--7 {
      padding-top: -56px !important;
      padding-bottom: -56px !important;
    }
  }
`;
    
export const py_sm__8 = `
  @media (min-width: 576px) {
    .py-sm--8 {
      padding-top: -64px !important;
      padding-bottom: -64px !important;
    }
  }
`;
    
export const py_sm_initial = `
  @media (min-width: 576px) {
    .py-sm-initial {
      padding-top: initial !important;
      padding-bottom: initial !important;
    }
  }
`;
    
export const py_xl_0 = `
  @media (min-width: 1320px) {
    .py-xl-0 {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  }
`;
    
export const py_xl_1 = `
  @media (min-width: 1320px) {
    .py-xl-1 {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
  }
`;
    
export const py_xl_2 = `
  @media (min-width: 1320px) {
    .py-xl-2 {
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }
  }
`;
    
export const py_xl_3 = `
  @media (min-width: 1320px) {
    .py-xl-3 {
      padding-top: 24px !important;
      padding-bottom: 24px !important;
    }
  }
`;
    
export const py_xl_4 = `
  @media (min-width: 1320px) {
    .py-xl-4 {
      padding-top: 32px !important;
      padding-bottom: 32px !important;
    }
  }
`;
    
export const py_xl_5 = `
  @media (min-width: 1320px) {
    .py-xl-5 {
      padding-top: 40px !important;
      padding-bottom: 40px !important;
    }
  }
`;
    
export const py_xl_6 = `
  @media (min-width: 1320px) {
    .py-xl-6 {
      padding-top: 48px !important;
      padding-bottom: 48px !important;
    }
  }
`;
    
export const py_xl_7 = `
  @media (min-width: 1320px) {
    .py-xl-7 {
      padding-top: 56px !important;
      padding-bottom: 56px !important;
    }
  }
`;
    
export const py_xl_8 = `
  @media (min-width: 1320px) {
    .py-xl-8 {
      padding-top: 64px !important;
      padding-bottom: 64px !important;
    }
  }
`;
    
export const py_xl__1 = `
  @media (min-width: 1320px) {
    .py-xl--1 {
      padding-top: -8px !important;
      padding-bottom: -8px !important;
    }
  }
`;
    
export const py_xl__2 = `
  @media (min-width: 1320px) {
    .py-xl--2 {
      padding-top: -16px !important;
      padding-bottom: -16px !important;
    }
  }
`;
    
export const py_xl__3 = `
  @media (min-width: 1320px) {
    .py-xl--3 {
      padding-top: -24px !important;
      padding-bottom: -24px !important;
    }
  }
`;
    
export const py_xl__4 = `
  @media (min-width: 1320px) {
    .py-xl--4 {
      padding-top: -32px !important;
      padding-bottom: -32px !important;
    }
  }
`;
    
export const py_xl__5 = `
  @media (min-width: 1320px) {
    .py-xl--5 {
      padding-top: -40px !important;
      padding-bottom: -40px !important;
    }
  }
`;
    
export const py_xl__6 = `
  @media (min-width: 1320px) {
    .py-xl--6 {
      padding-top: -48px !important;
      padding-bottom: -48px !important;
    }
  }
`;
    
export const py_xl__7 = `
  @media (min-width: 1320px) {
    .py-xl--7 {
      padding-top: -56px !important;
      padding-bottom: -56px !important;
    }
  }
`;
    
export const py_xl__8 = `
  @media (min-width: 1320px) {
    .py-xl--8 {
      padding-top: -64px !important;
      padding-bottom: -64px !important;
    }
  }
`;
    
export const py_xl_initial = `
  @media (min-width: 1320px) {
    .py-xl-initial {
      padding-top: initial !important;
      padding-bottom: initial !important;
    }
  }
`;
    
export const sp_1 = `
  .sp-1 {
    padding: 4px !important;
  }
`;
    
export const sp_2 = `
  .sp-2 {
    padding: 12px !important;
  }
`;
    
export const sp_3 = `
  .sp-3 {
    padding: 20px !important;
  }
`;
    
export const sp__1 = `
  .sp--1 {
    padding: -4px !important;
  }
`;
    
export const sp__2 = `
  .sp--2 {
    padding: -12px !important;
  }
`;
    
export const sp__3 = `
  .sp--3 {
    padding: -20px !important;
  }
`;
    
export const sp_lg_1 = `
  @media (min-width: 992px) {
    .sp-lg-1 {
      padding: 4px !important;
    }
  }
`;
    
export const sp_lg_2 = `
  @media (min-width: 992px) {
    .sp-lg-2 {
      padding: 12px !important;
    }
  }
`;
    
export const sp_lg_3 = `
  @media (min-width: 992px) {
    .sp-lg-3 {
      padding: 20px !important;
    }
  }
`;
    
export const sp_lg__1 = `
  @media (min-width: 992px) {
    .sp-lg--1 {
      padding: -4px !important;
    }
  }
`;
    
export const sp_lg__2 = `
  @media (min-width: 992px) {
    .sp-lg--2 {
      padding: -12px !important;
    }
  }
`;
    
export const sp_lg__3 = `
  @media (min-width: 992px) {
    .sp-lg--3 {
      padding: -20px !important;
    }
  }
`;
    
export const sp_md_1 = `
  @media (min-width: 768px) {
    .sp-md-1 {
      padding: 4px !important;
    }
  }
`;
    
export const sp_md_2 = `
  @media (min-width: 768px) {
    .sp-md-2 {
      padding: 12px !important;
    }
  }
`;
    
export const sp_md_3 = `
  @media (min-width: 768px) {
    .sp-md-3 {
      padding: 20px !important;
    }
  }
`;
    
export const sp_md__1 = `
  @media (min-width: 768px) {
    .sp-md--1 {
      padding: -4px !important;
    }
  }
`;
    
export const sp_md__2 = `
  @media (min-width: 768px) {
    .sp-md--2 {
      padding: -12px !important;
    }
  }
`;
    
export const sp_md__3 = `
  @media (min-width: 768px) {
    .sp-md--3 {
      padding: -20px !important;
    }
  }
`;
    
export const sp_sm_1 = `
  @media (min-width: 576px) {
    .sp-sm-1 {
      padding: 4px !important;
    }
  }
`;
    
export const sp_sm_2 = `
  @media (min-width: 576px) {
    .sp-sm-2 {
      padding: 12px !important;
    }
  }
`;
    
export const sp_sm_3 = `
  @media (min-width: 576px) {
    .sp-sm-3 {
      padding: 20px !important;
    }
  }
`;
    
export const sp_sm__1 = `
  @media (min-width: 576px) {
    .sp-sm--1 {
      padding: -4px !important;
    }
  }
`;
    
export const sp_sm__2 = `
  @media (min-width: 576px) {
    .sp-sm--2 {
      padding: -12px !important;
    }
  }
`;
    
export const sp_sm__3 = `
  @media (min-width: 576px) {
    .sp-sm--3 {
      padding: -20px !important;
    }
  }
`;
    
export const sp_xl_1 = `
  @media (min-width: 1320px) {
    .sp-xl-1 {
      padding: 4px !important;
    }
  }
`;
    
export const sp_xl_2 = `
  @media (min-width: 1320px) {
    .sp-xl-2 {
      padding: 12px !important;
    }
  }
`;
    
export const sp_xl_3 = `
  @media (min-width: 1320px) {
    .sp-xl-3 {
      padding: 20px !important;
    }
  }
`;
    
export const sp_xl__1 = `
  @media (min-width: 1320px) {
    .sp-xl--1 {
      padding: -4px !important;
    }
  }
`;
    
export const sp_xl__2 = `
  @media (min-width: 1320px) {
    .sp-xl--2 {
      padding: -12px !important;
    }
  }
`;
    
export const sp_xl__3 = `
  @media (min-width: 1320px) {
    .sp-xl--3 {
      padding: -20px !important;
    }
  }
`;
    
export const spb_1 = `
  .spb-1 {
    padding-bottom: 4px !important;
  }
`;
    
export const spb_2 = `
  .spb-2 {
    padding-bottom: 12px !important;
  }
`;
    
export const spb_3 = `
  .spb-3 {
    padding-bottom: 20px !important;
  }
`;
    
export const spb__1 = `
  .spb--1 {
    padding-bottom: -4px !important;
  }
`;
    
export const spb__2 = `
  .spb--2 {
    padding-bottom: -12px !important;
  }
`;
    
export const spb__3 = `
  .spb--3 {
    padding-bottom: -20px !important;
  }
`;
    
export const spb_lg_1 = `
  @media (min-width: 992px) {
    .spb-lg-1 {
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spb_lg_2 = `
  @media (min-width: 992px) {
    .spb-lg-2 {
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spb_lg_3 = `
  @media (min-width: 992px) {
    .spb-lg-3 {
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spb_lg__1 = `
  @media (min-width: 992px) {
    .spb-lg--1 {
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spb_lg__2 = `
  @media (min-width: 992px) {
    .spb-lg--2 {
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spb_lg__3 = `
  @media (min-width: 992px) {
    .spb-lg--3 {
      padding-bottom: -20px !important;
    }
  }
`;
    
export const spb_md_1 = `
  @media (min-width: 768px) {
    .spb-md-1 {
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spb_md_2 = `
  @media (min-width: 768px) {
    .spb-md-2 {
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spb_md_3 = `
  @media (min-width: 768px) {
    .spb-md-3 {
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spb_md__1 = `
  @media (min-width: 768px) {
    .spb-md--1 {
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spb_md__2 = `
  @media (min-width: 768px) {
    .spb-md--2 {
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spb_md__3 = `
  @media (min-width: 768px) {
    .spb-md--3 {
      padding-bottom: -20px !important;
    }
  }
`;
    
export const spb_sm_1 = `
  @media (min-width: 576px) {
    .spb-sm-1 {
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spb_sm_2 = `
  @media (min-width: 576px) {
    .spb-sm-2 {
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spb_sm_3 = `
  @media (min-width: 576px) {
    .spb-sm-3 {
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spb_sm__1 = `
  @media (min-width: 576px) {
    .spb-sm--1 {
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spb_sm__2 = `
  @media (min-width: 576px) {
    .spb-sm--2 {
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spb_sm__3 = `
  @media (min-width: 576px) {
    .spb-sm--3 {
      padding-bottom: -20px !important;
    }
  }
`;
    
export const spb_xl_1 = `
  @media (min-width: 1320px) {
    .spb-xl-1 {
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spb_xl_2 = `
  @media (min-width: 1320px) {
    .spb-xl-2 {
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spb_xl_3 = `
  @media (min-width: 1320px) {
    .spb-xl-3 {
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spb_xl__1 = `
  @media (min-width: 1320px) {
    .spb-xl--1 {
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spb_xl__2 = `
  @media (min-width: 1320px) {
    .spb-xl--2 {
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spb_xl__3 = `
  @media (min-width: 1320px) {
    .spb-xl--3 {
      padding-bottom: -20px !important;
    }
  }
`;
    
export const spl_1 = `
  .spl-1 {
    padding-left: 4px !important;
  }
`;
    
export const spl_2 = `
  .spl-2 {
    padding-left: 12px !important;
  }
`;
    
export const spl_3 = `
  .spl-3 {
    padding-left: 20px !important;
  }
`;
    
export const spl__1 = `
  .spl--1 {
    padding-left: -4px !important;
  }
`;
    
export const spl__2 = `
  .spl--2 {
    padding-left: -12px !important;
  }
`;
    
export const spl__3 = `
  .spl--3 {
    padding-left: -20px !important;
  }
`;
    
export const spl_lg_1 = `
  @media (min-width: 992px) {
    .spl-lg-1 {
      padding-left: 4px !important;
    }
  }
`;
    
export const spl_lg_2 = `
  @media (min-width: 992px) {
    .spl-lg-2 {
      padding-left: 12px !important;
    }
  }
`;
    
export const spl_lg_3 = `
  @media (min-width: 992px) {
    .spl-lg-3 {
      padding-left: 20px !important;
    }
  }
`;
    
export const spl_lg__1 = `
  @media (min-width: 992px) {
    .spl-lg--1 {
      padding-left: -4px !important;
    }
  }
`;
    
export const spl_lg__2 = `
  @media (min-width: 992px) {
    .spl-lg--2 {
      padding-left: -12px !important;
    }
  }
`;
    
export const spl_lg__3 = `
  @media (min-width: 992px) {
    .spl-lg--3 {
      padding-left: -20px !important;
    }
  }
`;
    
export const spl_md_1 = `
  @media (min-width: 768px) {
    .spl-md-1 {
      padding-left: 4px !important;
    }
  }
`;
    
export const spl_md_2 = `
  @media (min-width: 768px) {
    .spl-md-2 {
      padding-left: 12px !important;
    }
  }
`;
    
export const spl_md_3 = `
  @media (min-width: 768px) {
    .spl-md-3 {
      padding-left: 20px !important;
    }
  }
`;
    
export const spl_md__1 = `
  @media (min-width: 768px) {
    .spl-md--1 {
      padding-left: -4px !important;
    }
  }
`;
    
export const spl_md__2 = `
  @media (min-width: 768px) {
    .spl-md--2 {
      padding-left: -12px !important;
    }
  }
`;
    
export const spl_md__3 = `
  @media (min-width: 768px) {
    .spl-md--3 {
      padding-left: -20px !important;
    }
  }
`;
    
export const spl_sm_1 = `
  @media (min-width: 576px) {
    .spl-sm-1 {
      padding-left: 4px !important;
    }
  }
`;
    
export const spl_sm_2 = `
  @media (min-width: 576px) {
    .spl-sm-2 {
      padding-left: 12px !important;
    }
  }
`;
    
export const spl_sm_3 = `
  @media (min-width: 576px) {
    .spl-sm-3 {
      padding-left: 20px !important;
    }
  }
`;
    
export const spl_sm__1 = `
  @media (min-width: 576px) {
    .spl-sm--1 {
      padding-left: -4px !important;
    }
  }
`;
    
export const spl_sm__2 = `
  @media (min-width: 576px) {
    .spl-sm--2 {
      padding-left: -12px !important;
    }
  }
`;
    
export const spl_sm__3 = `
  @media (min-width: 576px) {
    .spl-sm--3 {
      padding-left: -20px !important;
    }
  }
`;
    
export const spl_xl_1 = `
  @media (min-width: 1320px) {
    .spl-xl-1 {
      padding-left: 4px !important;
    }
  }
`;
    
export const spl_xl_2 = `
  @media (min-width: 1320px) {
    .spl-xl-2 {
      padding-left: 12px !important;
    }
  }
`;
    
export const spl_xl_3 = `
  @media (min-width: 1320px) {
    .spl-xl-3 {
      padding-left: 20px !important;
    }
  }
`;
    
export const spl_xl__1 = `
  @media (min-width: 1320px) {
    .spl-xl--1 {
      padding-left: -4px !important;
    }
  }
`;
    
export const spl_xl__2 = `
  @media (min-width: 1320px) {
    .spl-xl--2 {
      padding-left: -12px !important;
    }
  }
`;
    
export const spl_xl__3 = `
  @media (min-width: 1320px) {
    .spl-xl--3 {
      padding-left: -20px !important;
    }
  }
`;
    
export const spr_1 = `
  .spr-1 {
    padding-right: 4px !important;
  }
`;
    
export const spr_2 = `
  .spr-2 {
    padding-right: 12px !important;
  }
`;
    
export const spr_3 = `
  .spr-3 {
    padding-right: 20px !important;
  }
`;
    
export const spr__1 = `
  .spr--1 {
    padding-right: -4px !important;
  }
`;
    
export const spr__2 = `
  .spr--2 {
    padding-right: -12px !important;
  }
`;
    
export const spr__3 = `
  .spr--3 {
    padding-right: -20px !important;
  }
`;
    
export const spr_lg_1 = `
  @media (min-width: 992px) {
    .spr-lg-1 {
      padding-right: 4px !important;
    }
  }
`;
    
export const spr_lg_2 = `
  @media (min-width: 992px) {
    .spr-lg-2 {
      padding-right: 12px !important;
    }
  }
`;
    
export const spr_lg_3 = `
  @media (min-width: 992px) {
    .spr-lg-3 {
      padding-right: 20px !important;
    }
  }
`;
    
export const spr_lg__1 = `
  @media (min-width: 992px) {
    .spr-lg--1 {
      padding-right: -4px !important;
    }
  }
`;
    
export const spr_lg__2 = `
  @media (min-width: 992px) {
    .spr-lg--2 {
      padding-right: -12px !important;
    }
  }
`;
    
export const spr_lg__3 = `
  @media (min-width: 992px) {
    .spr-lg--3 {
      padding-right: -20px !important;
    }
  }
`;
    
export const spr_md_1 = `
  @media (min-width: 768px) {
    .spr-md-1 {
      padding-right: 4px !important;
    }
  }
`;
    
export const spr_md_2 = `
  @media (min-width: 768px) {
    .spr-md-2 {
      padding-right: 12px !important;
    }
  }
`;
    
export const spr_md_3 = `
  @media (min-width: 768px) {
    .spr-md-3 {
      padding-right: 20px !important;
    }
  }
`;
    
export const spr_md__1 = `
  @media (min-width: 768px) {
    .spr-md--1 {
      padding-right: -4px !important;
    }
  }
`;
    
export const spr_md__2 = `
  @media (min-width: 768px) {
    .spr-md--2 {
      padding-right: -12px !important;
    }
  }
`;
    
export const spr_md__3 = `
  @media (min-width: 768px) {
    .spr-md--3 {
      padding-right: -20px !important;
    }
  }
`;
    
export const spr_sm_1 = `
  @media (min-width: 576px) {
    .spr-sm-1 {
      padding-right: 4px !important;
    }
  }
`;
    
export const spr_sm_2 = `
  @media (min-width: 576px) {
    .spr-sm-2 {
      padding-right: 12px !important;
    }
  }
`;
    
export const spr_sm_3 = `
  @media (min-width: 576px) {
    .spr-sm-3 {
      padding-right: 20px !important;
    }
  }
`;
    
export const spr_sm__1 = `
  @media (min-width: 576px) {
    .spr-sm--1 {
      padding-right: -4px !important;
    }
  }
`;
    
export const spr_sm__2 = `
  @media (min-width: 576px) {
    .spr-sm--2 {
      padding-right: -12px !important;
    }
  }
`;
    
export const spr_sm__3 = `
  @media (min-width: 576px) {
    .spr-sm--3 {
      padding-right: -20px !important;
    }
  }
`;
    
export const spr_xl_1 = `
  @media (min-width: 1320px) {
    .spr-xl-1 {
      padding-right: 4px !important;
    }
  }
`;
    
export const spr_xl_2 = `
  @media (min-width: 1320px) {
    .spr-xl-2 {
      padding-right: 12px !important;
    }
  }
`;
    
export const spr_xl_3 = `
  @media (min-width: 1320px) {
    .spr-xl-3 {
      padding-right: 20px !important;
    }
  }
`;
    
export const spr_xl__1 = `
  @media (min-width: 1320px) {
    .spr-xl--1 {
      padding-right: -4px !important;
    }
  }
`;
    
export const spr_xl__2 = `
  @media (min-width: 1320px) {
    .spr-xl--2 {
      padding-right: -12px !important;
    }
  }
`;
    
export const spr_xl__3 = `
  @media (min-width: 1320px) {
    .spr-xl--3 {
      padding-right: -20px !important;
    }
  }
`;
    
export const spt_1 = `
  .spt-1 {
    padding-top: 4px !important;
  }
`;
    
export const spt_2 = `
  .spt-2 {
    padding-top: 12px !important;
  }
`;
    
export const spt_3 = `
  .spt-3 {
    padding-top: 20px !important;
  }
`;
    
export const spt__1 = `
  .spt--1 {
    padding-top: -4px !important;
  }
`;
    
export const spt__2 = `
  .spt--2 {
    padding-top: -12px !important;
  }
`;
    
export const spt__3 = `
  .spt--3 {
    padding-top: -20px !important;
  }
`;
    
export const spt_lg_1 = `
  @media (min-width: 992px) {
    .spt-lg-1 {
      padding-top: 4px !important;
    }
  }
`;
    
export const spt_lg_2 = `
  @media (min-width: 992px) {
    .spt-lg-2 {
      padding-top: 12px !important;
    }
  }
`;
    
export const spt_lg_3 = `
  @media (min-width: 992px) {
    .spt-lg-3 {
      padding-top: 20px !important;
    }
  }
`;
    
export const spt_lg__1 = `
  @media (min-width: 992px) {
    .spt-lg--1 {
      padding-top: -4px !important;
    }
  }
`;
    
export const spt_lg__2 = `
  @media (min-width: 992px) {
    .spt-lg--2 {
      padding-top: -12px !important;
    }
  }
`;
    
export const spt_lg__3 = `
  @media (min-width: 992px) {
    .spt-lg--3 {
      padding-top: -20px !important;
    }
  }
`;
    
export const spt_md_1 = `
  @media (min-width: 768px) {
    .spt-md-1 {
      padding-top: 4px !important;
    }
  }
`;
    
export const spt_md_2 = `
  @media (min-width: 768px) {
    .spt-md-2 {
      padding-top: 12px !important;
    }
  }
`;
    
export const spt_md_3 = `
  @media (min-width: 768px) {
    .spt-md-3 {
      padding-top: 20px !important;
    }
  }
`;
    
export const spt_md__1 = `
  @media (min-width: 768px) {
    .spt-md--1 {
      padding-top: -4px !important;
    }
  }
`;
    
export const spt_md__2 = `
  @media (min-width: 768px) {
    .spt-md--2 {
      padding-top: -12px !important;
    }
  }
`;
    
export const spt_md__3 = `
  @media (min-width: 768px) {
    .spt-md--3 {
      padding-top: -20px !important;
    }
  }
`;
    
export const spt_sm_1 = `
  @media (min-width: 576px) {
    .spt-sm-1 {
      padding-top: 4px !important;
    }
  }
`;
    
export const spt_sm_2 = `
  @media (min-width: 576px) {
    .spt-sm-2 {
      padding-top: 12px !important;
    }
  }
`;
    
export const spt_sm_3 = `
  @media (min-width: 576px) {
    .spt-sm-3 {
      padding-top: 20px !important;
    }
  }
`;
    
export const spt_sm__1 = `
  @media (min-width: 576px) {
    .spt-sm--1 {
      padding-top: -4px !important;
    }
  }
`;
    
export const spt_sm__2 = `
  @media (min-width: 576px) {
    .spt-sm--2 {
      padding-top: -12px !important;
    }
  }
`;
    
export const spt_sm__3 = `
  @media (min-width: 576px) {
    .spt-sm--3 {
      padding-top: -20px !important;
    }
  }
`;
    
export const spt_xl_1 = `
  @media (min-width: 1320px) {
    .spt-xl-1 {
      padding-top: 4px !important;
    }
  }
`;
    
export const spt_xl_2 = `
  @media (min-width: 1320px) {
    .spt-xl-2 {
      padding-top: 12px !important;
    }
  }
`;
    
export const spt_xl_3 = `
  @media (min-width: 1320px) {
    .spt-xl-3 {
      padding-top: 20px !important;
    }
  }
`;
    
export const spt_xl__1 = `
  @media (min-width: 1320px) {
    .spt-xl--1 {
      padding-top: -4px !important;
    }
  }
`;
    
export const spt_xl__2 = `
  @media (min-width: 1320px) {
    .spt-xl--2 {
      padding-top: -12px !important;
    }
  }
`;
    
export const spt_xl__3 = `
  @media (min-width: 1320px) {
    .spt-xl--3 {
      padding-top: -20px !important;
    }
  }
`;
    
export const spx_1 = `
  .spx-1 {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
`;
    
export const spx_2 = `
  .spx-2 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
`;
    
export const spx_3 = `
  .spx-3 {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
`;
    
export const spx__1 = `
  .spx--1 {
    padding-left: -4px !important;
    padding-right: -4px !important;
  }
`;
    
export const spx__2 = `
  .spx--2 {
    padding-left: -12px !important;
    padding-right: -12px !important;
  }
`;
    
export const spx__3 = `
  .spx--3 {
    padding-left: -20px !important;
    padding-right: -20px !important;
  }
`;
    
export const spx_lg_1 = `
  @media (min-width: 992px) {
    .spx-lg-1 {
      padding-left: 4px !important;
      padding-right: 4px !important;
    }
  }
`;
    
export const spx_lg_2 = `
  @media (min-width: 992px) {
    .spx-lg-2 {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }
`;
    
export const spx_lg_3 = `
  @media (min-width: 992px) {
    .spx-lg-3 {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
  }
`;
    
export const spx_lg__1 = `
  @media (min-width: 992px) {
    .spx-lg--1 {
      padding-left: -4px !important;
      padding-right: -4px !important;
    }
  }
`;
    
export const spx_lg__2 = `
  @media (min-width: 992px) {
    .spx-lg--2 {
      padding-left: -12px !important;
      padding-right: -12px !important;
    }
  }
`;
    
export const spx_lg__3 = `
  @media (min-width: 992px) {
    .spx-lg--3 {
      padding-left: -20px !important;
      padding-right: -20px !important;
    }
  }
`;
    
export const spx_md_1 = `
  @media (min-width: 768px) {
    .spx-md-1 {
      padding-left: 4px !important;
      padding-right: 4px !important;
    }
  }
`;
    
export const spx_md_2 = `
  @media (min-width: 768px) {
    .spx-md-2 {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }
`;
    
export const spx_md_3 = `
  @media (min-width: 768px) {
    .spx-md-3 {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
  }
`;
    
export const spx_md__1 = `
  @media (min-width: 768px) {
    .spx-md--1 {
      padding-left: -4px !important;
      padding-right: -4px !important;
    }
  }
`;
    
export const spx_md__2 = `
  @media (min-width: 768px) {
    .spx-md--2 {
      padding-left: -12px !important;
      padding-right: -12px !important;
    }
  }
`;
    
export const spx_md__3 = `
  @media (min-width: 768px) {
    .spx-md--3 {
      padding-left: -20px !important;
      padding-right: -20px !important;
    }
  }
`;
    
export const spx_sm_1 = `
  @media (min-width: 576px) {
    .spx-sm-1 {
      padding-left: 4px !important;
      padding-right: 4px !important;
    }
  }
`;
    
export const spx_sm_2 = `
  @media (min-width: 576px) {
    .spx-sm-2 {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }
`;
    
export const spx_sm_3 = `
  @media (min-width: 576px) {
    .spx-sm-3 {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
  }
`;
    
export const spx_sm__1 = `
  @media (min-width: 576px) {
    .spx-sm--1 {
      padding-left: -4px !important;
      padding-right: -4px !important;
    }
  }
`;
    
export const spx_sm__2 = `
  @media (min-width: 576px) {
    .spx-sm--2 {
      padding-left: -12px !important;
      padding-right: -12px !important;
    }
  }
`;
    
export const spx_sm__3 = `
  @media (min-width: 576px) {
    .spx-sm--3 {
      padding-left: -20px !important;
      padding-right: -20px !important;
    }
  }
`;
    
export const spx_xl_1 = `
  @media (min-width: 1320px) {
    .spx-xl-1 {
      padding-left: 4px !important;
      padding-right: 4px !important;
    }
  }
`;
    
export const spx_xl_2 = `
  @media (min-width: 1320px) {
    .spx-xl-2 {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
  }
`;
    
export const spx_xl_3 = `
  @media (min-width: 1320px) {
    .spx-xl-3 {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
  }
`;
    
export const spx_xl__1 = `
  @media (min-width: 1320px) {
    .spx-xl--1 {
      padding-left: -4px !important;
      padding-right: -4px !important;
    }
  }
`;
    
export const spx_xl__2 = `
  @media (min-width: 1320px) {
    .spx-xl--2 {
      padding-left: -12px !important;
      padding-right: -12px !important;
    }
  }
`;
    
export const spx_xl__3 = `
  @media (min-width: 1320px) {
    .spx-xl--3 {
      padding-left: -20px !important;
      padding-right: -20px !important;
    }
  }
`;
    
export const spy_1 = `
  .spy-1 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
`;
    
export const spy_2 = `
  .spy-2 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
`;
    
export const spy_3 = `
  .spy-3 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
`;
    
export const spy__1 = `
  .spy--1 {
    padding-top: -4px !important;
    padding-bottom: -4px !important;
  }
`;
    
export const spy__2 = `
  .spy--2 {
    padding-top: -12px !important;
    padding-bottom: -12px !important;
  }
`;
    
export const spy__3 = `
  .spy--3 {
    padding-top: -20px !important;
    padding-bottom: -20px !important;
  }
`;
    
export const spy_lg_1 = `
  @media (min-width: 992px) {
    .spy-lg-1 {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spy_lg_2 = `
  @media (min-width: 992px) {
    .spy-lg-2 {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spy_lg_3 = `
  @media (min-width: 992px) {
    .spy-lg-3 {
      padding-top: 20px !important;
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spy_lg__1 = `
  @media (min-width: 992px) {
    .spy-lg--1 {
      padding-top: -4px !important;
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spy_lg__2 = `
  @media (min-width: 992px) {
    .spy-lg--2 {
      padding-top: -12px !important;
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spy_lg__3 = `
  @media (min-width: 992px) {
    .spy-lg--3 {
      padding-top: -20px !important;
      padding-bottom: -20px !important;
    }
  }
`;
    
export const spy_md_1 = `
  @media (min-width: 768px) {
    .spy-md-1 {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spy_md_2 = `
  @media (min-width: 768px) {
    .spy-md-2 {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spy_md_3 = `
  @media (min-width: 768px) {
    .spy-md-3 {
      padding-top: 20px !important;
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spy_md__1 = `
  @media (min-width: 768px) {
    .spy-md--1 {
      padding-top: -4px !important;
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spy_md__2 = `
  @media (min-width: 768px) {
    .spy-md--2 {
      padding-top: -12px !important;
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spy_md__3 = `
  @media (min-width: 768px) {
    .spy-md--3 {
      padding-top: -20px !important;
      padding-bottom: -20px !important;
    }
  }
`;
    
export const spy_sm_1 = `
  @media (min-width: 576px) {
    .spy-sm-1 {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spy_sm_2 = `
  @media (min-width: 576px) {
    .spy-sm-2 {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spy_sm_3 = `
  @media (min-width: 576px) {
    .spy-sm-3 {
      padding-top: 20px !important;
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spy_sm__1 = `
  @media (min-width: 576px) {
    .spy-sm--1 {
      padding-top: -4px !important;
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spy_sm__2 = `
  @media (min-width: 576px) {
    .spy-sm--2 {
      padding-top: -12px !important;
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spy_sm__3 = `
  @media (min-width: 576px) {
    .spy-sm--3 {
      padding-top: -20px !important;
      padding-bottom: -20px !important;
    }
  }
`;
    
export const spy_xl_1 = `
  @media (min-width: 1320px) {
    .spy-xl-1 {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
  }
`;
    
export const spy_xl_2 = `
  @media (min-width: 1320px) {
    .spy-xl-2 {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }
  }
`;
    
export const spy_xl_3 = `
  @media (min-width: 1320px) {
    .spy-xl-3 {
      padding-top: 20px !important;
      padding-bottom: 20px !important;
    }
  }
`;
    
export const spy_xl__1 = `
  @media (min-width: 1320px) {
    .spy-xl--1 {
      padding-top: -4px !important;
      padding-bottom: -4px !important;
    }
  }
`;
    
export const spy_xl__2 = `
  @media (min-width: 1320px) {
    .spy-xl--2 {
      padding-top: -12px !important;
      padding-bottom: -12px !important;
    }
  }
`;
    
export const spy_xl__3 = `
  @media (min-width: 1320px) {
    .spy-xl--3 {
      padding-top: -20px !important;
      padding-bottom: -20px !important;
    }
  }
`;
    